// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0px 1000px rgba(0, 0, 0, 0) inset;
    transition: background-color 5000s ease-in-out 0s;
}

.v-card__title {
    word-break: initial !important;
}

.smaller-text {
    font-size: 80%;
}

.bigger-text {
    font-size: 120%;
}

#logo-image {
    max-height: 30px;
    vertical-align: middle;
    display: block;
}

.center-logo-image > img {
    display: block;
}

.profile-avatar {
    width: 3.125rem;
    height: 3.125rem;
}

form {
    max-width: 28.125rem;
    margin: 0 auto;
}

#welcome-back-title {
    font-size: 3rem;
    font-family: 'Omnes ExtraLight';
}

div.v-card__text,
span.v-btn__content {
    font-family: 'Omnes Regular', 'sans-serif' !important;
}

div.v-dialog__container
> div
> div
> div
> div.v-card__actions
> button.v-btn.v-btn--contained.theme--light.v-size--default.primary
> span {
    color: var(--sd-light-text-strong);
}

#welcome-back-description {
    font-size: 1.5rem;
    font-family: 'Omnes Light';
}

.add-username-field {
    width: 75% !important;
    max-width: 28.125rem;
    left: -5% !important;
    display: inline-block;
    margin: 0;
}

.add-username-btn {
    width: 21%;
    display: inline-block;
    max-width: 4.688rem;
}

.add-username-form {
    float: right;
    max-width: 28.125rem;
    width: 100%;
}

#loader-container {
    margin-top: 2.5rem;
}

.popupcollapse {
    border-left: 0 !important;
    border-right: 0 !important;
    margin-bottom: 0 !important;
    border-bottom-left-radius: 12px !important;
    border-bottom-right-radius: 12px !important;
    border-bottom: none !important;
}

.collapsible > li:last-child > div {
    border-bottom-left-radius: 12px !important;
    border-bottom-right-radius: 12px !important;
    border-bottom: none;
}

.collapsible > li.active:last-child > div {
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
    border-bottom: 1px solid var(--sd-light-border) !important;
}

.collapsible {
    box-shadow: none;
    -webkit-box-shadow: none;
}

.leaflet-popup-content.collapsible.active
+ .leaflet-popup-tip-container.leaflet-popup-tip {
    background-color: var(--sd-light-surface-muted);
}

#mapid
> div.leaflet-pane.leaflet-map-pane
> div.leaflet-pane.leaflet-popup-pane
> div
> div.leaflet-popup-content-wrapper
> div
> ul
> li:last-child
> div.active {
    border-bottom-left-radius: initial !important;
    border-bottom-right-radius: initial !important;
    border-bottom: 1px solid var(--sd-light-border) !important;
}

#mapid
> div.leaflet-pane.leaflet-map-pane
> div.leaflet-pane.leaflet-popup-pane
> div
> div.leaflet-popup-content-wrapper
> div
> ul
> li:last-child
> div:last-child {
    border-bottom: none !important;
}

.leaflet-popup-content {
    margin-left: 0 !important;
    margin-right: 0 !important;
    margin-bottom: 0 !important;
}

html.theme--dark .leaflet-popup-content-wrapper,
body.theme--dark .leaflet-popup-content-wrapper,
.theme--dark .leaflet-popup-content-wrapper,
.v-theme--dark .leaflet-popup-content-wrapper,
html.theme--dark .leaflet-popup-tip,
body.theme--dark .leaflet-popup-tip,
.theme--dark .leaflet-popup-tip,
.v-theme--dark .leaflet-popup-tip {
    background-color: var(--sd-dark-surface-muted) !important;
    color: var(--sd-dark-text-inverse) !important;
}

html.theme--dark .leaflet-popup-content,
body.theme--dark .leaflet-popup-content,
.theme--dark .leaflet-popup-content,
.v-theme--dark .leaflet-popup-content {
    color: var(--sd-dark-text-inverse) !important;
}

html.theme--light .leaflet-popup-content-wrapper,
body.theme--light .leaflet-popup-content-wrapper,
.theme--light .leaflet-popup-content-wrapper,
.v-theme--light .leaflet-popup-content-wrapper,
html.theme--light .leaflet-popup-tip,
body.theme--light .leaflet-popup-tip,
.theme--light .leaflet-popup-tip,
.v-theme--light .leaflet-popup-tip {
    background-color: var(--sd-light-surface) !important;
    color: var(--sd-light-popup-text) !important;
}

html.theme--light .leaflet-popup-content,
body.theme--light .leaflet-popup-content,
.theme--light .leaflet-popup-content,
.v-theme--light .leaflet-popup-content {
    color: var(--sd-light-popup-text) !important;
}

.leaflet-draw-guides {
    z-index: 1000 !important;
}

.leaflet-draw-guide-dash {
    z-index: 1000 !important;
}

#reconstruction-container,
#report-container {
    max-width: 25rem;
    margin-right: auto;
    margin-left: auto;
    margin-top: 1.875rem;
}

#rightMainContainer,
#dataset-menu {
    transition: margin 1s, width 1s;
}

#rightMainContainer {
    width: 100%;
    position: absolute;
    z-index: 1;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
}

.hideDatasetMenu {
    margin: 0 !important;
    width: 100% !important;
}

.rightWidth {
    width: -webkit-calc(100% - 250px);
    width: -moz-calc(100% - 250px);
    width: calc(100% - 250px);
}

.icon-flipped {
    transform: scaleX(-1);
    -moz-transform: scaleX(-1);
    -webkit-transform: scaleX(-1);
    -ms-transform: scaleX(-1);
}

#app {
    background: none;
}

.application--wrap {
    min-height: 0;
}

.flexme {
    display: flex;
}

.v-expansion-panel-header:focus {
    background-color: var(--sd-surface-muted);
}

.toolbar-button {
    font-family: 'Omnes Medium';
}

a > div > img:hover {
    opacity: 0.9;
}

.no-autocomplete-border {
    margin-left: 0;
    margin-right: 0;
}

.no-select-border.v-text-field > .v-input__control > .v-input__slot:before {
    border-style: none;
}

.no-select-border.v-text-field > .v-input__control > .v-input__slot:after {
    border-style: none;
}

.v-toolbar__content,
.v-toolbar__extension {
    padding: 0 16px !important;
}

/*.top-page-site-select {*/
/*    max-width: 300px;*/
/*}*/

/*.top-page-dataset-select {*/
/*    max-width: 300px;*/
/*}*/

/*.top-page-view-select {*/
/*    max-width: 200px;*/
/*}*/

.toolbar-button > span > .help-icon {
    max-height: 0.938rem;
}

header.v-app-bar.v-app-bar--fixed {
    z-index: 4 !important;
}

div.top-bar-container > .headline {
    margin-top: 1rem;
}

.intercom-launcher-frame {
    display: none !important;
}

.intercom-messenger-frame {
    top: 80px !important;
}

@media only screen and (max-width: 600px) {
    /* xs breakpoint */
    .tab-card,
    .top-bar-bg {
        padding: 0 20px;
        width: 100%;
    }
}

@media only screen and (min-width: 600px) and (max-width: 960px) {
    /* sm breakpoint */
    .tab-card,
    .top-bar-bg {
        padding: 0 5%;
        width: 100%;
    }

    .card-grid-container {
        padding-left: 40px !important;
    }
}

.top-bar-bg {
    max-height: 7.5rem;
}

@media only screen and (min-width: 960px) {
    /* md breakpoint */
    .top-bar-bg {
        width: 100vw;
        margin: 0 auto;
    }

    div.tab-card,
    .top-bar-container {
        max-width: 1000px;
        margin: 0 auto;
    }

    .card-grid-container {
        padding-left: 60px !important;
    }

    .dashboard-container {
        margin-left: 60px !important;
    }
}

.full-width {
    width: 100%;
}

.card-grid-container > div.row > div > div.v-card,
.card-grid-container > div.row > div.v-card {
    max-width: 300px;
}

.max-width-500 {
    max-width: 500px !important;
    margin: 0 auto;
}

.max-width-700 {
    max-width: 700px !important;
    margin: 0 auto;
}

.max-width-1000 {
    max-width: 1000px !important;
    margin: 0 auto;
}

.v-list-item__title,
.v-list-item__subtitle {
    white-space: initial !important;
}

.v-window.full-width.fill-height.pa-5.v-item-group.theme--dark.v-tabs-items
> .v-window__container,
.v-window.full-width.fill-height.pa-5.v-item-group.theme--light.v-tabs-items
> .v-window__container {
    height: 100%;
}

header.v-app-bar {
    border: solid;
    border-width: 0;
    border-bottom-width: thin;
}

header.theme--dark.v-app-bar {
    border-color: var(--sd-dark-border);
}

header.theme--light.v-app-bar {
    border-color: var(--sd-light-border-subtle);
}

.v-picker.v-card.v-picker--date {
    box-shadow: none;
}

.v-date-picker-table {
    height: initial !important;
}

.v-input
> .v-input__control
> .v-input__slot
> .v-input__append-inner
> .v-input__icon.v-input__icon--append {
    transition: transform 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

.date-text-field.v-input--is-focused
> .v-input__control
> .v-input__slot
> .v-input__append-inner
> .v-input__icon.v-input__icon--append {
    transform: rotate(180deg);
}

.theme--dark.v-text-field--filled:not(.v-input--is-focused)
> .v-input__control
> .v-input__slot:hover {
    background: var(--sd-dark-field-hover) !important;
}

.theme--light.v-text-field--filled:not(.v-input--is-focused)
> .v-input__control
> .v-input__slot:hover {
    background: var(--sd-light-field-hover) !important;
}

button.dialog-close-btn {
    position: absolute;
    right: 0;
    top: 0;
}

.v-breadcrumbs li {
    font-size: 1.5rem !important;
}

.v-breadcrumbs,
.v-breadcrumbs ul {
    padding-left: 0 !important;
}

.no-margin {
    margin: 0 !important;
}

.v-icon.v-icon {
    max-width: 24px !important;
}

.top-bar-container {
    background-color: transparent;
}

.error-container {
    padding: 0.625rem;
    font-family: Omnes Regular, Omnes, Roboto, sans-serif;
    text-align: center;
}

.error-image {
    background: var(--sd-light-surface);
    padding: 0.313rem;
}

.color-button {
    padding: 0.938rem;
    width: 100%;
    height: 100%;
    cursor: pointer !important;
}

.color-button:hover {
    filter: brightness(90%);
}

.color-button.red {
    background-color: #ff0000;
}

.color-button.orange {
    background-color: #ff9900;
}

.color-button.yellow {
    background-color: #fffe00;
}

.color-button.green {
    background-color: #00c801;
}

.color-button.white {
    background-color: #e5e5e5;
}

.quality-button {
    cursor: pointer !important;
}

/*  This was originally set in vuetify.scss and imported through webpack (webpack.config.js:267)
    Since updating the sass-loader to handle scss/sass, this no longer worked properly
    TODO have vuetify import the Omnes Regular font correctly */
.v-application, .headline, .v-subheader, .omnes-font {
    font-family: Omnes Regular, Omnes, Roboto, sans-serif !important;
}

/* Modern UI standard layer (global, non-functional visual update) */

.v-application {
    background: radial-gradient(
        circle at 15% -10%,
        var(--sd-light-app-gradient-start) 0,
        var(--sd-bg) 40%,
        var(--sd-bg) 100%
    ) !important;
    color: var(--sd-text);
}

html,
body {
    background: var(--sd-bg);
    color: var(--sd-text);
}

.v-main {
    color: var(--sd-text);
}

a {
    color: var(--sd-primary);
    text-decoration-thickness: 1px;
    text-underline-offset: 2px;
}

a:hover {
    color: var(--sd-primary-strong);
}

header.v-app-bar {
    backdrop-filter: blur(8px);
    background-color: var(--sd-app-bar-bg) !important;
    box-shadow: 0 1px 0 rgba(30, 55, 90, 0.08);
}

.v-navigation-drawer {
    border-right: 1px solid var(--sd-border) !important;
    box-shadow: var(--sd-shadow-soft);
}

.v-card {
    border: 1px solid var(--sd-border);
    border-radius: var(--sd-radius-md) !important;
    box-shadow: var(--sd-shadow-soft) !important;
    overflow: hidden;
}

.v-card:hover {
    box-shadow: var(--sd-shadow-hover) !important;
}

.v-card__title {
    color: var(--sd-text);
    font-family: Omnes Medium, Omnes, Roboto, sans-serif !important;
    letter-spacing: 0.01em;
}

.v-card__text,
.v-list-item-subtitle,
.v-messages__message {
    color: var(--sd-text-muted) !important;
}

.v-list-item-title {
    color: var(--sd-text) !important;
}

/* Guard against legacy/global CSS making autocomplete text invisible */
.v-autocomplete .v-field__input,
.v-autocomplete .v-select__selection,
.v-autocomplete input,
.v-overlay .v-list-item-title {
    color: var(--sd-text) !important;
    opacity: 1 !important;
}

/* Keep all autocomplete fields readable over mixed page backgrounds. */
.v-autocomplete .v-field,
.v-autocomplete .v-field--variant-filled,
.v-autocomplete .v-field--variant-outlined,
.v-autocomplete .v-input__slot {
    background: var(--sd-light-surface) !important;
}

.v-btn {
    border-radius: var(--sd-radius-sm) !important;
    letter-spacing: 0.01em !important;
    text-transform: none !important;
    transition: box-shadow 0.18s ease, transform 0.18s ease;
}

.v-btn:hover {
    transform: translateY(-1px);
}

.v-btn--variant-elevated,
.v-btn--variant-flat,
.v-btn--variant-tonal {
    box-shadow: 0 4px 14px rgba(32, 78, 128, 0.15);
}

.v-btn--variant-text {
    box-shadow: none !important;
}

.v-field {
    border-radius: var(--sd-radius-sm) !important;
}

.v-field--variant-filled,
.v-field--variant-outlined {
    background: var(--sd-surface-soft) !important;
    border: 1px solid transparent;
    transition: border-color 0.16s ease, box-shadow 0.16s ease;
}

.v-field--variant-filled:hover,
.v-field--variant-outlined:hover {
    border-color: var(--sd-light-border-hover);
}

.v-field--focused {
    border-color: var(--sd-primary) !important;
    box-shadow: 0 0 0 3px rgba(47, 131, 201, 0.12);
}

.v-menu > .v-overlay__content,
.v-dialog > .v-overlay__content {
    border-radius: var(--sd-radius-md);
}

.v-overlay__content.smart-view-dialogue-overlay .smart-view-dialogue-base {
    background: var(--sd-surface) !important;
    color: var(--sd-text);
    border: 1px solid var(--sd-border);
    border-radius: var(--sd-radius-md) !important;
    box-shadow: var(--sd-shadow-soft) !important;
    overflow: hidden;
}

.smart-view-dialogue-overlay .smart-view-dialogue-base__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 24px 24px 16px;
    border-bottom: 1px solid var(--sd-border);
}

.smart-view-dialogue-overlay .smart-view-dialogue-base__heading {
    color: var(--sd-text);
    font-family: Omnes Medium, Omnes, Roboto, sans-serif !important;
    font-size: 1.35rem;
    line-height: 1.2;
    text-align: left;
}

.smart-view-dialogue-overlay .smart-view-dialogue-base__content {
    padding: 20px 24px 24px;
}

.smart-view-dialogue-overlay .smart-view-dialogue-base__close {
    flex-shrink: 0;
}

/* Autocomplete dropdown menu background */
.v-autocomplete__content,
.v-menu__content,
.v-menu > .v-overlay__content {
    background: var(--sd-light-surface) !important;
}

.v-autocomplete__content .v-list,
.v-menu__content .v-list,
.v-menu > .v-overlay__content .v-list {
    background: var(--sd-light-surface) !important;
}

/* Keep teleported menu lists aligned with explicit Vuetify theme classes. */
.v-autocomplete__content .v-list.v-theme--dark,
.v-menu__content .v-list.v-theme--dark,
.v-menu > .v-overlay__content .v-list.v-theme--dark,
.v-overlay__content .v-list.v-theme--dark {
    background: var(--sd-dark-surface-muted) !important;
    background-color: var(--sd-dark-surface-muted) !important;
}

.v-autocomplete__content .v-list.v-theme--light,
.v-menu__content .v-list.v-theme--light,
.v-menu > .v-overlay__content .v-list.v-theme--light,
.v-overlay__content .v-list.v-theme--light {
    background: var(--sd-light-surface) !important;
    background-color: var(--sd-light-surface) !important;
}

.v-list {
    background: transparent !important;
}

/* Dataset picker menu theming (moved from base.html inline styles). */
.dataset-menu-date-panel {
    border-right: 1px solid var(--sd-neutral-border-medium);
}

.dataset-menu-list {
    border: 1px solid var(--sd-neutral-border-medium);
    border-radius: 8px;
}

.dataset-groups-search .v-field {
    border: 1px solid var(--sd-neutral-border-medium);
    border-radius: 8px;
}

.theme--dark .dataset-menu-date-panel {
    border-right-color: var(--sd-dark-border-subtle);
}

.theme--light .dataset-menu-date-panel {
    border-right-color: var(--sd-light-border-subtle);
}

.theme--dark .dataset-menu-list .v-list-item-title,
.theme--dark .dataset-menu-list .v-list-item-subtitle {
    color: var(--sd-dark-text-strong);
}

.theme--light .dataset-menu-list .v-list-item-title,
.theme--light .dataset-menu-list .v-list-item-subtitle {
    color: var(--sd-light-text-strong);
}

.theme--dark .dataset-groups-search .v-field {
    background-color: var(--sd-dark-surface-muted) !important;
    border-color: var(--sd-dark-border-medium);
}

.theme--dark .dataset-groups-search .v-field__input,
.theme--dark .dataset-groups-search .v-icon {
    color: var(--sd-dark-text-strong) !important;
}

.theme--light .dataset-groups-search .v-field {
    background-color: var(--sd-light-surface) !important;
    border-color: var(--sd-light-border-medium);
}

.theme--dark .dataset-menu-list .v-list-item {
    background-color: var(--sd-dark-surface-muted) !important;
}

.theme--light .dataset-menu-list .v-list-item {
    background-color: var(--sd-light-surface) !important;
}

html.theme--light .leaflet-draw-toolbar a,
body.theme--light .leaflet-draw-toolbar a,
.theme--light .leaflet-draw-toolbar a,
.v-theme--light .leaflet-draw-toolbar a {
    background-image: linear-gradient(transparent, transparent),
        url('/static/img/leaflet-draw-spritesheet.svg') !important;
    background-repeat: no-repeat !important;
    background-size: 300px 30px !important;
}

.v-table,
.v-data-table {
    background: var(--sd-surface);
    border: 1px solid var(--sd-border);
    border-radius: var(--sd-radius-md);
    overflow: hidden;
}

.v-theme--light .v-table tbody tr:hover,
.theme--light .v-table tbody tr:hover,
.v-theme--light .v-data-table tbody tr:hover,
.theme--light .v-data-table tbody tr:hover {
    background: var(--sd-light-hover-overlay) !important;
}

.v-theme--dark .v-table tbody tr:hover,
.theme--dark .v-table tbody tr:hover,
.v-theme--dark .v-data-table tbody tr:hover,
.theme--dark .v-data-table tbody tr:hover {
    background: var(--sd-dark-hover-overlay) !important;
}

.v-chip {
    border-radius: 999px !important;
    border: 1px solid var(--sd-chip-border);
}

.v-theme--dark .v-application,
.theme--dark .v-application {
    background: var(--sd-bg) !important;
    color: var(--sd-text) !important;
}

html.theme--dark,
body.theme--dark {
    background: var(--sd-dark-body-bg) !important;
    color: var(--sd-dark-text) !important;
}

.v-theme--dark header.v-app-bar,
.theme--dark header.v-app-bar {
    background-color: var(--sd-dark-app-bar-bg) !important;
    box-shadow: 0 1px 0 rgba(255, 255, 255, 0.08);
}

.v-theme--dark .v-navigation-drawer,
.theme--dark .v-navigation-drawer {
    border-right: 1px solid var(--sd-dark-border) !important;
    box-shadow: none;
}

.v-theme--dark .v-card,
.theme--dark .v-card {
    border-color: var(--sd-dark-border);
    background: var(--sd-dark-surface);
    box-shadow: none !important;
}

.v-theme--dark .v-card__text,
.v-theme--dark .v-list-item-subtitle,
.theme--dark .v-card__text,
.theme--dark .v-list-item-subtitle {
    color: var(--sd-dark-text-soft) !important;
}

.v-theme--dark .v-field--variant-filled,
.v-theme--dark .v-field--variant-outlined,
.theme--dark .v-field--variant-filled,
.theme--dark .v-field--variant-outlined {
    background: var(--sd-dark-field-bg) !important;
}

.v-theme--dark .login-card .auth-card__left,
.theme--dark .login-card .auth-card__left {
    background: var(--sd-dark-surface-panel) !important;
}

.v-theme--light .login-card .auth-card__left,
.theme--light .login-card .auth-card__left {
    background: var(--sd-light-surface-panel) !important;
}

.v-theme--dark .reset-card .auth-card__left,
.theme--dark .reset-card .auth-card__left {
    background: var(--sd-dark-surface-panel) !important;
}

.v-theme--light .reset-card .auth-card__left,
.theme--light .reset-card .auth-card__left {
    background: var(--sd-light-surface-panel) !important;
}

.v-theme--dark .register-card .auth-card__left,
.theme--dark .register-card .auth-card__left {
    background: var(--sd-dark-surface-panel) !important;
}

.v-theme--light .register-card .auth-card__left,
.theme--light .register-card .auth-card__left {
    background: var(--sd-light-surface-panel) !important;
}

.v-theme--dark .v-autocomplete .v-field,
.v-theme--dark .v-autocomplete .v-field--variant-filled,
.v-theme--dark .v-autocomplete .v-field--variant-outlined,
.theme--dark .v-autocomplete .v-field,
.theme--dark .v-autocomplete .v-field--variant-filled,
.theme--dark .v-autocomplete .v-field--variant-outlined,
.theme--dark .v-autocomplete .v-input__slot {
    background: var(--sd-dark-autocomplete-bg) !important;
}

.v-theme--dark .v-autocomplete__content,
.theme--dark .v-autocomplete__content,
.v-theme--dark .v-autocomplete__content .v-list,
.theme--dark .v-autocomplete__content .v-list {
    background: var(--sd-dark-surface-elevated) !important;
}

.v-theme--dark .v-main,
.theme--dark .v-main,
.v-theme--dark .v-list-item-title,
.theme--dark .v-list-item-title,
.v-theme--dark .v-card__title,
.theme--dark .v-card__title {
    color: var(--sd-dark-text) !important;
}

.v-theme--dark .v-application,
.theme--dark .v-application,
.v-theme--dark .v-application .v-label,
.theme--dark .v-application .v-label,
.v-theme--dark .v-application .v-field__input,
.theme--dark .v-application .v-field__input,
.v-theme--dark .v-application .v-select__selection-text,
.theme--dark .v-application .v-select__selection-text,
.v-theme--dark .v-application .v-list-item-title,
.theme--dark .v-application .v-list-item-title,
.v-theme--dark .v-application .v-list-item-subtitle,
.theme--dark .v-application .v-list-item-subtitle,
.v-theme--dark .v-application .v-card-title,
.theme--dark .v-application .v-card-title,
.v-theme--dark .v-application .v-card-text,
.theme--dark .v-application .v-card-text,
.v-theme--dark .v-application .v-toolbar-title,
.theme--dark .v-application .v-toolbar-title,
.v-theme--dark .v-application .v-btn__content,
.theme--dark .v-application .v-btn__content,
.v-theme--dark .v-application .v-list-item-title a,
.theme--dark .v-application .v-list-item-title a {
    color: var(--sd-dark-text-inverse) !important;
}

.v-theme--dark .v-navigation-drawer,
.theme--dark .v-navigation-drawer {
    background: var(--sd-dark-surface-drawer) !important;
}

.v-theme--dark .v-navigation-drawer .v-list-item,
.theme--dark .v-navigation-drawer .v-list-item,
.v-theme--dark .v-navigation-drawer .v-list-item-title,
.theme--dark .v-navigation-drawer .v-list-item-title,
.v-theme--dark .v-navigation-drawer .v-list-item-subtitle,
.theme--dark .v-navigation-drawer .v-list-item-subtitle,
.v-theme--dark .v-navigation-drawer .v-list-group__header,
.theme--dark .v-navigation-drawer .v-list-group__header {
    color: var(--sd-dark-text-inverse) !important;
}

.v-theme--dark .v-navigation-drawer .v-divider,
.theme--dark .v-navigation-drawer .v-divider {
    border-color: var(--sd-dark-border-medium) !important;
}

.v-theme--dark .grey--text,
.theme--dark .grey--text,
.v-theme--dark .text-medium-emphasis,
.theme--dark .text-medium-emphasis {
    color: var(--sd-dark-text-strong) !important;
}

.v-theme--dark .v-menu > .v-overlay__content,
.theme--dark .v-menu > .v-overlay__content,
.v-theme--dark .v-dialog > .v-overlay__content,
.theme--dark .v-dialog > .v-overlay__content {
    background: var(--sd-dark-surface-elevated) !important;
}

.v-theme--dark .v-menu__content .v-list-item-subtitle,
.theme--dark .v-menu__content .v-list-item-subtitle,
.v-theme--dark .v-overlay .v-list-item-subtitle,
.theme--dark .v-overlay .v-list-item-subtitle {
    color: var(--sd-dark-text-muted) !important;
}

.v-theme--dark .v-autocomplete .v-field__input,
.theme--dark .v-autocomplete .v-field__input,
.v-theme--dark .v-autocomplete .v-select__selection,
.theme--dark .v-autocomplete .v-select__selection,
.v-theme--dark .v-autocomplete input,
.theme--dark .v-autocomplete input,
.v-theme--dark .v-overlay .v-list-item-title,
.theme--dark .v-overlay .v-list-item-title {
    color: var(--sd-dark-text) !important;
}

.v-theme--dark input:-webkit-autofill,
.theme--dark input:-webkit-autofill,
.v-theme--dark input:-webkit-autofill:hover,
.theme--dark input:-webkit-autofill:hover,
.v-theme--dark input:-webkit-autofill:focus,
.theme--dark input:-webkit-autofill:focus,
.v-theme--dark textarea:-webkit-autofill,
.theme--dark textarea:-webkit-autofill,
.v-theme--dark textarea:-webkit-autofill:hover,
.theme--dark textarea:-webkit-autofill:hover,
.v-theme--dark textarea:-webkit-autofill:focus,
.theme--dark textarea:-webkit-autofill:focus,
.v-theme--dark select:-webkit-autofill,
.theme--dark select:-webkit-autofill,
.v-theme--dark select:-webkit-autofill:hover,
.theme--dark select:-webkit-autofill:hover,
.v-theme--dark select:-webkit-autofill:focus,
.theme--dark select:-webkit-autofill:focus {
    -webkit-text-fill-color: var(--sd-dark-text-inverse) !important;
}

.v-theme--dark .leaflet-touch .leaflet-control-layers,
.theme--dark .leaflet-touch .leaflet-control-layers,
.v-theme--dark .leaflet-touch .leaflet-bar,
.theme--dark .leaflet-touch .leaflet-bar {
    border-color: var(--sd-dark-leaflet-border) !important;
}

.v-theme--dark .leaflet-container:not(.leaflet-control-minimap),
.theme--dark .leaflet-container:not(.leaflet-control-minimap) {
    background: var(--sd-dark-leaflet-bg) !important;
}

.v-theme--dark .handle-bl,
.theme--dark .handle-bl {
    background-color: var(--sd-dark-surface-muted);
    background-image: url('/static/img/expand-alt-white.svg');
}


/* Home dashboard page scope: keep page-specific styling isolated here. */
.dashboard-page {
    --dashboard-page-padding: 10px;
    --dashboard-page-max-width: 1400px;
    --dashboard-section-gap: 16px;
    --dashboard-section-padding-y: 0;
    --dashboard-section-padding-x: 0;
    --dashboard-title-size: 2.125rem;
    --dashboard-title-weight: 400;
    --dashboard-title-color: inherit;
    width: 100%;
    max-width: var(--dashboard-page-max-width);
    box-sizing: border-box;
    margin-left: auto;
    margin-right: auto;
    padding: var(--dashboard-page-padding);
    text-align: center;
}

.dashboard-page .dashboard-sections-wrapper {
    display: inline-block;
    width: fit-content;
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
    text-align: left;
}

.dashboard-page .dashboard-sections-wrapper > .dashboard-section {
    width: auto;
    max-width: 100%;
}

.dashboard-page .dashboard-section {
    margin: 0 0 var(--dashboard-section-gap) 0 !important;
    padding-top: var(--dashboard-section-padding-y) !important;
    padding-bottom: var(--dashboard-section-padding-y) !important;
    padding-left: var(--dashboard-section-padding-x) !important;
    padding-right: var(--dashboard-section-padding-x) !important;
}

.dashboard-page .dashboard-section > .v-row {
    margin-left: 0 !important;
    margin-right: 0 !important;
}

.dashboard-page .dashboard-section__title {
    font-size: var(--dashboard-title-size);
    font-weight: var(--dashboard-title-weight);
    color: var(--dashboard-title-color);
    margin-left: 0 !important;
    padding-left: 0 !important;
}

.v-theme--dark .dashboard-page,
.theme--dark .dashboard-page {
    --dashboard-title-color: var(--sd-dark-text-inverse);
}

.v-theme--dark .dashboard-page .dashboard-section__title,
.theme--dark .dashboard-page .dashboard-section__title {
    color: var(--sd-dark-text-inverse) !important;
}

/* Keep all dashboard sections on identical spacing rules. */
.dashboard-page .dashboard-section--recent-views,
.dashboard-page .dashboard-section--recently-uploaded-views,
.dashboard-page .dashboard-section--favourite-views,
.dashboard-page .dashboard-section--quick-actions {
    margin: 0 0 var(--dashboard-section-gap) 0 !important;
    padding-top: var(--dashboard-section-padding-y) !important;
    padding-bottom: var(--dashboard-section-padding-y) !important;
    padding-left: var(--dashboard-section-padding-x) !important;
    padding-right: var(--dashboard-section-padding-x) !important;
}

/* Cesium top toolbar + KML dropdown theme styling (global). */
.cesium-top-tools {
    background: var(--sd-light-app-bar-bg);
    border: 1px solid var(--sd-light-border-subtle);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.18);
    backdrop-filter: blur(4px);
}

.cesium-kml-dropdown-panel {
    background: var(--sd-light-surface);
    color: var(--sd-light-text);
    border: 1px solid var(--sd-light-border-subtle);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
}

.v-theme--dark .cesium-top-tools,
.theme--dark .cesium-top-tools {
    background: var(--sd-dark-app-bar-bg);
    border-color: var(--sd-dark-border-subtle);
    box-shadow: 0 10px 26px rgba(0, 0, 0, 0.5);
}

.v-theme--dark .cesium-kml-dropdown-panel,
.theme--dark .cesium-kml-dropdown-panel {
    background: var(--sd-dark-surface-muted);
    color: var(--sd-dark-text);
    border-color: var(--sd-dark-border-subtle);
}

/* Inspection viewer shell refresh: shared global styling for Phase 1A.
   Use the active app theme instead of pinning the shell to light mode. */
.inspection-view {
    padding: 0;
    background: var(--sd-bg);
    color: var(--sd-text);
    height: 100%;
    min-height: 0;
    overflow: hidden;
}

.inspection-view__primary {
    height: 100%;
    min-height: 0;
    padding-right: 0;
    overflow: hidden;
}

.inspection-view #inspectionMain,
.inspection-view #inspectionSpots {
    height: 100%;
    min-height: 0;
}

.inspection-view #inspectionSpots {
    padding-left: 0;
    border-radius: 0;
    overflow: hidden;
    border: none;
    box-shadow: none;
}

.inspection-view .inspection-shell {
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 0;
    min-height: 0;
    overflow: hidden;
}

.inspection-view .inspection-shell__header {
    display: flex;
    flex: 0 0 auto;
    justify-content: space-between;
    align-items: center;
    gap: 6px;
    overflow-x: auto;
    overflow-y: hidden;
    padding: 4px 12px;
    background: var(--sd-surface);
    border: none;
    border-bottom: 1px solid var(--sd-border);
    border-radius: 0;
    box-shadow: none;
    scrollbar-width: none;
}

.inspection-view .inspection-shell__header::-webkit-scrollbar {
    display: none;
}

.inspection-view .inspection-shell__title-group {
    flex: 0 0 auto;
    min-width: 0;
}

.inspection-view .inspection-shell__eyebrow,
.inspection-view .inspection-gallery__eyebrow,
.inspection-view .inspection-context-card__eyebrow {
    display: inline-block;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.14em;
    text-transform: uppercase;
}

.inspection-view .inspection-shell__eyebrow {
    color: var(--sd-primary);
    margin-bottom: 1px;
}

.inspection-view .inspection-shell__title-row {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;
}

.inspection-view .inspection-shell__title {
    margin: 0;
    font-family: 'Omnes Medium', 'Inter', sans-serif;
    font-size: 17px;
    line-height: 1.05;
    color: var(--sd-text);
}

.inspection-view .inspection-shell__title-badge {
    padding: 2px 7px;
    border-radius: 6px;
    background: var(--sd-info);
    color: var(--sd-light-text-inverse);
    font-size: 12px;
    font-weight: 600;
    text-transform: capitalize;
}

.inspection-view .inspection-shell__title-badge--profile {
    background: var(--sd-surface-soft);
    border: 1px solid var(--sd-border);
    color: var(--sd-text-secondary);
}

.inspection-view .inspection-shell__variant-switch {
    display: inline-flex;
    padding: 2px;
    border: 1px solid var(--sd-border);
    border-radius: 7px;
    background: var(--sd-surface-soft);
}

.inspection-view .inspection-shell__variant-button {
    padding: 3px 9px;
    border: 0;
    border-radius: 5px;
    background: transparent;
    color: var(--sd-text-secondary);
    font-size: 12px;
    font-weight: 600;
}

.inspection-view .inspection-shell__variant-button--active {
    background: var(--sd-primary);
    color: var(--sd-light-text-inverse);
}

.inspection-view .inspection-shell__meta {
    display: flex;
    align-items: stretch;
    gap: 6px;
    flex: 0 0 auto;
    flex-wrap: nowrap;
    justify-content: flex-end;
}

.inspection-view .inspection-shell__meta-pill {
    flex: 0 0 auto;
    min-width: 80px;
    padding: 4px 9px;
    border-radius: 8px;
    background: var(--sd-surface-soft);
    border: 1px solid var(--sd-border);
    color: var(--sd-text);
}

.inspection-view--split .inspection-shell__header {
    min-height: 62px;
    padding: 8px 12px;
}

.inspection-view--split .inspection-shell__meta-pill {
    display: none;
}

.inspection-view--split .inspection-shell__title {
    font-size: 16px;
}

.inspection-view--split .inspection-shell__title-group {
    min-width: 0;
}

.inspection-view .inspection-shell__meta-label {
    display: block;
    margin-bottom: 1px;
    font-size: 9px;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--sd-text-secondary);
}

.v-theme--dark .inspection-view .inspection-shell__header,
.theme--dark .inspection-view .inspection-shell__header,
html.theme--dark .inspection-view .inspection-shell__header,
body.theme--dark .inspection-view .inspection-shell__header {
    background: var(--sd-dark-surface-panel) !important;
    border-bottom-color: var(--sd-dark-border) !important;
}

.v-theme--dark .inspection-view .inspection-shell__eyebrow,
.theme--dark .inspection-view .inspection-shell__eyebrow,
html.theme--dark .inspection-view .inspection-shell__eyebrow,
body.theme--dark .inspection-view .inspection-shell__eyebrow {
    color: var(--sd-dark-text-secondary) !important;
}

.v-theme--dark .inspection-view .inspection-shell__title,
.theme--dark .inspection-view .inspection-shell__title,
html.theme--dark .inspection-view .inspection-shell__title,
body.theme--dark .inspection-view .inspection-shell__title {
    color: var(--sd-dark-text-inverse) !important;
}

.v-theme--dark .inspection-view .inspection-shell__title-badge,
.theme--dark .inspection-view .inspection-shell__title-badge,
html.theme--dark .inspection-view .inspection-shell__title-badge,
body.theme--dark .inspection-view .inspection-shell__title-badge {
    background: var(--sd-dark-surface-control) !important;
    color: var(--sd-dark-text-inverse) !important;
}

.v-theme--dark .inspection-view .inspection-shell__variant-switch,
.theme--dark .inspection-view .inspection-shell__variant-switch,
html.theme--dark .inspection-view .inspection-shell__variant-switch,
body.theme--dark .inspection-view .inspection-shell__variant-switch {
    background: var(--sd-dark-surface-control) !important;
    border-color: var(--sd-dark-border) !important;
}

.v-theme--dark .inspection-view .inspection-shell__variant-button,
.theme--dark .inspection-view .inspection-shell__variant-button,
html.theme--dark .inspection-view .inspection-shell__variant-button,
body.theme--dark .inspection-view .inspection-shell__variant-button {
    color: var(--sd-dark-text-secondary) !important;
}

.v-theme--dark .inspection-view .inspection-shell__variant-button--active,
.theme--dark .inspection-view .inspection-shell__variant-button--active,
html.theme--dark .inspection-view .inspection-shell__variant-button--active,
body.theme--dark .inspection-view .inspection-shell__variant-button--active {
    background: var(--sd-primary) !important;
    color: var(--sd-dark-text-inverse) !important;
}

.v-theme--dark .inspection-view .inspection-shell__meta-pill,
.theme--dark .inspection-view .inspection-shell__meta-pill,
html.theme--dark .inspection-view .inspection-shell__meta-pill,
body.theme--dark .inspection-view .inspection-shell__meta-pill {
    background: var(--sd-dark-surface-control) !important;
    border-color: var(--sd-dark-border) !important;
    color: var(--sd-dark-text-inverse) !important;
}

.v-theme--dark .inspection-view .inspection-shell__meta-label,
.theme--dark .inspection-view .inspection-shell__meta-label,
html.theme--dark .inspection-view .inspection-shell__meta-label,
body.theme--dark .inspection-view .inspection-shell__meta-label {
    color: var(--sd-dark-text-secondary) !important;
}

.v-theme--dark .inspection-view .inspection-shell__review-toggle,
.theme--dark .inspection-view .inspection-shell__review-toggle,
html.theme--dark .inspection-view .inspection-shell__review-toggle,
body.theme--dark .inspection-view .inspection-shell__review-toggle {
    background: var(--sd-dark-surface-control) !important;
    border-color: var(--sd-dark-border) !important;
    color: var(--sd-dark-text-inverse) !important;
}

.v-theme--dark .inspection-view .inspection-shell__review-toggle:hover,
.theme--dark .inspection-view .inspection-shell__review-toggle:hover,
html.theme--dark .inspection-view .inspection-shell__review-toggle:hover,
body.theme--dark .inspection-view .inspection-shell__review-toggle:hover {
    background: var(--sd-dark-surface-control-hover) !important;
}

.v-theme--dark .inspection-view .inspection-shell__review-toggle-icon,
.theme--dark .inspection-view .inspection-shell__review-toggle-icon,
html.theme--dark .inspection-view .inspection-shell__review-toggle-icon,
body.theme--dark .inspection-view .inspection-shell__review-toggle-icon {
    color: var(--sd-dark-text-inverse) !important;
}

.inspection-view .inspection-shell__body {
    flex: 1;
    min-height: 0;
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: 0;
    overflow: hidden;
}

.inspection-view .inspection-shell__body--context {
    grid-template-columns: minmax(0, 1fr) minmax(240px, 280px);
}

.inspection-view .inspection-canvas-stage {
    position: relative;
    min-height: 0;
    overflow: hidden;
    border-radius: 0;
    border: none;
    background: var(--sd-map-canvas-bg);
    box-shadow: none;
}

.inspection-view .inspection-context-rail {
    display: flex;
    flex-direction: column;
    gap: 10px;
    min-height: 0;
    max-height: 100%;
    overflow-y: auto;
    overscroll-behavior: contain;
    padding: 12px 12px 24px;
    scrollbar-gutter: stable;
    background: var(--sd-surface-soft);
    border-left: 1px solid var(--sd-border);
}

.inspection-view .inspection-context-rail__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 2px 2px 6px;
}

.inspection-view .inspection-context-rail__header h3 {
    margin: 2px 0 0;
    color: var(--sd-text);
    font-size: 18px;
    font-weight: 600;
}

.inspection-view .inspection-context-rail__close {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: 1px solid var(--sd-border);
    border-radius: 6px;
    background: var(--sd-surface);
    color: var(--sd-text-secondary);
    cursor: pointer;
}

.inspection-view .inspection-context-card {
    width: 100%;
    padding: 14px;
    border-radius: 14px;
    background: var(--sd-surface);
    border: 1px solid var(--sd-border);
    box-shadow: none;
    color: var(--sd-text);
}

.inspection-view .inspection-context-card__header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 12px;
}

.inspection-view .inspection-gallery__eyebrow,
.inspection-view .inspection-context-card__eyebrow {
    color: var(--sd-primary);
}

.inspection-view .inspection-context-card__hint {
    font-size: 12px;
    color: var(--sd-text-secondary);
}

.inspection-view .inspection-stats-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
}

.inspection-view .inspection-stat {
    padding: 8px 10px;
    border-radius: 10px;
    background: var(--sd-bg);
    border: 1px solid var(--sd-border);
}

.inspection-view .inspection-stat__label {
    display: block;
    margin-bottom: 5px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--sd-text-secondary);
}

.inspection-view .inspection-stat strong {
    color: var(--sd-text);
}

.inspection-view .inspection-shot-map {
    padding: 0;
    overflow: hidden;
}

.inspection-view .inspection-shot-map__header {
    padding: 14px 14px 0;
    margin-bottom: 12px;
}

.inspection-view .inspection-shot-map__canvas {
    width: 100%;
    height: 240px;
    border-top: 1px solid var(--sd-border);
}

.inspection-view .inspection-shot-map__empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    min-height: 220px;
    padding: 18px;
    border-top: 1px solid var(--sd-border);
    color: var(--sd-text-secondary);
    font-size: 13px;
    text-align: center;
}

.inspection-view .inspection-shot-map .leaflet-container {
    background: var(--sd-bg) !important;
}

.inspection-view .inspection-shot-map .leaflet-marker-icon,
.inspection-view .inspection-shot-map .leaflet-marker-shadow {
    transition: transform 0.15s ease;
}

.inspection-view .inspection-powerline-card__subtitle {
    margin: 6px 0 0;
    font-size: 13px;
    line-height: 1.45;
    color: var(--sd-text-secondary);
}

.inspection-view .inspection-powerline-card__status {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 92px;
    padding: 6px 10px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    border: 1px solid transparent;
}

.inspection-view .inspection-powerline-card__status--not-started {
    background: var(--sd-surface-soft);
    color: var(--sd-text-secondary);
    border-color: var(--sd-border);
}

.inspection-view .inspection-powerline-card__status--empty {
    background: var(--sd-surface-soft);
    color: var(--sd-text-secondary);
    border-color: var(--sd-border);
}

.inspection-view .inspection-powerline-card__status--requested {
    background: var(--sd-primary-surface-alpha);
    color: var(--sd-primary);
    border-color: var(--sd-primary-border-alpha);
}

.inspection-view .inspection-powerline-card__status--processing {
    background: var(--sd-primary-surface-alpha);
    color: var(--sd-primary);
    border-color: var(--sd-primary-border-alpha);
}

.inspection-view .inspection-powerline-card__status--completed,
.inspection-view .inspection-powerline-card__status--complete {
    background: var(--sd-success-surface-alpha);
    color: var(--sd-success);
    border-color: var(--sd-success-border-alpha);
}

.inspection-view .inspection-powerline-card__status--error,
.inspection-view .inspection-powerline-card__status--unavailable {
    background: var(--sd-error-surface-alpha);
    color: var(--sd-error);
    border-color: var(--sd-error-border-alpha);
}

.inspection-view .inspection-powerline-card__content {
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.inspection-view .inspection-powerline-card__status--compact {
    align-self: flex-start;
}

.inspection-view .inspection-powerline-card__empty {
    display: flex;
    align-items: center;
    gap: 10px;
    min-height: 64px;
    color: var(--sd-text-secondary);
    font-size: 13px;
}

.inspection-view .inspection-powerline-card__summary {
    margin: 0;
    font-size: 13px;
    line-height: 1.55;
    color: var(--sd-text);
}

.inspection-view .inspection-powerline-card__progress {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.inspection-view .inspection-powerline-card__progress-meta {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    font-size: 12px;
    color: var(--sd-text-secondary);
}

.inspection-view .inspection-powerline-card__progress-meta span:first-child {
    color: var(--sd-text);
    font-weight: 600;
}

.inspection-view .inspection-powerline-card__progress-track {
    position: relative;
    height: 8px;
    overflow: hidden;
    border-radius: 999px;
    background: var(--sd-surface-soft);
    border: 1px solid var(--sd-border);
}

.inspection-view .inspection-powerline-card__progress-bar {
    display: block;
    height: 100%;
    border-radius: inherit;
    background: linear-gradient(90deg, var(--sd-primary) 0%, var(--sd-primary-gradient-end) 100%);
    transition: width 0.2s ease;
}

.inspection-view .inspection-powerline-card__stats {
    margin-top: -2px;
}

.inspection-view .inspection-powerline-card__detector {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    padding: 14px;
    border-radius: 12px;
    border: 1px solid var(--sd-border);
    background: var(--sd-surface-soft);
}

.inspection-view .inspection-powerline-card__detector-copy {
    display: flex;
    flex: 1 1 200px;
    flex-direction: column;
    gap: 8px;
    min-width: 0;
}

.inspection-view .inspection-powerline-card__detector-heading {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
}

.inspection-view .inspection-powerline-card__detector-title {
    color: var(--sd-text);
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.01em;
}

.inspection-view .inspection-powerline-card__detector-text {
    margin: 0;
    color: var(--sd-text-secondary);
    font-size: 13px;
    line-height: 1.5;
}

.inspection-view .inspection-powerline-card__actions {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.inspection-view .inspection-powerline-card__action {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    min-height: 40px;
    padding: 10px 14px;
    border-radius: 10px;
    border: 1px solid var(--sd-border);
    background: var(--sd-surface);
    color: var(--sd-text);
    font-size: 13px;
    font-weight: 700;
    line-height: 1;
    transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease;
}

.inspection-view .inspection-powerline-card__action:hover {
    border-color: var(--sd-primary-border-hover);
    color: var(--sd-primary);
    background: var(--sd-surface-soft);
}

.inspection-view .inspection-powerline-card__action:disabled {
    cursor: wait;
    border-color: var(--sd-border);
    background: var(--sd-surface-soft);
    color: var(--sd-text-muted);
}

.inspection-view .inspection-powerline-card__action--primary {
    border-color: var(--sd-primary-border-muted);
    background: var(--sd-primary-surface-soft-alpha);
    color: var(--sd-primary);
}

.inspection-view .inspection-powerline-card__action-icon {
    color: inherit !important;
}

.inspection-view .inspection-gallery-root {
    --inspection-gallery-left-offset: 64px;
    position: absolute;
    left: var(--inspection-gallery-left-offset);
    right: 0;
    bottom: 0;
    z-index: 510;
    pointer-events: none;
    --inspection-gallery-right-offset: max(
        190px,
        calc(var(--leaflet-minimap-left-margin, 170px) + 210px)
    );
}

.inspection-view .inspection-gallery-root > * {
    pointer-events: auto;
}

.inspection-view .inspection-source-photos {
    position: absolute;
    left: 0;
    right: var(--inspection-gallery-right-offset);
    bottom: 42px;
    display: flex;
    min-height: 112px;
    overflow: hidden;
    border: 1px solid var(--sd-border);
    border-radius: 10px;
    background: var(--sd-surface);
    color: var(--sd-text);
    box-shadow: 0 8px 20px rgba(9, 15, 27, 0.22);
    transition: bottom 0.15s ease;
}

.inspection-view .inspection-source-photos--gallery-open {
    bottom: 164px;
}

.inspection-view .inspection-source-photos__header {
    display: flex;
    flex: 0 0 132px;
    flex-direction: column;
    justify-content: space-between;
    padding: 12px;
    border-right: 1px solid var(--sd-border);
}

.inspection-view .inspection-source-photos__title-group {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.inspection-view .inspection-source-photos__eyebrow {
    color: var(--sd-primary);
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.inspection-view .inspection-source-photos__title {
    color: var(--sd-text);
    font-size: 14px;
}

.inspection-view .inspection-source-photos__count {
    color: var(--sd-text-muted);
    font-size: 11px;
}

.inspection-view .inspection-source-photos__list {
    display: flex;
    flex: 1 1 auto;
    gap: 8px;
    min-width: 0;
    overflow-x: auto;
    padding: 8px;
}

.inspection-view .inspection-source-photos__empty {
    align-self: center;
    flex: 1 1 auto;
    margin: 8px;
    padding: 10px 12px;
    border: 1px dashed var(--sd-border);
    border-radius: 8px;
    color: var(--sd-text-secondary);
    font-size: 12px;
    text-align: center;
}

.inspection-view .inspection-source-photos__candidate {
    position: relative;
    display: flex;
    flex: 0 0 112px;
    flex-direction: column;
    gap: 5px;
    min-width: 0;
    padding: 4px;
    overflow: hidden;
    border: 1px solid var(--sd-border);
    border-radius: 10px;
    background: transparent;
    color: var(--sd-text-secondary);
    cursor: pointer;
    text-align: left;
}

.inspection-view .inspection-source-photos__candidate:hover {
    background: var(--sd-surface-soft);
}

.inspection-view .inspection-source-photos__candidate:disabled {
    cursor: wait;
    opacity: 0.62;
}

.inspection-view .inspection-source-photos__candidate:disabled:hover {
    background: transparent;
}

.inspection-view .inspection-source-photos__candidate--selected {
    border-color: var(--sd-primary);
    box-shadow: inset 0 0 0 1px var(--sd-primary);
}

.inspection-view .inspection-source-photos__thumbnail {
    width: 100%;
    border-radius: 7px;
}

.inspection-view .inspection-source-photos__rank,
.inspection-view .inspection-source-photos__state {
    position: absolute;
    top: 5px;
    z-index: 1;
    border-radius: 4px;
    background: rgba(15, 23, 42, 0.78);
    color: #ffffff;
    font-size: 10px;
    font-weight: 700;
    line-height: 18px;
}

.inspection-view .inspection-source-photos__rank {
    left: 5px;
    width: 18px;
    text-align: center;
}

.inspection-view .inspection-source-photos__state {
    right: 5px;
    padding: 0 5px;
}

.inspection-view .inspection-source-photos__filename {
    overflow: hidden;
    color: var(--sd-text-secondary);
    font-size: 10px;
    line-height: 14px;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.inspection-view .inspection-source-photos__legend {
    display: flex;
    flex-wrap: wrap;
    gap: 6px 12px;
    padding: 0 12px 10px;
    color: var(--sd-text-secondary);
    font-size: 11px;
}

.inspection-view .inspection-source-photos__legend > span {
    display: inline-flex;
    align-items: center;
    gap: 5px;
}

.inspection-view .inspection-source-photos__legend-icon {
    line-height: 1;
}

.inspection-view .inspection-source-photos__legend-icon--selection {
    color: #37a5ff;
}

.inspection-view .inspection-source-photos__legend-icon--finding {
    color: var(--sd-danger);
}

.inspection-view .inspection-gallery__toggle {
    position: absolute;
    left: 0;
    right: var(--inspection-gallery-right-offset);
    bottom: 0;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 16px;
    border: none;
    border-radius: 0;
    background: var(--sd-dark-surface-control);
    border-top: 1px solid var(--sd-dark-panel-border-soft);
    color: var(--sd-dark-panel-text-secondary);
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.15s ease;
    pointer-events: auto;
}

.inspection-view .inspection-gallery__toggle:hover {
    background: var(--sd-dark-surface-control-hover);
}

.inspection-view .inspection-gallery__toggle-icon {
    color: var(--sd-dark-panel-accent) !important;
}

.inspection-view .inspection-gallery__toggle-label {
    font-weight: 700;
    color: var(--sd-dark-panel-text);
    letter-spacing: 0.01em;
}

.inspection-view .inspection-gallery__toggle-count {
    font-size: 12px;
    font-weight: 500;
    color: var(--sd-dark-panel-text-muted);
}

.inspection-view .inspection-gallery__toggle-chevron {
    margin-left: auto;
    color: var(--sd-dark-panel-text-muted) !important;
}

.inspection-view .inspection-gallery {
    position: absolute;
    left: 0;
    right: var(--inspection-gallery-right-offset);
    bottom: 0;
    width: auto;
    max-width: none;
    border-radius: 12px !important;
    border: 1px solid var(--sd-dark-panel-border-soft);
    background: var(--sd-dark-surface-control) !important;
    box-shadow: 0 8px 20px rgba(9, 15, 27, 0.22);
    color: var(--sd-dark-panel-text);
}

.inspection-view .inspection-gallery__dialog {
    display: flex;
    flex-direction: column;
    width: min(1760px, 94vw);
    max-width: calc(100vw - 24px);
    max-height: calc(100vh - 24px);
    overflow: hidden;
}

.inspection-view .inspection-gallery__dialog-header {
    flex: 0 0 auto;
}

.inspection-view .inspection-gallery__dialog-body {
    flex: 1 1 auto;
    overflow: auto;
}

.inspection-view .inspection-gallery__toolbar {
    display: flex;
    align-items: center;
    gap: 10px;
    min-height: 48px;
    padding: 8px 14px 4px;
}

.inspection-view .inspection-gallery__icon-button {
    color: var(--sd-dark-panel-text);
}

.inspection-view .inspection-gallery__title-group {
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.inspection-view .inspection-gallery__title {
    font-size: 18px;
    font-weight: 700;
    color: var(--sd-dark-panel-text);
}

.inspection-view .inspection-gallery__count {
    margin-left: 8px;
    font-size: 13px;
    font-weight: 500;
    color: var(--sd-dark-text-secondary);
}

.inspection-view .inspection-gallery__strip {
    padding: 0 10px 10px;
}

.inspection-view .inspection-gallery__thumbnail {
    height: 88px;
    cursor: pointer;
    border-radius: 10px;
    border: 1px solid var(--sd-dark-panel-border-faint);
}

.inspection-view .inspection-gallery__thumbnail--selected {
    border-color: var(--sd-dark-panel-selected-border);
    box-shadow: inset 0 0 0 1px var(--sd-dark-panel-selected-ring);
}

.inspection-view .inspection-gallery__dialog {
    border-radius: 24px !important;
    overflow: hidden;
}

.inspection-view .inspection-gallery__dialog-header {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 18px 22px;
}

.inspection-view .inspection-gallery__dialog-body {
    background: var(--sd-bg);
}

.inspection-view .inspection-gallery__dialog-count {
    font-size: 13px;
    font-weight: 600;
    color: var(--sd-text-secondary);
}

.inspection-view .inspection-gallery__empty-card {
    background: transparent;
}

.inspection-view .inspection-gallery .v-slide-group__prev,
.inspection-view .inspection-gallery .v-slide-group__next {
    color: var(--sd-dark-panel-text);
}

.inspection-view .inspection-gallery .v-slide-group__prev--disabled,
.inspection-view .inspection-gallery .v-slide-group__next--disabled {
    opacity: 0.35;
}

.inspection-view .inspection-gallery .v-badge__badge {
    background: var(--sd-primary-active) !important;
    color: var(--sd-light-text-inverse) !important;
}

.inspection-view .inspection-gallery .v-card-text {
    color: inherit;
}

body.theme--light .inspection-view .inspection-gallery-root,
html.theme--light .inspection-view .inspection-gallery-root,
.theme--light .inspection-view .inspection-gallery-root,
.v-theme--light .inspection-view .inspection-gallery-root {
    --inspection-gallery-left-offset: 64px;
}

body.theme--light .inspection-view .inspection-gallery__toggle,
html.theme--light .inspection-view .inspection-gallery__toggle,
.theme--light .inspection-view .inspection-gallery__toggle,
.v-theme--light .inspection-view .inspection-gallery__toggle {
    background: var(--sd-light-surface-panel);
    border-top-color: var(--sd-light-border-subtle);
    color: var(--sd-light-text-secondary);
}

body.theme--light .inspection-view .inspection-gallery__toggle:hover,
html.theme--light .inspection-view .inspection-gallery__toggle:hover,
.theme--light .inspection-view .inspection-gallery__toggle:hover,
.v-theme--light .inspection-view .inspection-gallery__toggle:hover {
    background: var(--sd-light-surface-muted);
}

body.theme--light .inspection-view .inspection-gallery__toggle-icon,
html.theme--light .inspection-view .inspection-gallery__toggle-icon,
.theme--light .inspection-view .inspection-gallery__toggle-icon,
.v-theme--light .inspection-view .inspection-gallery__toggle-icon {
    color: var(--sd-light-primary-active) !important;
}

body.theme--light .inspection-view .inspection-gallery__toggle-label,
html.theme--light .inspection-view .inspection-gallery__toggle-label,
.theme--light .inspection-view .inspection-gallery__toggle-label,
.v-theme--light .inspection-view .inspection-gallery__toggle-label {
    color: var(--sd-light-text-strong);
}

body.theme--light .inspection-view .inspection-gallery__toggle-count,
html.theme--light .inspection-view .inspection-gallery__toggle-count,
.theme--light .inspection-view .inspection-gallery__toggle-count,
.v-theme--light .inspection-view .inspection-gallery__toggle-count,
body.theme--light .inspection-view .inspection-gallery__toggle-chevron,
html.theme--light .inspection-view .inspection-gallery__toggle-chevron,
.theme--light .inspection-view .inspection-gallery__toggle-chevron,
.v-theme--light .inspection-view .inspection-gallery__toggle-chevron {
    color: var(--sd-light-text-secondary) !important;
}

body.theme--light .inspection-view .inspection-gallery,
html.theme--light .inspection-view .inspection-gallery,
.theme--light .inspection-view .inspection-gallery,
.v-theme--light .inspection-view .inspection-gallery {
    border-color: var(--sd-light-border-subtle);
    background: var(--sd-light-surface-panel) !important;
    box-shadow: 0 8px 20px rgba(15, 23, 42, 0.12);
    color: var(--sd-light-text);
}

body.theme--light .inspection-view .inspection-gallery__toolbar,
html.theme--light .inspection-view .inspection-gallery__toolbar,
.theme--light .inspection-view .inspection-gallery__toolbar,
.v-theme--light .inspection-view .inspection-gallery__toolbar {
    background: var(--sd-light-surface-panel);
}

body.theme--light .inspection-view .inspection-gallery__icon-button,
html.theme--light .inspection-view .inspection-gallery__icon-button,
.theme--light .inspection-view .inspection-gallery__icon-button,
.v-theme--light .inspection-view .inspection-gallery__icon-button,
body.theme--light .inspection-view .inspection-gallery__title,
html.theme--light .inspection-view .inspection-gallery__title,
.theme--light .inspection-view .inspection-gallery__title,
.v-theme--light .inspection-view .inspection-gallery__title {
    color: var(--sd-light-text);
}

body.theme--light .inspection-view .inspection-gallery__count,
html.theme--light .inspection-view .inspection-gallery__count,
.theme--light .inspection-view .inspection-gallery__count,
.v-theme--light .inspection-view .inspection-gallery__count,
body.theme--light .inspection-view .inspection-gallery__dialog-count,
html.theme--light .inspection-view .inspection-gallery__dialog-count,
.theme--light .inspection-view .inspection-gallery__dialog-count,
.v-theme--light .inspection-view .inspection-gallery__dialog-count {
    color: var(--sd-light-text-secondary);
}

body.theme--light .inspection-view .inspection-gallery__thumbnail,
html.theme--light .inspection-view .inspection-gallery__thumbnail,
.theme--light .inspection-view .inspection-gallery__thumbnail,
.v-theme--light .inspection-view .inspection-gallery__thumbnail {
    border-color: var(--sd-light-border-subtle);
}

body.theme--light .inspection-view .inspection-gallery__thumbnail--selected,
html.theme--light .inspection-view .inspection-gallery__thumbnail--selected,
.theme--light .inspection-view .inspection-gallery__thumbnail--selected,
.v-theme--light .inspection-view .inspection-gallery__thumbnail--selected {
    border-color: var(--sd-light-primary-active);
    box-shadow: inset 0 0 0 1px var(--sd-light-primary-active);
}

body.theme--light .inspection-view .inspection-gallery .v-slide-group__prev,
body.theme--light .inspection-view .inspection-gallery .v-slide-group__next,
html.theme--light .inspection-view .inspection-gallery .v-slide-group__prev,
html.theme--light .inspection-view .inspection-gallery .v-slide-group__next,
.theme--light .inspection-view .inspection-gallery .v-slide-group__prev,
.theme--light .inspection-view .inspection-gallery .v-slide-group__next,
.v-theme--light .inspection-view .inspection-gallery .v-slide-group__prev,
.v-theme--light .inspection-view .inspection-gallery .v-slide-group__next {
    color: var(--sd-light-text-strong);
}

body.theme--light .inspection-view .inspection-gallery .v-badge__badge,
html.theme--light .inspection-view .inspection-gallery .v-badge__badge,
.theme--light .inspection-view .inspection-gallery .v-badge__badge,
.v-theme--light .inspection-view .inspection-gallery .v-badge__badge {
    background: var(--sd-light-primary-surface) !important;
    color: var(--sd-light-text-inverse) !important;
}

body.theme--light .inspection-view .inspection-gallery__dialog-body,
html.theme--light .inspection-view .inspection-gallery__dialog-body,
.theme--light .inspection-view .inspection-gallery__dialog-body,
.v-theme--light .inspection-view .inspection-gallery__dialog-body {
    background: var(--sd-light-surface);
}

.inspection-view .leaflet-container:not(.leaflet-control-minimap) {
    background: var(--sd-bg) !important;
}

.inspection-view .leaflet-top.leaflet-left,
.inspection-view .leaflet-top.leaflet-right {
    top: 16px;
}

.inspection-view .leaflet-top.leaflet-left {
    left: 18px;
}

.inspection-view .leaflet-top.leaflet-right {
    right: 18px;
}

.inspection-view .leaflet-bottom.leaflet-left {
    left: 12px;
    bottom: 12px;
}

.inspection-view .leaflet-bottom.leaflet-right {
    right: 12px;
    bottom: 12px;
}

.inspection-view .leaflet-bar,
.inspection-view .easy-button-container.leaflet-bar,
.inspection-view .leaflet-draw-toolbar {
    border: 1px solid var(--sd-border);
    border-radius: 10px;
    overflow: hidden;
    margin-top: auto;
    box-shadow: 0 4px 12px rgba(15, 23, 42, 0.10);
}

.inspection-view .leaflet-top.leaflet-left .leaflet-bar + .leaflet-bar {
    margin-top: 6px;
}

.inspection-view .leaflet-bar > a,
.inspection-view .easy-button-button,
.inspection-view .leaflet-draw-toolbar > a {
    display: flex !important;
    align-items: center;
    justify-content: center;
    padding: 0 !important;
    text-align: center;
    width: 36px !important;
    height: 36px !important;
    line-height: 36px !important;
    border-bottom: 1px solid var(--sd-border) !important;
    background-color: var(--sd-surface);
    color: var(--sd-text) !important;
}

.inspection-view .leaflet-bar > a > *,
.inspection-view .easy-button-button > * {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
    line-height: 1 !important;
}

.inspection-view .leaflet-bar a::before,
.inspection-view .leaflet-bar a::after,
.inspection-view .easy-button-button::before,
.inspection-view .easy-button-button::after {
    margin: auto;
}

.inspection-view .leaflet-bar i,
.inspection-view .easy-button-button i,
.inspection-view .leaflet-draw-toolbar i {
    line-height: 1 !important;
}

.inspection-view .leaflet-draw-toolbar > a {
    background-image: linear-gradient(transparent, transparent),
        url('/static/img/leaflet-draw-spritesheet.svg') !important;
    background-repeat: no-repeat !important;
    background-size: 300px 30px !important;
}

.leaflet-touch .inspection-view .leaflet-draw-toolbar .leaflet-draw-draw-polyline {
    background-position: -2px -2px !important;
}

.leaflet-touch .inspection-view .leaflet-draw-toolbar .leaflet-draw-draw-polygon {
    background-position: -31px -2px !important;
}

.leaflet-touch .inspection-view .leaflet-draw-toolbar .leaflet-draw-draw-rectangle {
    background-position: -62px -2px !important;
}

.leaflet-touch .inspection-view .leaflet-draw-toolbar .leaflet-draw-draw-circle {
    background-position: -92px -2px !important;
}

.leaflet-touch .inspection-view .leaflet-draw-toolbar .leaflet-draw-draw-marker {
    background-position: -122px -2px !important;
}

.leaflet-touch .inspection-view .leaflet-draw-toolbar .leaflet-draw-draw-circlemarker {
    background-position: -273px -2px !important;
}

.leaflet-touch .inspection-view .leaflet-draw-toolbar .leaflet-draw-edit-edit {
    background-position: -152px -2px !important;
}

.leaflet-touch .inspection-view .leaflet-draw-toolbar .leaflet-draw-edit-remove {
    background-position: -182px -2px !important;
}

.inspection-view .leaflet-bar > a:last-child,
.inspection-view .easy-button-button:last-child {
    border-bottom: 0 !important;
}

.inspection-view .leaflet-bar > a:hover,
.inspection-view .easy-button-button:hover,
.inspection-view .leaflet-draw-toolbar > a:hover {
    background-color: var(--sd-surface-soft);
}

.inspection-view .easy-button-button.leaflet-bar-part.leaflet-interactive.unnamed-state-active {
    padding: 0;
}

.inspection-view .downloadImageButton,
.inspection-view .hideAutoAnnotationsButton,
.inspection-view .hideSpotsMap {
    background-size: 18px;
    background-repeat: no-repeat;
    background-position: center;
}

.inspection-view .downloadImageButton {
    background-image: url('/static/img/download.svg');
}

.inspection-view .hideAutoAnnotationsButton {
    background-image: url('/static/img/robot.svg');
}

.inspection-view .hideSpotsMap {
    background-image: url('/static/img/smartview_markers/inspection_marker_white.png') !important;
}

.inspection-view .findSimilarButton {
    text-align: center;
}

.inspection-view .findSimilarButton i {
    line-height: 26px;
}

.inspection-view .findSimilarButton.active {
    background-color: var(--sd-surface-soft) !important;
    color: var(--sd-primary) !important;
}

.inspection-view .hideAutoAnnotationsButton.hidden:after,
.inspection-view .hideSpotsMap.hidden:after {
    content: '';
    position: absolute;
    width: 3px;
    height: 100%;
    top: 0;
    display: block;
    background: var(--sd-text) !important;
    left: 50%;
    transform: translate(-50%, 0) rotate(45deg);
}

.inspection-view .leaflet-draw-actions {
    left: 8px !important;
}

@media only screen and (max-height: 780px) {
    .inspection-view .inspection-gallery__toggle {
        gap: 6px;
        min-height: 28px;
        padding: 5px 12px;
        font-size: 12px;
    }

    .inspection-view .inspection-gallery__toggle-count {
        font-size: 11px;
    }

    .inspection-view .leaflet-top.leaflet-left,
    .inspection-view .leaflet-top.leaflet-right {
        top: 0px;
    }

    .inspection-view .leaflet-top.leaflet-left {
        left: 10px;
    }

    .inspection-view .leaflet-top.leaflet-right {
        right: 10px;
    }

    .inspection-view .leaflet-bar > a,
    .inspection-view .easy-button-button,
    .inspection-view .leaflet-draw-toolbar > a {
        width: 27px !important;
        height: 22px !important;
        line-height: 22px !important;
    }

    .inspection-view .leaflet-top.leaflet-left .leaflet-bar + .leaflet-bar {
        margin-top: 0;
    }

    .inspection-view .downloadImageButton,
    .inspection-view .hideAutoAnnotationsButton,
    .inspection-view .hideSpotsMap {
        background-size: 13px;
    }

    .inspection-view .findSimilarButton i {
        line-height: 18px;
    }
}

.v-theme--dark .inspection-view .leaflet-top.leaflet-left .leaflet-bar,
.theme--dark .inspection-view .leaflet-top.leaflet-left .leaflet-bar,
.v-theme--dark .inspection-view .leaflet-top.leaflet-left .easy-button-container.leaflet-bar,
.theme--dark .inspection-view .leaflet-top.leaflet-left .easy-button-container.leaflet-bar,
.v-theme--dark .inspection-view .leaflet-top.leaflet-left .leaflet-draw-toolbar,
.theme--dark .inspection-view .leaflet-top.leaflet-left .leaflet-draw-toolbar {
    background: var(--sd-surface) !important;
    border-color: var(--sd-border) !important;
}

.v-theme--dark .inspection-view .leaflet-top.leaflet-left .leaflet-bar > a,
.theme--dark .inspection-view .leaflet-top.leaflet-left .leaflet-bar > a,
.v-theme--dark .inspection-view .leaflet-top.leaflet-left .easy-button-button,
.theme--dark .inspection-view .leaflet-top.leaflet-left .easy-button-button,
.v-theme--dark .inspection-view .leaflet-top.leaflet-left .leaflet-draw-toolbar > a,
.theme--dark .inspection-view .leaflet-top.leaflet-left .leaflet-draw-toolbar > a {
    background-color: var(--sd-surface) !important;
    border-bottom-color: var(--sd-border) !important;
    color: var(--sd-dark-text-inverse) !important;
}

.v-theme--dark .inspection-view .leaflet-top.leaflet-left .leaflet-draw-toolbar > a,
.theme--dark .inspection-view .leaflet-top.leaflet-left .leaflet-draw-toolbar > a {
    background-image: linear-gradient(transparent, transparent),
        url('/static/img/leaflet-draw-spritesheet-white.svg') !important;
}

.v-theme--dark .inspection-view .leaflet-top.leaflet-left .easy-button-button *,
.theme--dark .inspection-view .leaflet-top.leaflet-left .easy-button-button * {
    color: var(--sd-dark-text-inverse) !important;
}

.v-theme--dark .inspection-view .leaflet-top.leaflet-left .inspectionImageDownloadButton,
.theme--dark .inspection-view .leaflet-top.leaflet-left .inspectionImageDownloadButton {
    background-image: url('/static/img/download-white.svg') !important;
    background-color: var(--sd-dark-surface-control) !important;
    color: var(--sd-dark-text-inverse) !important;
}

.v-theme--dark .inspection-view .leaflet-top.leaflet-left .hideAutoAnnotationsButton,
.theme--dark .inspection-view .leaflet-top.leaflet-left .hideAutoAnnotationsButton {
    background-color: var(--sd-dark-surface-control) !important;
    background-image: url('/static/img/robot-white.svg') !important;
    color: var(--sd-dark-text-inverse) !important;
}

.v-theme--dark .inspection-view .leaflet-top.leaflet-left .quality-button,
.theme--dark .inspection-view .leaflet-top.leaflet-left .quality-button {
    background-color: var(--sd-dark-surface-control) !important;
    color: var(--sd-dark-text-inverse) !important;
}

.v-theme--dark .inspection-view .leaflet-top.leaflet-left .hideSpotsMap,
.theme--dark .inspection-view .leaflet-top.leaflet-left .hideSpotsMap {
    background-color: var(--sd-dark-surface-control) !important;
    color: var(--sd-dark-text-inverse) !important;
    background-image: url('/static/img/smartview_markers/inspection_marker_white.png') !important;
}

.v-theme--dark .inspection-view .leaflet-top.leaflet-left .findSimilarButton.active,
.theme--dark .inspection-view .leaflet-top.leaflet-left .findSimilarButton.active {
    background-color: var(--sd-surface-soft) !important;
    color: var(--sd-dark-text-inverse) !important;
}

.v-theme--dark .inspection-view .leaflet-top.leaflet-left .hideAutoAnnotationsButton.hidden:after,
.theme--dark .inspection-view .leaflet-top.leaflet-left .hideAutoAnnotationsButton.hidden:after,
.v-theme--dark .inspection-view .leaflet-top.leaflet-left .hideSpotsMap.hidden:after,
.theme--dark .inspection-view .leaflet-top.leaflet-left .hideSpotsMap.hidden:after {
    background: var(--sd-dark-text-inverse) !important;
}

.v-theme--dark .inspection-view .leaflet-draw-actions a,
.theme--dark .inspection-view .leaflet-draw-actions a,
.v-theme--dark .inspection-view .leaflet-draw-tooltip,
.theme--dark .inspection-view .leaflet-draw-tooltip {
    background-color: var(--sd-dark-draw-tooltip-bg) !important;
    border-color: var(--sd-border) !important;
    color: var(--sd-dark-text-inverse) !important;
}

.v-theme--dark .inspection-view .leaflet-draw-tooltip:before,
.theme--dark .inspection-view .leaflet-draw-tooltip:before {
    border-right-color: var(--sd-surface) !important;
}

.v-theme--dark .inspection-view .leaflet-draw-tooltip-subtext,
.theme--dark .inspection-view .leaflet-draw-tooltip-subtext {
    color: var(--sd-dark-text-soft) !important;
}

.v-theme--dark .inspection-view .leaflet-top.leaflet-left .leaflet-bar > a:hover,
.theme--dark .inspection-view .leaflet-top.leaflet-left .leaflet-bar > a:hover,
.v-theme--dark .inspection-view .leaflet-top.leaflet-left .easy-button-button:hover,
.theme--dark .inspection-view .leaflet-top.leaflet-left .easy-button-button:hover,
.v-theme--dark .inspection-view .leaflet-top.leaflet-left .leaflet-draw-toolbar > a:hover,
.theme--dark .inspection-view .leaflet-top.leaflet-left .leaflet-draw-toolbar > a:hover,
.v-theme--dark .inspection-view .leaflet-draw-actions a:hover,
.theme--dark .inspection-view .leaflet-draw-actions a:hover {
    background-color: var(--sd-surface-soft) !important;
    color: var(--sd-dark-text-inverse) !important;
}

.inspection-view .easy-button-button .color-button {
    display: block;
    width: 100%;
    height: 100%;
    border-radius: inherit;
}

.inspection-view .leaflet-control-minimap {
    border: 1px solid var(--sd-dark-border-medium);
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.22);
}

.inspection-view .leaflet-control-minimap-toggle-display {
    background-color: var(--sd-dark-draw-tooltip-bg);
}

.inspection-view #altitudecontainer,
.inspection-view #colorbar-container,
.inspection-view .leaflet-card,
.inspection-view .v-btn-graph {
    box-shadow: 0 14px 30px rgba(15, 23, 42, 0.18);
}

/* --- Review Mode Toggle Button --- */

.inspection-view .inspection-shell__review-toggle {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 4px 10px;
    border: 1px solid var(--sd-primary-border-soft);
    border-radius: 10px;
    background: linear-gradient(180deg, var(--sd-light-surface-selected) 0%, var(--sd-light-primary-surface-strong) 100%);
    color: var(--sd-light-primary-active);
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.01em;
    cursor: pointer;
    white-space: nowrap;
    transition: background 0.15s ease, box-shadow 0.15s ease;
}

.inspection-view .inspection-shell__review-toggle:hover {
    background: linear-gradient(180deg, var(--sd-light-primary-surface-hover) 0%, var(--sd-light-primary-surface-hover-strong) 100%);
    box-shadow: 0 4px 12px rgba(42, 70, 171, 0.12);
}

.inspection-view .inspection-shell__review-toggle-icon {
    color: var(--sd-primary);
    font-size: 13px !important;
}

/* --- Review Mode Grid Switch --- */

.inspection-view .inspection-shell__body--review {
    grid-template-columns: minmax(0, 1fr) minmax(340px, 400px);
}

/* --- Docked Findings Panel --- */

.inspection-view .inspection-findings-panel {
    display: flex;
    flex-direction: column;
    min-height: 0;
    border-radius: 14px;
    background:
        linear-gradient(
            180deg,
            var(--sd-dark-panel-gradient-start) 0%,
            var(--sd-dark-panel-gradient-end) 100%
        );
    border: 1px solid var(--sd-dark-panel-border);
    box-shadow: 0 16px 36px rgba(9, 15, 27, 0.32);
    color: var(--sd-dark-panel-text);
    overflow: hidden;
}

.inspection-view .inspection-findings-panel__header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
    padding: 16px 18px 12px;
    border-bottom: 1px solid var(--sd-dark-panel-border-subtle);
}

.inspection-view .inspection-findings-panel__title {
    margin: 4px 0 0;
    font-family: 'Omnes Medium', 'Inter', sans-serif;
    font-size: 18px;
    font-weight: 700;
    line-height: 1.2;
    color: var(--sd-dark-panel-text);
}

.inspection-view .inspection-findings-panel__subtitle {
    margin: 6px 0 0;
    font-size: 12px;
    line-height: 1.5;
    color: var(--sd-dark-panel-text-subtle);
}

.inspection-view .inspection-findings-panel__close {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border: 1px solid var(--sd-dark-panel-accent-border);
    border-radius: 8px;
    background: var(--sd-dark-panel-surface-raised);
    cursor: pointer;
    transition: background 0.15s ease;
}

.inspection-view .inspection-findings-panel__close:hover {
    background: var(--sd-dark-panel-surface-hover);
}

.inspection-view .inspection-findings-panel__list {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 14px 18px;
}

.inspection-view .inspection-findings-panel__content {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.inspection-view .inspection-findings-panel__detail,
.inspection-view .inspection-findings-panel__queue {
    display: flex;
    flex-direction: column;
    gap: 14px;
    padding: 14px;
    border-radius: 14px;
    background: var(--sd-dark-panel-surface);
    border: 1px solid var(--sd-dark-panel-border-subtle);
}

.inspection-view .inspection-findings-panel__detail-header,
.inspection-view .inspection-findings-panel__queue-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
}

.inspection-view .inspection-findings-panel__detail-copy {
    min-width: 0;
}

.inspection-view .inspection-findings-panel__detail-title-row {
    display: flex;
    align-items: center;
    gap: 10px;
}

.inspection-view .inspection-findings-panel__detail-title {
    margin: 0;
    font-size: 16px;
    line-height: 1.3;
    color: var(--sd-dark-panel-text);
}

.inspection-view .inspection-findings-panel__severity-dot {
    flex: 0 0 auto;
    width: 10px;
    height: 10px;
    border-radius: 999px;
    box-shadow: 0 0 0 3px var(--sd-dark-panel-surface);
}

.inspection-view .inspection-findings-panel__detail-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 10px;
}

.inspection-view .inspection-findings-panel__detail-tag {
    display: inline-flex;
    align-items: center;
    padding: 4px 8px;
    border-radius: 999px;
    background: var(--sd-dark-panel-surface-raised);
    border: 1px solid var(--sd-dark-panel-accent-border);
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: var(--sd-dark-panel-text-secondary);
}

.inspection-view .inspection-findings-panel__detail-tag--ai {
    color: var(--sd-dark-panel-accent);
    border-color: var(--sd-dark-panel-accent-border-medium);
}

.inspection-view .inspection-findings-panel__detail-tag--manual {
    color: var(--sd-dark-text-secondary);
}

.inspection-view .inspection-findings-panel__detail-context {
    margin: 10px 0 0;
    font-size: 12px;
    line-height: 1.5;
    color: var(--sd-dark-panel-text-subtle);
}

.inspection-view .inspection-findings-panel__focus-button {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 8px 12px;
    border: 1px solid var(--sd-dark-panel-accent-border-soft);
    border-radius: 10px;
    background: var(--sd-dark-panel-selected-surface);
    color: var(--sd-dark-panel-text);
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.15s ease, border-color 0.15s ease;
}

.inspection-view .inspection-findings-panel__focus-button:hover {
    background: var(--sd-dark-panel-selected-surface-hover);
    border-color: var(--sd-dark-panel-accent-border-hover);
}

.inspection-view .inspection-findings-panel__focus-button-icon {
    color: var(--sd-dark-panel-accent) !important;
}

.inspection-view .inspection-findings-panel__preview {
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    min-height: 170px;
    border-radius: 12px;
    background: var(--sd-dark-panel-preview-bg);
    border: 1px solid var(--sd-dark-panel-border-subtle);
}

.inspection-view .inspection-findings-panel__preview-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.inspection-view .inspection-findings-panel__preview--empty {
    flex-direction: column;
    gap: 10px;
    color: var(--sd-dark-panel-text-muted);
    font-size: 13px;
}

.inspection-view .inspection-findings-panel__metrics {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 10px;
}

.inspection-view .inspection-findings-panel__metric {
    padding: 10px 12px;
    border-radius: 10px;
    background: var(--sd-dark-panel-surface);
    border: 1px solid var(--sd-dark-panel-border-faint);
}

.inspection-view .inspection-findings-panel__metric-label {
    display: block;
    margin-bottom: 6px;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--sd-dark-panel-text-muted);
}

.inspection-view .inspection-findings-panel__queue-title {
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--sd-dark-text-secondary);
}

.inspection-view .inspection-findings-panel__queue-count {
    font-size: 12px;
    font-weight: 600;
    color: var(--sd-dark-panel-accent);
}

.inspection-view .inspection-findings-panel__items {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.inspection-view .inspection-findings-panel__queue-empty {
    padding: 14px;
    border: 1px dashed var(--sd-dark-panel-border-dashed);
    border-radius: 12px;
    color: var(--sd-dark-panel-text-muted);
    font-size: 13px;
    line-height: 1.5;
    text-align: center;
}

.inspection-view .inspection-findings-panel__item {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 10px 12px;
    border: 1px solid var(--sd-dark-panel-border-faint);
    border-radius: 12px;
    background: var(--sd-dark-panel-surface-subtle);
    color: inherit;
    text-align: left;
    cursor: pointer;
    transition: background 0.15s ease, border-color 0.15s ease,
        transform 0.15s ease;
}

.inspection-view .inspection-findings-panel__item:hover {
    background: var(--sd-dark-panel-surface-muted);
    border-color: var(--sd-dark-panel-accent-border-soft);
}

.inspection-view .inspection-findings-panel__item--selected {
    background: var(--sd-dark-panel-selected-surface);
    border-color: var(--sd-dark-panel-accent-border-strong);
    transform: translateX(2px);
}

.inspection-view .inspection-findings-panel__item-copy {
    flex: 1;
    min-width: 0;
}

.inspection-view .inspection-findings-panel__item-label {
    display: block;
    color: var(--sd-dark-panel-text);
    font-size: 13px;
    line-height: 1.4;
}

.inspection-view .inspection-findings-panel__item-meta {
    display: block;
    margin-top: 2px;
    font-size: 12px;
    color: var(--sd-dark-panel-text-subtle);
}

.inspection-view .inspection-findings-panel__item-context {
    display: block;
    margin-top: 4px;
    font-size: 11px;
    line-height: 1.45;
    color: var(--sd-dark-text-secondary);
}

.inspection-view .inspection-findings-panel__empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 48px 24px;
    text-align: center;
}

.inspection-view .inspection-findings-panel__empty-title {
    margin: 0;
    font-size: 15px;
    font-weight: 600;
    color: var(--sd-dark-panel-text-secondary);
}

.inspection-view .inspection-findings-panel__empty-hint {
    margin: 0;
    font-size: 13px;
    line-height: 1.5;
    color: var(--sd-dark-panel-text-muted);
    max-width: 240px;
}

.inspection-view .inspection-findings-panel__footer {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 18px;
    border-top: 1px solid var(--sd-dark-panel-border-faint);
}

.inspection-view .inspection-findings-panel__footer-label {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--sd-dark-text-secondary);
}

@media only screen and (max-width: 1600px) {
    .inspection-view .inspection-shell__body--context {
        grid-template-columns: minmax(0, 1fr) 240px;
    }

    .inspection-view .inspection-shell__body--review {
        grid-template-columns: minmax(0, 1fr) minmax(300px, 360px);
    }
}

@media only screen and (max-width: 1320px) {
    .inspection-view .inspection-shell__body--context {
        grid-template-columns: 1fr;
    }

    .inspection-view .inspection-context-rail {
        display: none;
    }

    .inspection-view .inspection-shell__body--review {
        grid-template-columns: 1fr;
    }

    .inspection-view .inspection-findings-panel {
        max-height: 320px;
    }

    .inspection-view .inspection-findings-panel__metrics {
        grid-template-columns: 1fr;
    }
}

@media only screen and (max-width: 1000px) {
    .inspection-view .inspection-shell__header {
        padding: 10px 14px;
    }

    .inspection-view .inspection-shell__title {
        font-size: 18px;
    }

    .inspection-view .inspection-gallery__toolbar {
        flex-wrap: wrap;
    }
}

/* One dataset-scoped Context rail serves all visible viewer panes. */
.inspection-shared-rail-host {
    display: contents;
}

.inspection-shared-rail-host--active {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 12;
    display: flex;
    min-height: 0;
    padding: 0;
    border-left: 1px solid var(--sd-border);
    box-shadow: -12px 0 28px rgba(9, 15, 27, 0.18);
    width: var(--smartview-active-rail-width);
}

.inspection-shared-rail-host--context {
    --smartview-active-rail-width: var(--smartview-context-rail-width);
}

.inspection-shared-rail-host--review {
    --smartview-active-rail-width: var(--smartview-review-rail-width);
}

.inspection-shared-rail-host--active .inspection-context-rail,
.inspection-shared-rail-host--active .inspection-findings-panel {
    display: flex;
    width: 100%;
    height: 100%;
    max-height: none;
    border: 0;
    border-radius: 0;
    box-shadow: none;
}

/* ==========================================================================
   PLATFORM SHELL — Figma Design System Parity
   Source: Figma "Smartdata Design System" node 895:14743, 895:14192
   Overrides existing app-bar rules at lines 403, 565, 840 via higher
   specificity (element + two classes beats element + one class).
   ========================================================================== */

/* --- Blue top nav bar (72px, solid brand primary) --- */

header.v-app-bar.nd-shell-bar {
    --sd-border: var(--sd-light-border);
    --sd-text: var(--sd-shell-text);
    --sd-text-secondary: var(--sd-shell-text-secondary);
    background-color: var(--sd-primary) !important;
    backdrop-filter: none !important;
    border: none !important;
    box-shadow: none !important;
}

header.v-app-bar.nd-shell-bar .v-toolbar__content {
    height: 72px !important;
    align-items: center;
}

/* Dark mode: bar stays blue */
.v-theme--dark header.v-app-bar.nd-shell-bar,
.theme--dark header.v-app-bar.nd-shell-bar,
html.theme--dark header.v-app-bar.nd-shell-bar,
body.theme--dark header.v-app-bar.nd-shell-bar {
    background-color: var(--sd-primary) !important;
    box-shadow: none !important;
}

/* --- White contextual sub-bar (extension slot, 56px) --- */

header.v-app-bar.nd-shell-bar .v-toolbar__extension {
    background: var(--sd-light-surface);
    box-shadow: 0 2px 4px rgba(63, 75, 97, 0.12);
    padding: 0 16px !important;
}

.v-theme--dark header.v-app-bar.nd-shell-bar .v-toolbar__extension,
.theme--dark header.v-app-bar.nd-shell-bar .v-toolbar__extension,
html.theme--dark header.v-app-bar.nd-shell-bar .v-toolbar__extension,
body.theme--dark header.v-app-bar.nd-shell-bar .v-toolbar__extension {
    background: var(--sd-surface) !important;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.28);
}

header.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-subbar {
    display: flex;
    align-items: stretch;
    width: 100%;
    min-height: 56px;
}

header.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-subbar__segment {
    position: relative;
    display: flex;
    align-items: stretch;
    flex: 0 1 auto;
    min-width: 0;
    height: 56px;
}

header.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-selector {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 4px;
    width: 100%;
    min-width: 0;
    height: 56px;
    padding: 8px 32px 8px 12px;
    background: transparent;
    border: none;
    border-radius: 0;
    appearance: none;
    -webkit-appearance: none;
    color: var(--sd-text, var(--sd-shell-text));
    cursor: pointer;
    text-align: left;
    opacity: 1 !important;
}

header.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-selector__label {
    color: var(--sd-text-secondary, var(--sd-shell-text-secondary));
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.06em;
    line-height: 1;
    opacity: 1 !important;
    text-transform: uppercase;
}

header.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-selector__value {
    display: block;
    width: 100%;
    min-width: 0;
    overflow: hidden;
    color: var(--sd-text, var(--sd-shell-text));
    -webkit-text-fill-color: var(--sd-text, var(--sd-shell-text));
    font-family: 'Omnes Medium', 'Omnes', Roboto, sans-serif;
    font-size: 18px;
    font-weight: 600;
    line-height: 1.2;
    opacity: 1 !important;
    text-overflow: ellipsis;
    white-space: nowrap;
}

header.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-selector__icon {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: var(--sd-text-secondary, var(--sd-shell-text-secondary));
    opacity: 1 !important;
}

header.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-selector__spinner {
    position: absolute;
    right: 28px;
    top: 50%;
    transform: translateY(-50%);
}

.v-theme--dark header.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-selector,
.theme--dark header.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-selector,
html.theme--dark header.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-selector,
body.theme--dark header.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-selector {
    color: var(--sd-dark-text) !important;
}

.v-theme--dark header.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-selector__label,
.theme--dark header.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-selector__label,
html.theme--dark header.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-selector__label,
body.theme--dark header.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-selector__label {
    color: var(--sd-dark-text) !important;
    -webkit-text-fill-color: var(--sd-dark-text) !important;
}

.v-theme--dark header.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-selector__value,
.theme--dark header.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-selector__value,
html.theme--dark header.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-selector__value,
body.theme--dark header.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-selector__value {
    color: var(--sd-dark-text) !important;
    -webkit-text-fill-color: var(--sd-dark-text) !important;
}

.v-theme--dark header.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-selector__icon,
.theme--dark header.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-selector__icon,
html.theme--dark header.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-selector__icon,
body.theme--dark header.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-selector__icon {
    color: var(--sd-dark-text-secondary) !important;
    opacity: 1 !important;
}

header.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-subbar__input {
    display: flex;
    align-items: stretch;
    width: 100%;
    min-width: 0;
    height: 56px;
}

header.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-subbar__input--active .v-input,
header.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-subbar__input--active .nd-shell-subbar__selector-control {
    width: 100%;
    max-width: 100% !important;
}

/* Sub-bar text colors: inherit from theme, not from blue bar */
header.v-app-bar.nd-shell-bar .v-toolbar__extension .v-field__input,
header.v-app-bar.nd-shell-bar .v-toolbar__extension .v-field__input input,
header.v-app-bar.nd-shell-bar .v-toolbar__extension .v-field__input input::placeholder,
header.v-app-bar.nd-shell-bar .v-toolbar__extension .v-select__selection,
header.v-app-bar.nd-shell-bar .v-toolbar__extension .v-select__selection-text,
header.v-app-bar.nd-shell-bar .v-toolbar__extension .v-field__field input,
header.v-app-bar.nd-shell-bar .v-toolbar__extension .v-field label,
header.v-app-bar.nd-shell-bar .v-toolbar__extension .v-field-label,
header.v-app-bar.nd-shell-bar .v-toolbar__extension .v-autocomplete input {
    color: var(--sd-text, var(--sd-light-text)) !important;
    -webkit-text-fill-color: var(--sd-text, var(--sd-light-text)) !important;
    opacity: 1 !important;
}

header.v-app-bar.nd-shell-bar .v-toolbar__extension .v-input {
    margin: 0 !important;
}

header.v-app-bar.nd-shell-bar .v-toolbar__extension .v-field,
header.v-app-bar.nd-shell-bar .v-toolbar__extension .v-field--variant-filled,
header.v-app-bar.nd-shell-bar .v-toolbar__extension .v-field--variant-outlined,
header.v-app-bar.nd-shell-bar .v-toolbar__extension .v-input__control,
header.v-app-bar.nd-shell-bar .v-toolbar__extension .v-text-field .v-field {
    background: transparent !important;
    border: none !important;
    border-radius: 0 !important;
    box-shadow: none !important;
}

header.v-app-bar.nd-shell-bar .v-toolbar__extension .v-field__overlay,
header.v-app-bar.nd-shell-bar .v-toolbar__extension .v-field__underlay,
header.v-app-bar.nd-shell-bar .v-toolbar__extension .v-field::before,
header.v-app-bar.nd-shell-bar .v-toolbar__extension .v-field::after,
header.v-app-bar.nd-shell-bar .v-toolbar__extension .v-field__outline {
    display: none !important;
    opacity: 0 !important;
}

header.v-app-bar.nd-shell-bar .v-toolbar__extension .v-field__field,
header.v-app-bar.nd-shell-bar .v-toolbar__extension .v-field__input {
    min-height: 56px !important;
}

header.v-app-bar.nd-shell-bar .v-toolbar__extension .v-field__input,
header.v-app-bar.nd-shell-bar .v-toolbar__extension .v-select__selection-text,
header.v-app-bar.nd-shell-bar .v-toolbar__extension .v-select__selection {
    font-family: 'Omnes Medium', 'Omnes', Roboto, sans-serif !important;
    font-size: 18px !important;
    font-weight: 600 !important;
    line-height: 1.2 !important;
    color: var(--sd-text, var(--sd-shell-text)) !important;
    -webkit-text-fill-color: var(--sd-text, var(--sd-shell-text)) !important;
}

header.v-app-bar.nd-shell-bar .v-toolbar__extension .v-label {
    color: var(--sd-text-secondary, var(--sd-light-text-secondary)) !important;
    font-size: 11px !important;
    letter-spacing: 0.06em !important;
    opacity: 1 !important;
    text-transform: uppercase;
}

header.v-app-bar.nd-shell-bar .v-toolbar__extension .v-field-label,
header.v-app-bar.nd-shell-bar .v-toolbar__extension .v-label {
    color: var(--sd-text-secondary, var(--sd-light-text-secondary)) !important;
    opacity: 1 !important;
}

header.v-app-bar.nd-shell-bar .v-toolbar__extension .v-input--disabled,
header.v-app-bar.nd-shell-bar .v-toolbar__extension .v-input--disabled .v-field__input,
header.v-app-bar.nd-shell-bar .v-toolbar__extension .v-input--disabled .v-select__selection,
header.v-app-bar.nd-shell-bar .v-toolbar__extension .v-input--disabled .v-select__selection-text,
header.v-app-bar.nd-shell-bar .v-toolbar__extension .v-input--disabled .v-label,
header.v-app-bar.nd-shell-bar .v-toolbar__extension .v-input--disabled .v-field-label {
    color: var(--sd-text-secondary, var(--sd-light-text-secondary)) !important;
    -webkit-text-fill-color: var(--sd-text-secondary, var(--sd-light-text-secondary)) !important;
    opacity: 1 !important;
}

header.v-app-bar.nd-shell-bar .v-toolbar__extension .v-field__append-inner .v-icon,
header.v-app-bar.nd-shell-bar .v-toolbar__extension .v-field__clearable .v-icon,
header.v-app-bar.nd-shell-bar .v-toolbar__extension .v-field__prepend-inner .v-icon,
header.v-app-bar.nd-shell-bar .v-toolbar__extension .v-select__menu-icon {
    color: var(--sd-text-secondary, var(--sd-light-text-secondary)) !important;
    opacity: 0.9 !important;
}

header.v-app-bar.nd-shell-bar .v-toolbar__extension .top-page-site-select,
header.v-app-bar.nd-shell-bar .v-toolbar__extension .top-page-view-select,
header.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-subbar__selector-control {
    align-self: stretch;
}

header.v-app-bar.nd-shell-bar .v-toolbar__extension .v-divider--vertical {
    border-color: var(--sd-border, var(--sd-light-border)) !important;
}

.nd-shell-dropdown-menu,
.v-overlay__content.nd-shell-dropdown-menu,
.v-menu__content.nd-shell-dropdown-menu {
    background: var(--sd-light-surface) !important;
    border: 1px solid var(--sd-border, var(--sd-light-border));
    border-radius: 14px !important;
    box-shadow: 0 18px 40px rgba(17, 27, 50, 0.18) !important;
    color: var(--sd-text, var(--sd-shell-text)) !important;
    overflow: hidden;
}

.v-theme--dark .nd-shell-dropdown-menu,
.theme--dark .nd-shell-dropdown-menu,
html.theme--dark .nd-shell-dropdown-menu,
body.theme--dark .nd-shell-dropdown-menu,
.v-theme--dark .v-overlay__content.nd-shell-dropdown-menu,
.theme--dark .v-overlay__content.nd-shell-dropdown-menu,
html.theme--dark .v-overlay__content.nd-shell-dropdown-menu,
body.theme--dark .v-overlay__content.nd-shell-dropdown-menu,
.v-theme--dark .v-menu__content.nd-shell-dropdown-menu,
.theme--dark .v-menu__content.nd-shell-dropdown-menu,
html.theme--dark .v-menu__content.nd-shell-dropdown-menu,
body.theme--dark .v-menu__content.nd-shell-dropdown-menu {
    background: var(--sd-surface) !important;
    border-color: var(--sd-border, var(--sd-light-border));
    box-shadow: 0 18px 40px rgba(0, 0, 0, 0.32) !important;
}

.nd-shell-dropdown-menu .v-list,
.v-overlay__content.nd-shell-dropdown-menu .v-list,
.v-menu__content.nd-shell-dropdown-menu .v-list {
    background: var(--sd-light-surface) !important;
    color: var(--sd-text, var(--sd-shell-text)) !important;
    padding: 8px 0;
}

.v-theme--dark .nd-shell-dropdown-menu .v-list,
.theme--dark .nd-shell-dropdown-menu .v-list,
html.theme--dark .nd-shell-dropdown-menu .v-list,
body.theme--dark .nd-shell-dropdown-menu .v-list,
.v-theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list,
.theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list,
html.theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list,
body.theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list,
.v-theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list,
.theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list,
html.theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list,
body.theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list {
    background: var(--sd-surface) !important;
}

.nd-shell-dropdown-menu .v-list-item,
.nd-shell-dropdown-menu .v-list-item-title,
.nd-shell-dropdown-menu .v-list-item-subtitle,
.nd-shell-dropdown-menu .v-list-item__prepend .v-icon,
.nd-shell-dropdown-menu .v-list-item__append .v-icon,
.v-overlay__content.nd-shell-dropdown-menu .v-list-item,
.v-overlay__content.nd-shell-dropdown-menu .v-list-item-title,
.v-overlay__content.nd-shell-dropdown-menu .v-list-item-subtitle,
.v-overlay__content.nd-shell-dropdown-menu .v-list-item__prepend .v-icon,
.v-overlay__content.nd-shell-dropdown-menu .v-list-item__append .v-icon,
.v-menu__content.nd-shell-dropdown-menu .v-list-item,
.v-menu__content.nd-shell-dropdown-menu .v-list-item-title,
.v-menu__content.nd-shell-dropdown-menu .v-list-item-subtitle,
.v-menu__content.nd-shell-dropdown-menu .v-list-item__prepend .v-icon,
.v-menu__content.nd-shell-dropdown-menu .v-list-item__append .v-icon {
    color: var(--sd-text, var(--sd-shell-text)) !important;
    opacity: 1 !important;
}

.nd-shell-dropdown-menu .v-list-item,
.v-overlay__content.nd-shell-dropdown-menu .v-list-item,
.v-menu__content.nd-shell-dropdown-menu .v-list-item {
    min-height: 48px;
}

.v-theme--dark .nd-shell-dropdown-menu .v-list-item,
.theme--dark .nd-shell-dropdown-menu .v-list-item,
html.theme--dark .nd-shell-dropdown-menu .v-list-item,
body.theme--dark .nd-shell-dropdown-menu .v-list-item,
.v-theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list-item,
.theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list-item,
html.theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list-item,
body.theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list-item,
.v-theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list-item,
.theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list-item,
html.theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list-item,
body.theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list-item {
    color: var(--sd-text) !important;
}

.nd-shell-dropdown-menu .v-list-item-subtitle,
.v-overlay__content.nd-shell-dropdown-menu .v-list-item-subtitle,
.v-menu__content.nd-shell-dropdown-menu .v-list-item-subtitle {
    color: var(--sd-text-secondary, var(--sd-shell-text-secondary)) !important;
}

.nd-shell-dropdown-menu .v-list-item--disabled,
.v-overlay__content.nd-shell-dropdown-menu .v-list-item--disabled,
.v-menu__content.nd-shell-dropdown-menu .v-list-item--disabled {
    opacity: 0.42 !important;
}

.nd-shell-dropdown-menu .v-list-item--active,
.nd-shell-dropdown-menu .v-list-item:hover,
.v-overlay__content.nd-shell-dropdown-menu .v-list-item--active,
.v-overlay__content.nd-shell-dropdown-menu .v-list-item:hover,
.v-menu__content.nd-shell-dropdown-menu .v-list-item--active,
.v-menu__content.nd-shell-dropdown-menu .v-list-item:hover {
    background: var(--sd-light-primary-surface) !important;
}

.v-theme--dark .nd-shell-dropdown-menu .v-list-item--active,
.v-theme--dark .nd-shell-dropdown-menu .v-list-item:hover,
.theme--dark .nd-shell-dropdown-menu .v-list-item--active,
.theme--dark .nd-shell-dropdown-menu .v-list-item:hover,
html.theme--dark .nd-shell-dropdown-menu .v-list-item--active,
html.theme--dark .nd-shell-dropdown-menu .v-list-item:hover,
body.theme--dark .nd-shell-dropdown-menu .v-list-item--active,
body.theme--dark .nd-shell-dropdown-menu .v-list-item:hover,
.v-theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list-item--active,
.v-theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list-item:hover,
.theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list-item--active,
.theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list-item:hover,
html.theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list-item--active,
html.theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list-item:hover,
body.theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list-item--active,
body.theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list-item:hover,
.v-theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list-item--active,
.v-theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list-item:hover,
.theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list-item--active,
.theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list-item:hover,
html.theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list-item--active,
html.theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list-item:hover,
body.theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list-item--active,
body.theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list-item:hover {
    background: var(--sd-surface-soft) !important;
    color: var(--sd-text) !important;
}

.v-theme--dark .nd-shell-dropdown-menu .v-list-item--active .v-list-item-title,
.v-theme--dark .nd-shell-dropdown-menu .v-list-item:hover .v-list-item-title,
.theme--dark .nd-shell-dropdown-menu .v-list-item--active .v-list-item-title,
.theme--dark .nd-shell-dropdown-menu .v-list-item:hover .v-list-item-title,
html.theme--dark .nd-shell-dropdown-menu .v-list-item--active .v-list-item-title,
html.theme--dark .nd-shell-dropdown-menu .v-list-item:hover .v-list-item-title,
body.theme--dark .nd-shell-dropdown-menu .v-list-item--active .v-list-item-title,
body.theme--dark .nd-shell-dropdown-menu .v-list-item:hover .v-list-item-title,
.v-theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list-item--active .v-list-item-title,
.v-theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list-item:hover .v-list-item-title,
.theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list-item--active .v-list-item-title,
.theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list-item:hover .v-list-item-title,
html.theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list-item--active .v-list-item-title,
html.theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list-item:hover .v-list-item-title,
body.theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list-item--active .v-list-item-title,
body.theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list-item:hover .v-list-item-title,
.v-theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list-item--active .v-list-item-title,
.v-theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list-item:hover .v-list-item-title,
.theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list-item--active .v-list-item-title,
.theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list-item:hover .v-list-item-title,
html.theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list-item--active .v-list-item-title,
html.theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list-item:hover .v-list-item-title,
body.theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list-item--active .v-list-item-title,
body.theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list-item:hover .v-list-item-title {
    color: var(--sd-text) !important;
}

.nd-shell-dropdown-menu .v-btn {
    box-shadow: none !important;
    transform: none !important;
}

.nd-shell-view-menu {
    min-width: 300px;
    contain: none !important;
    isolation: isolate;
}

.nd-shell-view-list {
    min-width: 300px;
    position: relative;
    z-index: 0;
}

.nd-shell-view-option {
    position: relative;
    isolation: isolate;
    padding-left: 14px !important;
    padding-right: 14px !important;
}

.nd-shell-view-option .v-list-item__overlay,
.nd-shell-view-option .v-list-item__underlay {
    display: none !important;
    background: transparent !important;
    opacity: 0 !important;
}

.nd-shell-view-option--selected {
    background: var(--sd-light-primary-surface) !important;
}

.v-theme--dark .nd-shell-view-option--selected,
.theme--dark .nd-shell-view-option--selected,
html.theme--dark .nd-shell-view-option--selected,
body.theme--dark .nd-shell-view-option--selected {
    background: var(--sd-surface-soft) !important;
}

.v-theme--dark .nd-shell-view-option--selected .nd-shell-view-option__title,
.theme--dark .nd-shell-view-option--selected .nd-shell-view-option__title,
html.theme--dark .nd-shell-view-option--selected .nd-shell-view-option__title,
body.theme--dark .nd-shell-view-option--selected .nd-shell-view-option__title,
.v-theme--dark .nd-shell-view-option--selected .nd-shell-view-option__icon,
.theme--dark .nd-shell-view-option--selected .nd-shell-view-option__icon,
html.theme--dark .nd-shell-view-option--selected .nd-shell-view-option__icon,
body.theme--dark .nd-shell-view-option--selected .nd-shell-view-option__icon,
.v-theme--dark .nd-shell-view-option--selected .v-list-item-title,
.theme--dark .nd-shell-view-option--selected .v-list-item-title,
html.theme--dark .nd-shell-view-option--selected .v-list-item-title,
body.theme--dark .nd-shell-view-option--selected .v-list-item-title,
.v-theme--dark .v-overlay__content.nd-shell-dropdown-menu .nd-shell-view-option--selected .v-list-item-title,
.theme--dark .v-overlay__content.nd-shell-dropdown-menu .nd-shell-view-option--selected .v-list-item-title,
html.theme--dark .v-overlay__content.nd-shell-dropdown-menu .nd-shell-view-option--selected .v-list-item-title,
body.theme--dark .v-overlay__content.nd-shell-dropdown-menu .nd-shell-view-option--selected .v-list-item-title {
    color: var(--sd-light-text-strong) !important;
    -webkit-text-fill-color: var(--sd-light-text-strong) !important;
}

.nd-shell-view-option--empty {
    cursor: default;
}

.nd-shell-view-option__row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    width: 100%;
    min-width: 0;
    position: relative;
    z-index: 1;
}

.nd-shell-view-option__main {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
    flex: 1 1 auto;
    position: relative;
    z-index: 1;
}

.nd-shell-view-option__icon {
    flex: 0 0 auto;
    color: var(--sd-shell-icon-muted) !important;
    backface-visibility: hidden;
    opacity: 1 !important;
}

.nd-shell-view-option__title {
    color: var(--sd-text, var(--sd-shell-text));
    -webkit-text-fill-color: var(--sd-text, var(--sd-shell-text)) !important;
    backface-visibility: hidden;
    display: block;
    font-family: 'Omnes Medium', 'Omnes', Roboto, sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.2;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-shadow: 0 0 0 currentColor;
    opacity: 1 !important;
}

.nd-shell-view-option__actions {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    flex: 0 0 auto;
}

.nd-shell-view-option__action {
    min-width: 40px !important;
}

/* --- Desktop navigation links --- */

.nd-nav-links {
    display: flex;
    align-items: center;
    gap: 28px;
    margin-left: 24px;
}

.nd-nav-link {
    font-family: 'Omnes Medium', 'Omnes', Roboto, sans-serif;
    font-size: 18px;
    color: var(--sd-shell-nav-text);
    text-decoration: none;
    white-space: nowrap;
    transition: color 0.15s ease;
    line-height: 72px;
}

.nd-nav-link:hover {
    color: var(--sd-shell-nav-text-active);
}

.nd-nav-link--active {
    color: var(--sd-shell-nav-text-active);
    font-family: 'Omnes Medium', 'Omnes', Roboto, sans-serif;
}

/* --- Shell right-side controls --- */

.nd-shell-avatar {
    border: 2px solid var(--sd-shell-avatar-border);
}

.nd-shell-more-btn.v-btn {
    color: var(--sd-shell-control-text) !important;
}

.nd-shell-more-btn.v-btn:hover {
    color: var(--sd-shell-nav-text-active) !important;
}

.nd-shell-help-btn.v-btn {
    color: var(--sd-shell-control-text) !important;
}

.nd-shell-help-btn.v-btn:hover {
    color: var(--sd-shell-nav-text-active) !important;
}

/* --- Responsive rules --- */

/* Mobile: hide nav links, keep hamburger */
@media (max-width: 959.98px) {
    .nd-nav-links {
        display: none !important;
    }

    .nd-shell-more-menu {
        display: none !important;
    }
}

/* Desktop: hide hamburger, show nav links */
@media (min-width: 960px) {
    header.v-app-bar.nd-shell-bar .v-app-bar-nav-icon {
        display: none !important;
    }
}

/* --- White logo on blue bar --- */

.nd-shell-logo {
    max-height: 30px;
    vertical-align: middle;
    display: block;
}

/* ND-1324: common controls use the existing selector row. */
.nd-annotation-toolbar {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex: 1 1 690px;
    min-width: 210px;
    max-width: 100%;
}
.nd-annotation-toolbar:empty { display: none; }
.nd-shell-subbar:has(.nd-annotation-toolbar:not(:empty)) > .v-spacer { flex: 0 0 auto !important; }
.annotation-toolbar-host {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 6px;
    min-width: 0;
    color: var(--sd-text);
    height: 56px;
}
.annotation-toolbar-host__owner { display: flex; align-items: center; gap: 4px; white-space: nowrap; font-size: 12px; }
.annotation-toolbar-host__tools { min-width: 0; }
.annotation-toolbar-host .cesium-viewer-menu-toolbar { position: static; gap: 0; }
.annotation-toolbar-host .viewer-primary-tools,
.annotation-toolbar-host__compact .viewer-primary-tools {
    display: flex;
    align-items: center;
    gap: 2px;
    padding: 0;
    min-height: 40px;
    border: 0;
    box-shadow: none;
    background: var(--sd-surface);
    backdrop-filter: none;
}
.annotation-toolbar-host .viewer-tool-button,
.annotation-toolbar-host__compact .viewer-tool-button { min-width: 0; padding: 0 8px; height: 38px; color: var(--sd-text); background: transparent; text-transform: none; letter-spacing: 0; border: 0; }
.annotation-toolbar-host .viewer-tool-button--active,
.annotation-toolbar-host__compact .viewer-tool-button--active { color: var(--sd-light-text-inverse); background: var(--sd-primary); }
.annotation-toolbar-host .viewer-mode-indicator,
.annotation-toolbar-status { position: absolute; width: 1px; height: 1px; overflow: hidden; clip-path: inset(50%); white-space: nowrap; }
.annotation-toolbar-host__compact { padding: 8px; max-width: min(440px, calc(100vw - 24px)); background: var(--sd-surface); color: var(--sd-text); }
.annotation-toolbar-host__compact .viewer-primary-tools { flex-wrap: wrap; }
/* Menus and dialogs can render outside the toolbar through a Vue teleport. */
:is(.annotation-toolbar-host, .annotation-toolbar-host__compact,
    .viewer-tool-menu, .viewer-more-menu, .top-menu-submenu,
    .annotation-pane-menu, .viewer-settings-menu, .annotation-form-root,
    .inspection-annotation-dialog, .entity-control-buttons) {
    font-family: 'Omnes Regular', Omnes, sans-serif;
}
:is(.annotation-toolbar-host, .annotation-toolbar-host__compact,
    .viewer-tool-menu, .viewer-more-menu, .top-menu-submenu,
    .annotation-pane-menu, .viewer-settings-menu, .annotation-form-root,
    .inspection-annotation-dialog, .entity-control-buttons)
:is(.v-btn__content, .v-list-item-title, .v-list-item-subtitle,
    .v-list-subheader, .v-label, .v-field__input, input, textarea) {
    font-family: inherit !important;
}
.annotation-toolbar-host__compact .cesium-viewer-menu-toolbar { position: static; }
.annotation-toolbar-host__compact .viewer-mode-indicator { display: none; }

/* The source-photo panel reserves space instead of covering the canvas. */
.inspection-view .inspection-canvas-stage { display: flex; flex-direction: column; }
.inspection-map-stage { position: relative; display: flex; flex-direction: column; flex: 1 1 auto; min-height: 90px; overflow: hidden; }
.inspection-map-canvas { position: relative; display: flex; flex-direction: column; flex: 1 1 auto; min-height: 90px; min-width: 0; }
.inspection-map-canvas__map { flex: 1 1 auto; min-height: 0; height: 100%; width: 100%; }
.inspection-map-canvas .inspection-annotation-launcher { display: none; }
.inspection-view .inspection-gallery-root {
    position: relative;
    order: 2;
    flex: 0 0 auto;
    left: auto;
    right: auto;
    bottom: auto;
    padding: 0 6px;
    pointer-events: auto;
    z-index: auto;
}
.inspection-view .inspection-source-photos {
    position: relative;
    left: auto;
    right: auto;
    bottom: auto;
    display: flex;
    flex-direction: column;
    min-height: 0;
    margin: 0 0 4px;
    overflow: visible;
    box-shadow: none;
}
.inspection-view .inspection-source-photos__header {
    flex: 0 0 auto;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px 10px;
    padding: 6px 8px;
    border-right: 0;
}
.inspection-view .inspection-source-photos__title-group { flex-direction: row; align-items: baseline; flex-wrap: wrap; }
.inspection-source-photos__toggle { margin-left: auto; padding: 4px 6px; border: 1px solid var(--sd-border); border-radius: 5px; color: var(--sd-text); background: var(--sd-surface-soft); font-size: 12px; }
.inspection-view .inspection-source-photos__legend { flex: 0 0 auto; padding: 4px 8px; }
.inspection-view .inspection-source-photos__status { max-height: 64px; overflow-y: auto; padding: 4px 8px; font-size: 12px; overflow-wrap: anywhere; border-top: 1px solid var(--sd-border); }
.inspection-view .inspection-source-photos__list {
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 6px;
    padding: 6px;
    overflow: visible;
}
.inspection-view .inspection-source-photos__candidate { width: 100%; flex: none; }
.inspection-view .inspection-source-photos__filename { white-space: normal; overflow-wrap: anywhere; text-overflow: clip; font-size: 11px; }
.inspection-view .inspection-gallery__toggle,
.inspection-view .inspection-gallery { position: relative; left: auto; right: auto; bottom: auto; width: 100%; }
.inspection-view .inspection-gallery__toggle { padding: 8px; }
.inspection-workspace-status,
.cesium-workspace-status {
    order: 1;
    flex: 0 0 auto;
    display: flex;
    gap: 8px;
    max-height: 76px;
    overflow-y: auto;
    padding: 6px 10px;
    background: var(--sd-surface);
    color: var(--sd-text);
    border-top: 1px solid var(--sd-border);
    font-size: 12px;
    overflow-wrap: anywhere;
}
.inspection-workspace-status span,
.cesium-workspace-status span { flex: 1; }
.inspection-workspace-status button,
.cesium-workspace-status button { align-self: flex-start; }
.inspection-source-photos__toggle:focus-visible,
.inspection-source-photos__candidate:focus-visible {
    outline: 2px solid var(--sd-primary);
    outline-offset: 2px;
}
@media (max-width: 1100px) {
    .inspection-view .inspection-source-photos__list { grid-template-columns: repeat(3, minmax(0, 1fr)); }
    .annotation-toolbar-host__owner > span { position: absolute; width: 1px; height: 1px; overflow: hidden; clip-path: inset(50%); }
    .nd-annotation-toolbar { min-width: 168px; }
}
@media (max-width: 760px) {
    .inspection-view .inspection-source-photos__list { grid-template-columns: repeat(2, minmax(0, 1fr)); }
    .inspection-view .inspection-source-photos__thumbnail { max-height: 48px; }
    .inspection-view .inspection-source-photos__header { gap: 4px; }
}

/* Keep Settings rows readable and within the browser viewport. */
.viewer-settings-list {
    width: 300px;
    max-width: calc(100vw - 24px);
    max-height: min(480px, calc(100vh - 140px));
    overflow-y: auto;
    color: var(--sd-text);
    background: var(--sd-surface);
}
.viewer-settings-list .v-list-item { min-height: 44px; padding: 0 4px; }

/* ND-1331: one photo gallery serves both viewer panes. */
.smartview-root { position: relative; }
.smartview-root--photo-workspace .column-item { position: relative; }
.photo-workspace-pane-label { position: absolute; top: 8px; left: 10px; z-index: 500; background: #161e29df; color: #fff; border-radius: 12px; padding: 4px 10px; font-size: 12px; pointer-events: none; }
.inspection-view--photo-workspace .inspection-shell__body { padding: 0; }
#nd-photo-workspace-toolbar { display: flex; align-items: center; flex: 0 0 auto; }
#nd-photo-workspace-toolbar:empty { display: none; }

.smartview-root--photo-workspace .column-item:has(.inspection-view--photo-workspace) .photo-workspace-pane-label { left: 64px; }
`, "",{"version":3,"sources":["webpack://./portal/static/css/main.css"],"names":[],"mappings":"AAAA;;;;;;;;;IASI,yDAAyD;IACzD,iDAAiD;AACrD;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,+BAA+B;AACnC;;AAEA;;IAEI,qDAAqD;AACzD;;AAEA;;;;;;;IAOI,kCAAkC;AACtC;;AAEA;IACI,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,oBAAoB;IACpB,qBAAqB;IACrB,SAAS;AACb;;AAEA;IACI,UAAU;IACV,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,2BAA2B;IAC3B,0CAA0C;IAC1C,2CAA2C;IAC3C,8BAA8B;AAClC;;AAEA;IACI,0CAA0C;IAC1C,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA;IACI,uCAAuC;IACvC,wCAAwC;IACxC,0DAA0D;AAC9D;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;;IAEI,+CAA+C;AACnD;;AAEA;;;;;;;;;IASI,6CAA6C;IAC7C,8CAA8C;IAC9C,0DAA0D;AAC9D;;AAEA;;;;;;;;;IASI,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;;;;;;;;IAQI,yDAAyD;IACzD,6CAA6C;AACjD;;AAEA;;;;IAII,6CAA6C;AACjD;;AAEA;;;;;;;;IAQI,oDAAoD;IACpD,4CAA4C;AAChD;;AAEA;;;;IAII,4CAA4C;AAChD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;IAEI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;;IAEI,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,SAAS;IACT,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;IACjC,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,0BAA0B;IAC1B,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA,0BAA0B;AAC1B,wBAAwB;AACxB,IAAI;;AAEJ,6BAA6B;AAC7B,wBAAwB;AACxB,IAAI;;AAEJ,0BAA0B;AAC1B,wBAAwB;AACxB,IAAI;;AAEJ;IACI,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB;;QAEI,eAAe;QACf,WAAW;IACf;AACJ;;AAEA;IACI,kBAAkB;IAClB;;QAEI,aAAa;QACb,WAAW;IACf;;IAEA;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB;QACI,YAAY;QACZ,cAAc;IAClB;;IAEA;;QAEI,iBAAiB;QACjB,cAAc;IAClB;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,4BAA4B;IAC5B,cAAc;AAClB;;AAEA;;IAEI,+BAA+B;AACnC;;AAEA;;;;IAII,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;;;;IAKI,0DAA0D;AAC9D;;AAEA;;;;;IAKI,yBAAyB;AAC7B;;AAEA;;;IAGI,iDAAiD;AACrD;;AAEA;;;IAGI,kDAAkD;AACtD;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,MAAM;AACV;;AAEA;IACI,4BAA4B;AAChC;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,qDAAqD;IACrD,kBAAkB;AACtB;;AAEA;IACI,mCAAmC;IACnC,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;+DAE+D;AAC/D;IACI,gEAAgE;AACpE;;AAEA,oEAAoE;;AAEpE;IACI;;;;;gBAKY;IACZ,qBAAqB;AACzB;;AAEA;;IAEI,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0BAA0B;IAC1B,iDAAiD;IACjD,0CAA0C;AAC9C;;AAEA;IACI,mDAAmD;IACnD,iCAAiC;AACrC;;AAEA;IACI,kCAAkC;IAClC,6CAA6C;IAC7C,4CAA4C;IAC5C,gBAAgB;AACpB;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,qBAAqB;IACrB,+DAA+D;IAC/D,sBAAsB;AAC1B;;AAEA;;;IAGI,sCAAsC;AAC1C;;AAEA;IACI,gCAAgC;AACpC;;AAEA,uEAAuE;AACvE;;;;IAII,gCAAgC;IAChC,qBAAqB;AACzB;;AAEA,uEAAuE;AACvE;;;;IAII,8CAA8C;AAClD;;AAEA;IACI,6CAA6C;IAC7C,iCAAiC;IACjC,+BAA+B;IAC/B,uDAAuD;AAC3D;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;;IAGI,8CAA8C;AAClD;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,6CAA6C;AACjD;;AAEA;;IAEI,6CAA6C;IAC7C,6BAA6B;IAC7B,0DAA0D;AAC9D;;AAEA;;IAEI,0CAA0C;AAC9C;;AAEA;IACI,0CAA0C;IAC1C,8CAA8C;AAClD;;AAEA;;IAEI,kCAAkC;AACtC;;AAEA;IACI,wCAAwC;IACxC,qBAAqB;IACrB,kCAAkC;IAClC,6CAA6C;IAC7C,4CAA4C;IAC5C,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,uBAAuB;IACvB,yCAAyC;AAC7C;;AAEA;IACI,qBAAqB;IACrB,+DAA+D;IAC/D,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA,0CAA0C;AAC1C;;;IAGI,8CAA8C;AAClD;;AAEA;;;IAGI,8CAA8C;AAClD;;AAEA,4EAA4E;AAC5E;;;;IAII,mDAAmD;IACnD,yDAAyD;AAC7D;;AAEA;;;;IAII,8CAA8C;IAC9C,oDAAoD;AACxD;;AAEA;IACI,kCAAkC;AACtC;;AAEA,sEAAsE;AACtE;IACI,uDAAuD;AAC3D;;AAEA;IACI,iDAAiD;IACjD,kBAAkB;AACtB;;AAEA;IACI,iDAAiD;IACjD,kBAAkB;AACtB;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,iDAAiD;AACrD;;AAEA;;IAEI,iCAAiC;AACrC;;AAEA;;IAEI,kCAAkC;AACtC;;AAEA;IACI,yDAAyD;IACzD,0CAA0C;AAC9C;;AAEA;;IAEI,4CAA4C;AAChD;;AAEA;IACI,oDAAoD;IACpD,2CAA2C;AAC/C;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;IACI,oDAAoD;AACxD;;AAEA;;;;IAII;kEAC8D;IAC9D,uCAAuC;IACvC,sCAAsC;AAC1C;;AAEA;;IAEI,6BAA6B;IAC7B,kCAAkC;IAClC,kCAAkC;IAClC,gBAAgB;AACpB;;AAEA;;;;IAII,oDAAoD;AACxD;;AAEA;;;;IAII,mDAAmD;AACvD;;AAEA;IACI,+BAA+B;IAC/B,uCAAuC;AAC3C;;AAEA;;IAEI,mCAAmC;IACnC,gCAAgC;AACpC;;AAEA;;IAEI,6CAA6C;IAC7C,qCAAqC;AACzC;;AAEA;;IAEI,sDAAsD;IACtD,6CAA6C;AACjD;;AAEA;;IAEI,wDAAwD;IACxD,gBAAgB;AACpB;;AAEA;;IAEI,mCAAmC;IACnC,kCAAkC;IAClC,2BAA2B;AAC/B;;AAEA;;;;IAII,0CAA0C;AAC9C;;AAEA;;;;IAII,8CAA8C;AAClD;;AAEA;;IAEI,mDAAmD;AACvD;;AAEA;;IAEI,oDAAoD;AACxD;;AAEA;;IAEI,mDAAmD;AACvD;;AAEA;;IAEI,oDAAoD;AACxD;;AAEA;;IAEI,mDAAmD;AACvD;;AAEA;;IAEI,oDAAoD;AACxD;;AAEA;;;;;;;IAOI,qDAAqD;AACzD;;AAEA;;;;IAII,sDAAsD;AAC1D;;AAEA;;;;;;IAMI,qCAAqC;AACzC;;AAEA;;;;;;;;;;;;;;;;;;;;;;IAsBI,6CAA6C;AACjD;;AAEA;;IAEI,oDAAoD;AACxD;;AAEA;;;;;;;;IAQI,6CAA6C;AACjD;;AAEA;;IAEI,qDAAqD;AACzD;;AAEA;;;;IAII,4CAA4C;AAChD;;AAEA;;;;IAII,sDAAsD;AAC1D;;AAEA;;;;IAII,2CAA2C;AAC/C;;AAEA;;;;;;;;IAQI,qCAAqC;AACzC;;AAEA;;;;;;;;;;;;;;;;;;IAkBI,+DAA+D;AACnE;;AAEA;;;;IAII,sDAAsD;AAC1D;;AAEA;;IAEI,gDAAgD;AACpD;;AAEA;;IAEI,8CAA8C;IAC9C,yDAAyD;AAC7D;;;AAGA,yEAAyE;AACzE;IACI,8BAA8B;IAC9B,kCAAkC;IAClC,6BAA6B;IAC7B,gCAAgC;IAChC,gCAAgC;IAChC,gCAAgC;IAChC,6BAA6B;IAC7B,gCAAgC;IAChC,WAAW;IACX,0CAA0C;IAC1C,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,sCAAsC;IACtC,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,qDAAqD;IACrD,0DAA0D;IAC1D,6DAA6D;IAC7D,2DAA2D;IAC3D,4DAA4D;AAChE;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,sCAAsC;IACtC,0CAA0C;IAC1C,mCAAmC;IACnC,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;;IAEI,oDAAoD;AACxD;;AAEA;;IAEI,6CAA6C;AACjD;;AAEA,4DAA4D;AAC5D;;;;IAII,qDAAqD;IACrD,0DAA0D;IAC1D,6DAA6D;IAC7D,2DAA2D;IAC3D,4DAA4D;AAChE;;AAEA,8DAA8D;AAC9D;IACI,sCAAsC;IACtC,+CAA+C;IAC/C,0CAA0C;IAC1C,0BAA0B;AAC9B;;AAEA;IACI,mCAAmC;IACnC,2BAA2B;IAC3B,+CAA+C;IAC/C,0CAA0C;AAC9C;;AAEA;;IAEI,qCAAqC;IACrC,0CAA0C;IAC1C,0CAA0C;AAC9C;;AAEA;;IAEI,wCAAwC;IACxC,0BAA0B;IAC1B,0CAA0C;AAC9C;;AAEA;yEACyE;AACzE;IACI,UAAU;IACV,wBAAwB;IACxB,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;IAEI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,MAAM;IACN,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,8BAA8B;IAC9B,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,6BAA6B;IAC7B,YAAY;IACZ,yCAAyC;IACzC,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;;;IAGI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,gDAAgD;IAChD,eAAe;IACf,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;IAC1B,mCAAmC;IACnC,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,kCAAkC;IAClC,kCAAkC;IAClC,+BAA+B;AACnC;;AAEA;IACI,oBAAoB;IACpB,YAAY;IACZ,kCAAkC;IAClC,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,kBAAkB;IAClB,uBAAuB;IACvB,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,QAAQ;IACR,cAAc;IACd,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,kCAAkC;IAClC,kCAAkC;IAClC,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA;;;;IAII,mDAAmD;IACnD,qDAAqD;AACzD;;AAEA;;;;IAII,+CAA+C;AACnD;;AAEA;;;;IAII,6CAA6C;AACjD;;AAEA;;;;IAII,qDAAqD;IACrD,6CAA6C;AACjD;;AAEA;;;;IAII,qDAAqD;IACrD,8CAA8C;AAClD;;AAEA;;;;IAII,+CAA+C;AACnD;;AAEA;;;;IAII,wCAAwC;IACxC,6CAA6C;AACjD;;AAEA;;;;IAII,qDAAqD;IACrD,8CAA8C;IAC9C,6CAA6C;AACjD;;AAEA;;;;IAII,+CAA+C;AACnD;;AAEA;;;;IAII,qDAAqD;IACrD,8CAA8C;IAC9C,6CAA6C;AACjD;;AAEA;;;;IAII,2DAA2D;AAC/D;;AAEA;;;;IAII,6CAA6C;AACjD;;AAEA;IACI,OAAO;IACP,aAAa;IACb,aAAa;IACb,qCAAqC;IACrC,MAAM;IACN,gBAAgB;AACpB;;AAEA;IACI,0DAA0D;AAC9D;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,mCAAmC;IACnC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,4BAA4B;IAC5B,uBAAuB;IACvB,wBAAwB;IACxB,kCAAkC;IAClC,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,kBAAkB;IAClB,6BAA6B;IAC7B,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,kCAAkC;IAClC,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;IACT,mBAAmB;AACvB;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,wBAAwB;IACxB,kCAAkC;AACtC;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,iBAAiB;IACjB,aAAa;IACb,sCAAsC;IACtC,+BAA+B;IAC/B,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;;IAEI,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,kCAAkC;IAClC,+BAA+B;IAC/B,8BAA8B;AAClC;;AAEA;IACI,kCAAkC;IAClC,+BAA+B;IAC/B,8BAA8B;AAClC;;AAEA;IACI,2CAA2C;IAC3C,wBAAwB;IACxB,4CAA4C;AAChD;;AAEA;IACI,2CAA2C;IAC3C,wBAAwB;IACxB,4CAA4C;AAChD;;AAEA;;IAEI,2CAA2C;IAC3C,wBAAwB;IACxB,4CAA4C;AAChD;;AAEA;;IAEI,yCAAyC;IACzC,sBAAsB;IACtB,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,oBAAoB;IACpB,kCAAkC;IAClC,kCAAkC;AACtC;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,sBAAsB;IACtB,6FAA6F;IAC7F,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,kCAAkC;IAClC,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;AACb;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,kCAAkC;IAClC,6BAA6B;IAC7B,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,4EAA4E;AAChF;;AAEA;IACI,4CAA4C;IAC5C,wBAAwB;IACxB,kCAAkC;AACtC;;AAEA;IACI,YAAY;IACZ,8BAA8B;IAC9B,kCAAkC;IAClC,2BAA2B;AAC/B;;AAEA;IACI,4CAA4C;IAC5C,gDAAgD;IAChD,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sCAAsC;IACtC,kBAAkB;IAClB,2CAA2C;IAC3C,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,oBAAoB;IACpB;;;KAGC;AACL;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,6CAA6C;IAC7C,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,kCAAkC;IAClC,mBAAmB;IACnB,6BAA6B;IAC7B,qBAAqB;IACrB,4CAA4C;IAC5C,6BAA6B;AACjC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,8BAA8B;IAC9B,aAAa;IACb,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,QAAQ;IACR,YAAY;IACZ,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,mCAAmC;IACnC,kBAAkB;IAClB,+BAA+B;IAC/B,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,QAAQ;IACR,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,kCAAkC;IAClC,mBAAmB;IACnB,uBAAuB;IACvB,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,+BAA+B;IAC/B,6CAA6C;AACjD;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,kBAAkB;IAClB,kCAAkC;IAClC,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,aAAa;IACb,oBAAoB;IACpB,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,6CAA6C;IAC7C,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,0CAA0C;IAC1C,sDAAsD;IACtD,0CAA0C;IAC1C,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,iCAAiC;IACjC,oBAAoB;AACxB;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,iBAAiB;IACjB,iDAAiD;AACrD;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,6CAA6C;IAC7C,SAAS;IACT,WAAW;IACX,eAAe;IACf,8BAA8B;IAC9B,kDAAkD;IAClD,qDAAqD;IACrD,4CAA4C;IAC5C,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,wBAAwB;IACxB,6BAA6B;IAC7B,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,oCAAoC;AACxC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,mDAAmD;AACvD;;AAEA;IACI,kDAAkD;IAClD,8DAA8D;AAClE;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;IAEI,gCAAgC;AACpC;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,+CAA+C;IAC/C,8CAA8C;AAClD;;AAEA;IACI,cAAc;AAClB;;AAEA;;;;IAII,sCAAsC;AAC1C;;AAEA;;;;IAII,yCAAyC;IACzC,+CAA+C;IAC/C,qCAAqC;AACzC;;AAEA;;;;IAII,yCAAyC;AAC7C;;AAEA;;;;IAII,gDAAgD;AACpD;;AAEA;;;;IAII,kCAAkC;AACtC;;AAEA;;;;;;;;IAQI,gDAAgD;AACpD;;AAEA;;;;IAII,2CAA2C;IAC3C,oDAAoD;IACpD,6CAA6C;IAC7C,2BAA2B;AAC/B;;AAEA;;;;IAII,yCAAyC;AAC7C;;AAEA;;;;;;;;IAQI,2BAA2B;AAC/B;;AAEA;;;;;;;;IAQI,qCAAqC;AACzC;;AAEA;;;;IAII,2CAA2C;AAC/C;;AAEA;;;;IAII,4CAA4C;IAC5C,0DAA0D;AAC9D;;AAEA;;;;;;;;IAQI,kCAAkC;AACtC;;AAEA;;;;IAII,sDAAsD;IACtD,8CAA8C;AAClD;;AAEA;;;;IAII,mCAAmC;AACvC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;;IAEI,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;;;IAGI,kCAAkC;IAClC,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,6CAA6C;AACjD;;AAEA;IACI,eAAe;AACnB;;AAEA;;;IAGI,wBAAwB;IACxB,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;IAC5B,oDAAoD;IACpD,mCAAmC;IACnC,gCAAgC;AACpC;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;;;IAII,YAAY;AAChB;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;IACI;kEAC8D;IAC9D,uCAAuC;IACvC,sCAAsC;AAC1C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;;IAGI,wCAAwC;AAC5C;;AAEA;IACI,UAAU;AACd;;AAEA;;;IAGI,qBAAqB;IACrB,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,6FAA6F;AACjG;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mDAAmD;IACnD,mCAAmC;AACvC;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,MAAM;IACN,cAAc;IACd,qCAAqC;IACrC,SAAS;IACT,2CAA2C;AAC/C;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI;QACI,QAAQ;QACR,gBAAgB;QAChB,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,QAAQ;IACZ;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,WAAW;IACf;;IAEA;;;QAGI,sBAAsB;QACtB,uBAAuB;QACvB,4BAA4B;IAChC;;IAEA;QACI,aAAa;IACjB;;IAEA;;;QAGI,qBAAqB;IACzB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;;;;;;IAMI,wCAAwC;IACxC,yCAAyC;AAC7C;;AAEA;;;;;;IAMI,8CAA8C;IAC9C,gDAAgD;IAChD,6CAA6C;AACjD;;AAEA;;IAEI;wEACoE;AACxE;;AAEA;;IAEI,6CAA6C;AACjD;;AAEA;;IAEI,kEAAkE;IAClE,2DAA2D;IAC3D,6CAA6C;AACjD;;AAEA;;IAEI,2DAA2D;IAC3D,+DAA+D;IAC/D,6CAA6C;AACjD;;AAEA;;IAEI,2DAA2D;IAC3D,6CAA6C;AACjD;;AAEA;;IAEI,2DAA2D;IAC3D,6CAA6C;IAC7C,6FAA6F;AACjG;;AAEA;;IAEI,mDAAmD;IACnD,6CAA6C;AACjD;;AAEA;;;;IAII,kDAAkD;AACtD;;AAEA;;;;IAII,2DAA2D;IAC3D,yCAAyC;IACzC,6CAA6C;AACjD;;AAEA;;IAEI,gDAAgD;AACpD;;AAEA;;IAEI,0CAA0C;AAC9C;;AAEA;;;;;;;;IAQI,mDAAmD;IACnD,6CAA6C;AACjD;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,8CAA8C;IAC9C,mBAAmB;IACnB,gBAAgB;IAChB,8CAA8C;AAClD;;AAEA;IACI,gDAAgD;AACpD;;AAEA;;;;IAII,8CAA8C;AAClD;;AAEA,sCAAsC;;AAEtC;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,+CAA+C;IAC/C,mBAAmB;IACnB,qHAAqH;IACrH,qCAAqC;IACrC,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,mBAAmB;IACnB,wDAAwD;AAC5D;;AAEA;IACI,gIAAgI;IAChI,8CAA8C;AAClD;;AAEA;IACI,wBAAwB;IACxB,0BAA0B;AAC9B;;AAEA,oCAAoC;;AAEpC;IACI,0DAA0D;AAC9D;;AAEA,kCAAkC;;AAElC;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB;;;;;SAKK;IACL,6CAA6C;IAC7C,6CAA6C;IAC7C,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;IACT,uBAAuB;IACvB,2DAA2D;AAC/D;;AAEA;IACI,eAAe;IACf,gDAAgD;IAChD,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,oDAAoD;IACpD,kBAAkB;IAClB,+CAA+C;IAC/C,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,OAAO;IACP,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,wCAAwC;IACxC,oDAAoD;AACxD;;AAEA;;IAEI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,kDAAkD;AACtD;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,+CAA+C;IAC/C,oDAAoD;IACpD,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,0CAA0C;AAC9C;;AAEA;IACI,kCAAkC;IAClC,uDAAuD;AAC3D;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,uCAAuC;AAC3C;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,yDAAyD;IACzD,mBAAmB;IACnB,iDAAiD;IACjD,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,0DAA0D;AAC9D;;AAEA;IACI,uDAAuD;IACvD,sDAAsD;AAC1D;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,2CAA2C;IAC3C,oDAAoD;AACxD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,SAAS;IACT,sCAAsC;IACtC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,wCAAwC;IACxC,mDAAmD;AACvD;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,sCAAsC;AAC1C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,qDAAqD;IACrD,mBAAmB;IACnB,sCAAsC;IACtC,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,mDAAmD;IACnD,mBAAmB;IACnB,+CAA+C;IAC/C,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf;4BACwB;AAC5B;;AAEA;IACI,8CAA8C;IAC9C,qDAAqD;AACzD;;AAEA;IACI,iDAAiD;IACjD,uDAAuD;IACvD,0BAA0B;AAC9B;;AAEA;IACI,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,uCAAuC;AAC3C;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,sCAAsC;IACtC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,uDAAuD;AAC3D;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,oCAAoC;AACxC;;AAEA;IACI;QACI,2CAA2C;IAC/C;;IAEA;QACI,0DAA0D;IAC9D;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,qEAAqE;AACrE;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,WAAW;IACX,aAAa;IACb,aAAa;IACb,UAAU;IACV,uCAAuC;IACvC,8CAA8C;IAC9C,yCAAyC;AAC7C;;AAEA;IACI,kEAAkE;AACtE;;AAEA;IACI,iEAAiE;AACrE;;AAEA;;IAEI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;;;;+EAK+E;;AAE/E,yDAAyD;;AAEzD;IACI,mCAAmC;IACnC,+BAA+B;IAC/B,mDAAmD;IACnD,8CAA8C;IAC9C,gCAAgC;IAChC,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA,8BAA8B;AAC9B;;;;IAII,8CAA8C;IAC9C,2BAA2B;AAC/B;;AAEA,4DAA4D;;AAE5D;IACI,mCAAmC;IACnC,4CAA4C;IAC5C,0BAA0B;AAC9B;;AAEA;;;;IAII,wCAAwC;IACxC,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,oBAAoB;IACpB,cAAc;IACd,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,0BAA0B;IAC1B,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,wBAAwB;IACxB,2CAA2C;IAC3C,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,+DAA+D;IAC/D,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;IACd,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,2CAA2C;IAC3C,6DAA6D;IAC7D,wDAAwD;IACxD,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,+DAA+D;IAC/D,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;;;;IAII,qCAAqC;AACzC;;AAEA;;;;IAII,qCAAqC;IACrC,uDAAuD;AAC3D;;AAEA;;;;IAII,qCAAqC;IACrC,uDAAuD;AAC3D;;AAEA;;;;IAII,+CAA+C;IAC/C,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA;;IAEI,WAAW;IACX,0BAA0B;AAC9B;;AAEA,+DAA+D;AAC/D;;;;;;;;;IASI,sDAAsD;IACtD,wEAAwE;IACxE,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;;;;;IAKI,kCAAkC;IAClC,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;;;;;IAKI,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;;IAGI,mEAAmE;IACnE,0BAA0B;IAC1B,2BAA2B;IAC3B,2BAA2B;IAC3B,sDAAsD;IACtD,wEAAwE;AAC5E;;AAEA;IACI,0EAA0E;IAC1E,0BAA0B;IAC1B,iCAAiC;IACjC,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;;IAEI,0EAA0E;IAC1E,qBAAqB;AACzB;;AAEA;;;;;;IAMI,0EAA0E;IAC1E,4FAA4F;IAC5F,qBAAqB;AACzB;;AAEA;;;;IAII,0EAA0E;IAC1E,uBAAuB;AAC3B;;AAEA;;;IAGI,mBAAmB;AACvB;;AAEA;IACI,iEAAiE;AACrE;;AAEA;;;IAGI,8CAA8C;IAC9C,0DAA0D;IAC1D,8BAA8B;IAC9B,yDAAyD;IACzD,sDAAsD;IACtD,gBAAgB;AACpB;;AAEA;;;;;;;;;;;;IAYI,wCAAwC;IACxC,sDAAsD;IACtD,sDAAsD;AAC1D;;AAEA;;;IAGI,8CAA8C;IAC9C,sDAAsD;IACtD,cAAc;AAClB;;AAEA;;;;;;;;;;;;IAYI,wCAAwC;AAC5C;;AAEA;;;;;;;;;;;;;;;IAeI,sDAAsD;IACtD,qBAAqB;AACzB;;AAEA;;;IAGI,gBAAgB;AACpB;;AAEA;;;;;;;;;;;;IAYI,gCAAgC;AACpC;;AAEA;;;IAGI,0EAA0E;AAC9E;;AAEA;;;IAGI,wBAAwB;AAC5B;;AAEA;;;;;;IAMI,sDAAsD;AAC1D;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;IAwBI,6CAA6C;IAC7C,gCAAgC;AACpC;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;IAwBI,gCAAgC;AACpC;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;;IAEI,wBAAwB;IACxB,kCAAkC;IAClC,qBAAqB;AACzB;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;;;;IAII,6CAA6C;AACjD;;AAEA;;;;;;;;;;;;;;;;IAgBI,6CAA6C;IAC7C,+DAA+D;AACnE;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,cAAc;IACd,4CAA4C;IAC5C,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI,2CAA2C;IAC3C,wEAAwE;IACxE,2BAA2B;IAC3B,cAAc;IACd,wDAAwD;IACxD,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,+BAA+B;IAC/B,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,qCAAqC;;AAErC;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,wDAAwD;IACxD,eAAe;IACf,+BAA+B;IAC/B,qBAAqB;IACrB,mBAAmB;IACnB,4BAA4B;IAC5B,iBAAiB;AACrB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,sCAAsC;IACtC,wDAAwD;AAC5D;;AAEA,sCAAsC;;AAEtC;IACI,+CAA+C;AACnD;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,iDAAiD;AACrD;;AAEA,6BAA6B;;AAE7B,2CAA2C;AAC3C;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA,4CAA4C;AAC5C;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA,mCAAmC;;AAEnC;IACI,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;AAClB;;AAEA,4DAA4D;AAC5D;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;AACA,+BAA+B,aAAa,EAAE;AAC9C,uEAAuE,yBAAyB,EAAE;AAClG;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,QAAQ;IACR,YAAY;IACZ,qBAAqB;IACrB,YAAY;AAChB;AACA,kCAAkC,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,mBAAmB,EAAE,eAAe,EAAE;AACtH,kCAAkC,YAAY,EAAE;AAChD,uDAAuD,gBAAgB,EAAE,MAAM,EAAE;AACjF;;IAEI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,UAAU;IACV,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,6BAA6B;IAC7B,qBAAqB;AACzB;AACA;wDACwD,YAAY,EAAE,cAAc,EAAE,YAAY,EAAE,qBAAqB,EAAE,uBAAuB,EAAE,oBAAoB,EAAE,iBAAiB,EAAE,SAAS,EAAE;AACxM;gEACgE,mCAAmC,EAAE,6BAA6B,EAAE;AACpI;6BAC6B,kBAAkB,EAAE,UAAU,EAAE,WAAW,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,mBAAmB,EAAE;AACxI,oCAAoC,YAAY,EAAE,yCAAyC,EAAE,6BAA6B,EAAE,qBAAqB,EAAE;AACnJ,0DAA0D,eAAe,EAAE;AAC3E,6EAA6E;AAC7E;;;;IAII,+CAA+C;AACnD;AACA;;;;;;IAMI,+BAA+B;AACnC;AACA,gEAAgE,gBAAgB,EAAE;AAClF,2DAA2D,aAAa,EAAE;;AAE1E,0EAA0E;AAC1E,4CAA4C,aAAa,EAAE,sBAAsB,EAAE;AACnF,wBAAwB,kBAAkB,EAAE,aAAa,EAAE,sBAAsB,EAAE,cAAc,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AACvI,yBAAyB,kBAAkB,EAAE,aAAa,EAAE,sBAAsB,EAAE,cAAc,EAAE,gBAAgB,EAAE,YAAY,EAAE;AACpI,8BAA8B,cAAc,EAAE,aAAa,EAAE,YAAY,EAAE,WAAW,EAAE;AACxF,yDAAyD,aAAa,EAAE;AACxE;IACI,kBAAkB;IAClB,QAAQ;IACR,cAAc;IACd,UAAU;IACV,WAAW;IACX,YAAY;IACZ,cAAc;IACd,oBAAoB;IACpB,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,eAAe;AACnB;AACA,0DAA0D,mBAAmB,EAAE,qBAAqB,EAAE,eAAe,EAAE;AACvH,oCAAoC,iBAAiB,EAAE,gBAAgB,EAAE,kCAAkC,EAAE,kBAAkB,EAAE,qBAAqB,EAAE,kCAAkC,EAAE,eAAe,EAAE;AAC7M,qDAAqD,cAAc,EAAE,gBAAgB,EAAE;AACvF,qDAAqD,gBAAgB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,eAAe,EAAE,uBAAuB,EAAE,sCAAsC,EAAE;AAC7L;IACI,aAAa;IACb,gDAAgD;IAChD,QAAQ;IACR,YAAY;IACZ,iBAAiB;AACrB;AACA,wDAAwD,WAAW,EAAE,UAAU,EAAE;AACjF,uDAAuD,mBAAmB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE,eAAe,EAAE;AAC3I;uCACuC,kBAAkB,EAAE,UAAU,EAAE,WAAW,EAAE,YAAY,EAAE,WAAW,EAAE;AAC/G,+CAA+C,YAAY,EAAE;AAC7D;;IAEI,QAAQ;IACR,cAAc;IACd,aAAa;IACb,QAAQ;IACR,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;IAC7B,qBAAqB;IACrB,sCAAsC;IACtC,eAAe;IACf,uBAAuB;AAC3B;AACA;gCACgC,OAAO,EAAE;AACzC;kCACkC,sBAAsB,EAAE;AAC1D;;IAEI,oCAAoC;IACpC,mBAAmB;AACvB;AACA;IACI,mDAAmD,gDAAgD,EAAE;IACrG,yCAAyC,kBAAkB,EAAE,UAAU,EAAE,WAAW,EAAE,gBAAgB,EAAE,qBAAqB,EAAE;IAC/H,yBAAyB,gBAAgB,EAAE;AAC/C;AACA;IACI,mDAAmD,gDAAgD,EAAE;IACrG,wDAAwD,gBAAgB,EAAE;IAC1E,qDAAqD,QAAQ,EAAE;AACnE;;AAEA,iEAAiE;AACjE;IACI,YAAY;IACZ,6BAA6B;IAC7B,2CAA2C;IAC3C,gBAAgB;IAChB,qBAAqB;IACrB,6BAA6B;AACjC;AACA,qCAAqC,gBAAgB,EAAE,cAAc,EAAE;;AAEvE,yDAAyD;AACzD,kBAAkB,kBAAkB,EAAE;AACtC,gDAAgD,kBAAkB,EAAE;AACpE,8BAA8B,kBAAkB,EAAE,QAAQ,EAAE,UAAU,EAAE,YAAY,EAAE,qBAAqB,EAAE,WAAW,EAAE,mBAAmB,EAAE,iBAAiB,EAAE,eAAe,EAAE,oBAAoB,EAAE;AACzM,4DAA4D,UAAU,EAAE;AACxE,8BAA8B,aAAa,EAAE,mBAAmB,EAAE,cAAc,EAAE;AAClF,oCAAoC,aAAa,EAAE;;AAEnD,mHAAmH,UAAU,EAAE","sourcesContent":["input:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ntextarea:-webkit-autofill,\ntextarea:-webkit-autofill:hover,\ntextarea:-webkit-autofill:focus,\nselect:-webkit-autofill,\nselect:-webkit-autofill:hover,\nselect:-webkit-autofill:focus {\n    -webkit-box-shadow: 0 0 0px 1000px rgba(0, 0, 0, 0) inset;\n    transition: background-color 5000s ease-in-out 0s;\n}\n\n.v-card__title {\n    word-break: initial !important;\n}\n\n.smaller-text {\n    font-size: 80%;\n}\n\n.bigger-text {\n    font-size: 120%;\n}\n\n#logo-image {\n    max-height: 30px;\n    vertical-align: middle;\n    display: block;\n}\n\n.center-logo-image > img {\n    display: block;\n}\n\n.profile-avatar {\n    width: 3.125rem;\n    height: 3.125rem;\n}\n\nform {\n    max-width: 28.125rem;\n    margin: 0 auto;\n}\n\n#welcome-back-title {\n    font-size: 3rem;\n    font-family: 'Omnes ExtraLight';\n}\n\ndiv.v-card__text,\nspan.v-btn__content {\n    font-family: 'Omnes Regular', 'sans-serif' !important;\n}\n\ndiv.v-dialog__container\n> div\n> div\n> div\n> div.v-card__actions\n> button.v-btn.v-btn--contained.theme--light.v-size--default.primary\n> span {\n    color: var(--sd-light-text-strong);\n}\n\n#welcome-back-description {\n    font-size: 1.5rem;\n    font-family: 'Omnes Light';\n}\n\n.add-username-field {\n    width: 75% !important;\n    max-width: 28.125rem;\n    left: -5% !important;\n    display: inline-block;\n    margin: 0;\n}\n\n.add-username-btn {\n    width: 21%;\n    display: inline-block;\n    max-width: 4.688rem;\n}\n\n.add-username-form {\n    float: right;\n    max-width: 28.125rem;\n    width: 100%;\n}\n\n#loader-container {\n    margin-top: 2.5rem;\n}\n\n.popupcollapse {\n    border-left: 0 !important;\n    border-right: 0 !important;\n    margin-bottom: 0 !important;\n    border-bottom-left-radius: 12px !important;\n    border-bottom-right-radius: 12px !important;\n    border-bottom: none !important;\n}\n\n.collapsible > li:last-child > div {\n    border-bottom-left-radius: 12px !important;\n    border-bottom-right-radius: 12px !important;\n    border-bottom: none;\n}\n\n.collapsible > li.active:last-child > div {\n    border-bottom-left-radius: 0 !important;\n    border-bottom-right-radius: 0 !important;\n    border-bottom: 1px solid var(--sd-light-border) !important;\n}\n\n.collapsible {\n    box-shadow: none;\n    -webkit-box-shadow: none;\n}\n\n.leaflet-popup-content.collapsible.active\n+ .leaflet-popup-tip-container.leaflet-popup-tip {\n    background-color: var(--sd-light-surface-muted);\n}\n\n#mapid\n> div.leaflet-pane.leaflet-map-pane\n> div.leaflet-pane.leaflet-popup-pane\n> div\n> div.leaflet-popup-content-wrapper\n> div\n> ul\n> li:last-child\n> div.active {\n    border-bottom-left-radius: initial !important;\n    border-bottom-right-radius: initial !important;\n    border-bottom: 1px solid var(--sd-light-border) !important;\n}\n\n#mapid\n> div.leaflet-pane.leaflet-map-pane\n> div.leaflet-pane.leaflet-popup-pane\n> div\n> div.leaflet-popup-content-wrapper\n> div\n> ul\n> li:last-child\n> div:last-child {\n    border-bottom: none !important;\n}\n\n.leaflet-popup-content {\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n    margin-bottom: 0 !important;\n}\n\nhtml.theme--dark .leaflet-popup-content-wrapper,\nbody.theme--dark .leaflet-popup-content-wrapper,\n.theme--dark .leaflet-popup-content-wrapper,\n.v-theme--dark .leaflet-popup-content-wrapper,\nhtml.theme--dark .leaflet-popup-tip,\nbody.theme--dark .leaflet-popup-tip,\n.theme--dark .leaflet-popup-tip,\n.v-theme--dark .leaflet-popup-tip {\n    background-color: var(--sd-dark-surface-muted) !important;\n    color: var(--sd-dark-text-inverse) !important;\n}\n\nhtml.theme--dark .leaflet-popup-content,\nbody.theme--dark .leaflet-popup-content,\n.theme--dark .leaflet-popup-content,\n.v-theme--dark .leaflet-popup-content {\n    color: var(--sd-dark-text-inverse) !important;\n}\n\nhtml.theme--light .leaflet-popup-content-wrapper,\nbody.theme--light .leaflet-popup-content-wrapper,\n.theme--light .leaflet-popup-content-wrapper,\n.v-theme--light .leaflet-popup-content-wrapper,\nhtml.theme--light .leaflet-popup-tip,\nbody.theme--light .leaflet-popup-tip,\n.theme--light .leaflet-popup-tip,\n.v-theme--light .leaflet-popup-tip {\n    background-color: var(--sd-light-surface) !important;\n    color: var(--sd-light-popup-text) !important;\n}\n\nhtml.theme--light .leaflet-popup-content,\nbody.theme--light .leaflet-popup-content,\n.theme--light .leaflet-popup-content,\n.v-theme--light .leaflet-popup-content {\n    color: var(--sd-light-popup-text) !important;\n}\n\n.leaflet-draw-guides {\n    z-index: 1000 !important;\n}\n\n.leaflet-draw-guide-dash {\n    z-index: 1000 !important;\n}\n\n#reconstruction-container,\n#report-container {\n    max-width: 25rem;\n    margin-right: auto;\n    margin-left: auto;\n    margin-top: 1.875rem;\n}\n\n#rightMainContainer,\n#dataset-menu {\n    transition: margin 1s, width 1s;\n}\n\n#rightMainContainer {\n    width: 100%;\n    position: absolute;\n    z-index: 1;\n    height: 100%;\n    margin: 0;\n    padding: 0;\n    overflow: hidden;\n}\n\n.hideDatasetMenu {\n    margin: 0 !important;\n    width: 100% !important;\n}\n\n.rightWidth {\n    width: -webkit-calc(100% - 250px);\n    width: -moz-calc(100% - 250px);\n    width: calc(100% - 250px);\n}\n\n.icon-flipped {\n    transform: scaleX(-1);\n    -moz-transform: scaleX(-1);\n    -webkit-transform: scaleX(-1);\n    -ms-transform: scaleX(-1);\n}\n\n#app {\n    background: none;\n}\n\n.application--wrap {\n    min-height: 0;\n}\n\n.flexme {\n    display: flex;\n}\n\n.v-expansion-panel-header:focus {\n    background-color: var(--sd-surface-muted);\n}\n\n.toolbar-button {\n    font-family: 'Omnes Medium';\n}\n\na > div > img:hover {\n    opacity: 0.9;\n}\n\n.no-autocomplete-border {\n    margin-left: 0;\n    margin-right: 0;\n}\n\n.no-select-border.v-text-field > .v-input__control > .v-input__slot:before {\n    border-style: none;\n}\n\n.no-select-border.v-text-field > .v-input__control > .v-input__slot:after {\n    border-style: none;\n}\n\n.v-toolbar__content,\n.v-toolbar__extension {\n    padding: 0 16px !important;\n}\n\n/*.top-page-site-select {*/\n/*    max-width: 300px;*/\n/*}*/\n\n/*.top-page-dataset-select {*/\n/*    max-width: 300px;*/\n/*}*/\n\n/*.top-page-view-select {*/\n/*    max-width: 200px;*/\n/*}*/\n\n.toolbar-button > span > .help-icon {\n    max-height: 0.938rem;\n}\n\nheader.v-app-bar.v-app-bar--fixed {\n    z-index: 4 !important;\n}\n\ndiv.top-bar-container > .headline {\n    margin-top: 1rem;\n}\n\n.intercom-launcher-frame {\n    display: none !important;\n}\n\n.intercom-messenger-frame {\n    top: 80px !important;\n}\n\n@media only screen and (max-width: 600px) {\n    /* xs breakpoint */\n    .tab-card,\n    .top-bar-bg {\n        padding: 0 20px;\n        width: 100%;\n    }\n}\n\n@media only screen and (min-width: 600px) and (max-width: 960px) {\n    /* sm breakpoint */\n    .tab-card,\n    .top-bar-bg {\n        padding: 0 5%;\n        width: 100%;\n    }\n\n    .card-grid-container {\n        padding-left: 40px !important;\n    }\n}\n\n.top-bar-bg {\n    max-height: 7.5rem;\n}\n\n@media only screen and (min-width: 960px) {\n    /* md breakpoint */\n    .top-bar-bg {\n        width: 100vw;\n        margin: 0 auto;\n    }\n\n    div.tab-card,\n    .top-bar-container {\n        max-width: 1000px;\n        margin: 0 auto;\n    }\n\n    .card-grid-container {\n        padding-left: 60px !important;\n    }\n\n    .dashboard-container {\n        margin-left: 60px !important;\n    }\n}\n\n.full-width {\n    width: 100%;\n}\n\n.card-grid-container > div.row > div > div.v-card,\n.card-grid-container > div.row > div.v-card {\n    max-width: 300px;\n}\n\n.max-width-500 {\n    max-width: 500px !important;\n    margin: 0 auto;\n}\n\n.max-width-700 {\n    max-width: 700px !important;\n    margin: 0 auto;\n}\n\n.max-width-1000 {\n    max-width: 1000px !important;\n    margin: 0 auto;\n}\n\n.v-list-item__title,\n.v-list-item__subtitle {\n    white-space: initial !important;\n}\n\n.v-window.full-width.fill-height.pa-5.v-item-group.theme--dark.v-tabs-items\n> .v-window__container,\n.v-window.full-width.fill-height.pa-5.v-item-group.theme--light.v-tabs-items\n> .v-window__container {\n    height: 100%;\n}\n\nheader.v-app-bar {\n    border: solid;\n    border-width: 0;\n    border-bottom-width: thin;\n}\n\nheader.theme--dark.v-app-bar {\n    border-color: var(--sd-dark-border);\n}\n\nheader.theme--light.v-app-bar {\n    border-color: var(--sd-light-border-subtle);\n}\n\n.v-picker.v-card.v-picker--date {\n    box-shadow: none;\n}\n\n.v-date-picker-table {\n    height: initial !important;\n}\n\n.v-input\n> .v-input__control\n> .v-input__slot\n> .v-input__append-inner\n> .v-input__icon.v-input__icon--append {\n    transition: transform 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n\n.date-text-field.v-input--is-focused\n> .v-input__control\n> .v-input__slot\n> .v-input__append-inner\n> .v-input__icon.v-input__icon--append {\n    transform: rotate(180deg);\n}\n\n.theme--dark.v-text-field--filled:not(.v-input--is-focused)\n> .v-input__control\n> .v-input__slot:hover {\n    background: var(--sd-dark-field-hover) !important;\n}\n\n.theme--light.v-text-field--filled:not(.v-input--is-focused)\n> .v-input__control\n> .v-input__slot:hover {\n    background: var(--sd-light-field-hover) !important;\n}\n\nbutton.dialog-close-btn {\n    position: absolute;\n    right: 0;\n    top: 0;\n}\n\n.v-breadcrumbs li {\n    font-size: 1.5rem !important;\n}\n\n.v-breadcrumbs,\n.v-breadcrumbs ul {\n    padding-left: 0 !important;\n}\n\n.no-margin {\n    margin: 0 !important;\n}\n\n.v-icon.v-icon {\n    max-width: 24px !important;\n}\n\n.top-bar-container {\n    background-color: transparent;\n}\n\n.error-container {\n    padding: 0.625rem;\n    font-family: Omnes Regular, Omnes, Roboto, sans-serif;\n    text-align: center;\n}\n\n.error-image {\n    background: var(--sd-light-surface);\n    padding: 0.313rem;\n}\n\n.color-button {\n    padding: 0.938rem;\n    width: 100%;\n    height: 100%;\n    cursor: pointer !important;\n}\n\n.color-button:hover {\n    filter: brightness(90%);\n}\n\n.color-button.red {\n    background-color: #ff0000;\n}\n\n.color-button.orange {\n    background-color: #ff9900;\n}\n\n.color-button.yellow {\n    background-color: #fffe00;\n}\n\n.color-button.green {\n    background-color: #00c801;\n}\n\n.color-button.white {\n    background-color: #e5e5e5;\n}\n\n.quality-button {\n    cursor: pointer !important;\n}\n\n/*  This was originally set in vuetify.scss and imported through webpack (webpack.config.js:267)\n    Since updating the sass-loader to handle scss/sass, this no longer worked properly\n    TODO have vuetify import the Omnes Regular font correctly */\n.v-application, .headline, .v-subheader, .omnes-font {\n    font-family: Omnes Regular, Omnes, Roboto, sans-serif !important;\n}\n\n/* Modern UI standard layer (global, non-functional visual update) */\n\n.v-application {\n    background: radial-gradient(\n        circle at 15% -10%,\n        var(--sd-light-app-gradient-start) 0,\n        var(--sd-bg) 40%,\n        var(--sd-bg) 100%\n    ) !important;\n    color: var(--sd-text);\n}\n\nhtml,\nbody {\n    background: var(--sd-bg);\n    color: var(--sd-text);\n}\n\n.v-main {\n    color: var(--sd-text);\n}\n\na {\n    color: var(--sd-primary);\n    text-decoration-thickness: 1px;\n    text-underline-offset: 2px;\n}\n\na:hover {\n    color: var(--sd-primary-strong);\n}\n\nheader.v-app-bar {\n    backdrop-filter: blur(8px);\n    background-color: var(--sd-app-bar-bg) !important;\n    box-shadow: 0 1px 0 rgba(30, 55, 90, 0.08);\n}\n\n.v-navigation-drawer {\n    border-right: 1px solid var(--sd-border) !important;\n    box-shadow: var(--sd-shadow-soft);\n}\n\n.v-card {\n    border: 1px solid var(--sd-border);\n    border-radius: var(--sd-radius-md) !important;\n    box-shadow: var(--sd-shadow-soft) !important;\n    overflow: hidden;\n}\n\n.v-card:hover {\n    box-shadow: var(--sd-shadow-hover) !important;\n}\n\n.v-card__title {\n    color: var(--sd-text);\n    font-family: Omnes Medium, Omnes, Roboto, sans-serif !important;\n    letter-spacing: 0.01em;\n}\n\n.v-card__text,\n.v-list-item-subtitle,\n.v-messages__message {\n    color: var(--sd-text-muted) !important;\n}\n\n.v-list-item-title {\n    color: var(--sd-text) !important;\n}\n\n/* Guard against legacy/global CSS making autocomplete text invisible */\n.v-autocomplete .v-field__input,\n.v-autocomplete .v-select__selection,\n.v-autocomplete input,\n.v-overlay .v-list-item-title {\n    color: var(--sd-text) !important;\n    opacity: 1 !important;\n}\n\n/* Keep all autocomplete fields readable over mixed page backgrounds. */\n.v-autocomplete .v-field,\n.v-autocomplete .v-field--variant-filled,\n.v-autocomplete .v-field--variant-outlined,\n.v-autocomplete .v-input__slot {\n    background: var(--sd-light-surface) !important;\n}\n\n.v-btn {\n    border-radius: var(--sd-radius-sm) !important;\n    letter-spacing: 0.01em !important;\n    text-transform: none !important;\n    transition: box-shadow 0.18s ease, transform 0.18s ease;\n}\n\n.v-btn:hover {\n    transform: translateY(-1px);\n}\n\n.v-btn--variant-elevated,\n.v-btn--variant-flat,\n.v-btn--variant-tonal {\n    box-shadow: 0 4px 14px rgba(32, 78, 128, 0.15);\n}\n\n.v-btn--variant-text {\n    box-shadow: none !important;\n}\n\n.v-field {\n    border-radius: var(--sd-radius-sm) !important;\n}\n\n.v-field--variant-filled,\n.v-field--variant-outlined {\n    background: var(--sd-surface-soft) !important;\n    border: 1px solid transparent;\n    transition: border-color 0.16s ease, box-shadow 0.16s ease;\n}\n\n.v-field--variant-filled:hover,\n.v-field--variant-outlined:hover {\n    border-color: var(--sd-light-border-hover);\n}\n\n.v-field--focused {\n    border-color: var(--sd-primary) !important;\n    box-shadow: 0 0 0 3px rgba(47, 131, 201, 0.12);\n}\n\n.v-menu > .v-overlay__content,\n.v-dialog > .v-overlay__content {\n    border-radius: var(--sd-radius-md);\n}\n\n.v-overlay__content.smart-view-dialogue-overlay .smart-view-dialogue-base {\n    background: var(--sd-surface) !important;\n    color: var(--sd-text);\n    border: 1px solid var(--sd-border);\n    border-radius: var(--sd-radius-md) !important;\n    box-shadow: var(--sd-shadow-soft) !important;\n    overflow: hidden;\n}\n\n.smart-view-dialogue-overlay .smart-view-dialogue-base__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    padding: 24px 24px 16px;\n    border-bottom: 1px solid var(--sd-border);\n}\n\n.smart-view-dialogue-overlay .smart-view-dialogue-base__heading {\n    color: var(--sd-text);\n    font-family: Omnes Medium, Omnes, Roboto, sans-serif !important;\n    font-size: 1.35rem;\n    line-height: 1.2;\n    text-align: left;\n}\n\n.smart-view-dialogue-overlay .smart-view-dialogue-base__content {\n    padding: 20px 24px 24px;\n}\n\n.smart-view-dialogue-overlay .smart-view-dialogue-base__close {\n    flex-shrink: 0;\n}\n\n/* Autocomplete dropdown menu background */\n.v-autocomplete__content,\n.v-menu__content,\n.v-menu > .v-overlay__content {\n    background: var(--sd-light-surface) !important;\n}\n\n.v-autocomplete__content .v-list,\n.v-menu__content .v-list,\n.v-menu > .v-overlay__content .v-list {\n    background: var(--sd-light-surface) !important;\n}\n\n/* Keep teleported menu lists aligned with explicit Vuetify theme classes. */\n.v-autocomplete__content .v-list.v-theme--dark,\n.v-menu__content .v-list.v-theme--dark,\n.v-menu > .v-overlay__content .v-list.v-theme--dark,\n.v-overlay__content .v-list.v-theme--dark {\n    background: var(--sd-dark-surface-muted) !important;\n    background-color: var(--sd-dark-surface-muted) !important;\n}\n\n.v-autocomplete__content .v-list.v-theme--light,\n.v-menu__content .v-list.v-theme--light,\n.v-menu > .v-overlay__content .v-list.v-theme--light,\n.v-overlay__content .v-list.v-theme--light {\n    background: var(--sd-light-surface) !important;\n    background-color: var(--sd-light-surface) !important;\n}\n\n.v-list {\n    background: transparent !important;\n}\n\n/* Dataset picker menu theming (moved from base.html inline styles). */\n.dataset-menu-date-panel {\n    border-right: 1px solid var(--sd-neutral-border-medium);\n}\n\n.dataset-menu-list {\n    border: 1px solid var(--sd-neutral-border-medium);\n    border-radius: 8px;\n}\n\n.dataset-groups-search .v-field {\n    border: 1px solid var(--sd-neutral-border-medium);\n    border-radius: 8px;\n}\n\n.theme--dark .dataset-menu-date-panel {\n    border-right-color: var(--sd-dark-border-subtle);\n}\n\n.theme--light .dataset-menu-date-panel {\n    border-right-color: var(--sd-light-border-subtle);\n}\n\n.theme--dark .dataset-menu-list .v-list-item-title,\n.theme--dark .dataset-menu-list .v-list-item-subtitle {\n    color: var(--sd-dark-text-strong);\n}\n\n.theme--light .dataset-menu-list .v-list-item-title,\n.theme--light .dataset-menu-list .v-list-item-subtitle {\n    color: var(--sd-light-text-strong);\n}\n\n.theme--dark .dataset-groups-search .v-field {\n    background-color: var(--sd-dark-surface-muted) !important;\n    border-color: var(--sd-dark-border-medium);\n}\n\n.theme--dark .dataset-groups-search .v-field__input,\n.theme--dark .dataset-groups-search .v-icon {\n    color: var(--sd-dark-text-strong) !important;\n}\n\n.theme--light .dataset-groups-search .v-field {\n    background-color: var(--sd-light-surface) !important;\n    border-color: var(--sd-light-border-medium);\n}\n\n.theme--dark .dataset-menu-list .v-list-item {\n    background-color: var(--sd-dark-surface-muted) !important;\n}\n\n.theme--light .dataset-menu-list .v-list-item {\n    background-color: var(--sd-light-surface) !important;\n}\n\nhtml.theme--light .leaflet-draw-toolbar a,\nbody.theme--light .leaflet-draw-toolbar a,\n.theme--light .leaflet-draw-toolbar a,\n.v-theme--light .leaflet-draw-toolbar a {\n    background-image: linear-gradient(transparent, transparent),\n        url('/static/img/leaflet-draw-spritesheet.svg') !important;\n    background-repeat: no-repeat !important;\n    background-size: 300px 30px !important;\n}\n\n.v-table,\n.v-data-table {\n    background: var(--sd-surface);\n    border: 1px solid var(--sd-border);\n    border-radius: var(--sd-radius-md);\n    overflow: hidden;\n}\n\n.v-theme--light .v-table tbody tr:hover,\n.theme--light .v-table tbody tr:hover,\n.v-theme--light .v-data-table tbody tr:hover,\n.theme--light .v-data-table tbody tr:hover {\n    background: var(--sd-light-hover-overlay) !important;\n}\n\n.v-theme--dark .v-table tbody tr:hover,\n.theme--dark .v-table tbody tr:hover,\n.v-theme--dark .v-data-table tbody tr:hover,\n.theme--dark .v-data-table tbody tr:hover {\n    background: var(--sd-dark-hover-overlay) !important;\n}\n\n.v-chip {\n    border-radius: 999px !important;\n    border: 1px solid var(--sd-chip-border);\n}\n\n.v-theme--dark .v-application,\n.theme--dark .v-application {\n    background: var(--sd-bg) !important;\n    color: var(--sd-text) !important;\n}\n\nhtml.theme--dark,\nbody.theme--dark {\n    background: var(--sd-dark-body-bg) !important;\n    color: var(--sd-dark-text) !important;\n}\n\n.v-theme--dark header.v-app-bar,\n.theme--dark header.v-app-bar {\n    background-color: var(--sd-dark-app-bar-bg) !important;\n    box-shadow: 0 1px 0 rgba(255, 255, 255, 0.08);\n}\n\n.v-theme--dark .v-navigation-drawer,\n.theme--dark .v-navigation-drawer {\n    border-right: 1px solid var(--sd-dark-border) !important;\n    box-shadow: none;\n}\n\n.v-theme--dark .v-card,\n.theme--dark .v-card {\n    border-color: var(--sd-dark-border);\n    background: var(--sd-dark-surface);\n    box-shadow: none !important;\n}\n\n.v-theme--dark .v-card__text,\n.v-theme--dark .v-list-item-subtitle,\n.theme--dark .v-card__text,\n.theme--dark .v-list-item-subtitle {\n    color: var(--sd-dark-text-soft) !important;\n}\n\n.v-theme--dark .v-field--variant-filled,\n.v-theme--dark .v-field--variant-outlined,\n.theme--dark .v-field--variant-filled,\n.theme--dark .v-field--variant-outlined {\n    background: var(--sd-dark-field-bg) !important;\n}\n\n.v-theme--dark .login-card .auth-card__left,\n.theme--dark .login-card .auth-card__left {\n    background: var(--sd-dark-surface-panel) !important;\n}\n\n.v-theme--light .login-card .auth-card__left,\n.theme--light .login-card .auth-card__left {\n    background: var(--sd-light-surface-panel) !important;\n}\n\n.v-theme--dark .reset-card .auth-card__left,\n.theme--dark .reset-card .auth-card__left {\n    background: var(--sd-dark-surface-panel) !important;\n}\n\n.v-theme--light .reset-card .auth-card__left,\n.theme--light .reset-card .auth-card__left {\n    background: var(--sd-light-surface-panel) !important;\n}\n\n.v-theme--dark .register-card .auth-card__left,\n.theme--dark .register-card .auth-card__left {\n    background: var(--sd-dark-surface-panel) !important;\n}\n\n.v-theme--light .register-card .auth-card__left,\n.theme--light .register-card .auth-card__left {\n    background: var(--sd-light-surface-panel) !important;\n}\n\n.v-theme--dark .v-autocomplete .v-field,\n.v-theme--dark .v-autocomplete .v-field--variant-filled,\n.v-theme--dark .v-autocomplete .v-field--variant-outlined,\n.theme--dark .v-autocomplete .v-field,\n.theme--dark .v-autocomplete .v-field--variant-filled,\n.theme--dark .v-autocomplete .v-field--variant-outlined,\n.theme--dark .v-autocomplete .v-input__slot {\n    background: var(--sd-dark-autocomplete-bg) !important;\n}\n\n.v-theme--dark .v-autocomplete__content,\n.theme--dark .v-autocomplete__content,\n.v-theme--dark .v-autocomplete__content .v-list,\n.theme--dark .v-autocomplete__content .v-list {\n    background: var(--sd-dark-surface-elevated) !important;\n}\n\n.v-theme--dark .v-main,\n.theme--dark .v-main,\n.v-theme--dark .v-list-item-title,\n.theme--dark .v-list-item-title,\n.v-theme--dark .v-card__title,\n.theme--dark .v-card__title {\n    color: var(--sd-dark-text) !important;\n}\n\n.v-theme--dark .v-application,\n.theme--dark .v-application,\n.v-theme--dark .v-application .v-label,\n.theme--dark .v-application .v-label,\n.v-theme--dark .v-application .v-field__input,\n.theme--dark .v-application .v-field__input,\n.v-theme--dark .v-application .v-select__selection-text,\n.theme--dark .v-application .v-select__selection-text,\n.v-theme--dark .v-application .v-list-item-title,\n.theme--dark .v-application .v-list-item-title,\n.v-theme--dark .v-application .v-list-item-subtitle,\n.theme--dark .v-application .v-list-item-subtitle,\n.v-theme--dark .v-application .v-card-title,\n.theme--dark .v-application .v-card-title,\n.v-theme--dark .v-application .v-card-text,\n.theme--dark .v-application .v-card-text,\n.v-theme--dark .v-application .v-toolbar-title,\n.theme--dark .v-application .v-toolbar-title,\n.v-theme--dark .v-application .v-btn__content,\n.theme--dark .v-application .v-btn__content,\n.v-theme--dark .v-application .v-list-item-title a,\n.theme--dark .v-application .v-list-item-title a {\n    color: var(--sd-dark-text-inverse) !important;\n}\n\n.v-theme--dark .v-navigation-drawer,\n.theme--dark .v-navigation-drawer {\n    background: var(--sd-dark-surface-drawer) !important;\n}\n\n.v-theme--dark .v-navigation-drawer .v-list-item,\n.theme--dark .v-navigation-drawer .v-list-item,\n.v-theme--dark .v-navigation-drawer .v-list-item-title,\n.theme--dark .v-navigation-drawer .v-list-item-title,\n.v-theme--dark .v-navigation-drawer .v-list-item-subtitle,\n.theme--dark .v-navigation-drawer .v-list-item-subtitle,\n.v-theme--dark .v-navigation-drawer .v-list-group__header,\n.theme--dark .v-navigation-drawer .v-list-group__header {\n    color: var(--sd-dark-text-inverse) !important;\n}\n\n.v-theme--dark .v-navigation-drawer .v-divider,\n.theme--dark .v-navigation-drawer .v-divider {\n    border-color: var(--sd-dark-border-medium) !important;\n}\n\n.v-theme--dark .grey--text,\n.theme--dark .grey--text,\n.v-theme--dark .text-medium-emphasis,\n.theme--dark .text-medium-emphasis {\n    color: var(--sd-dark-text-strong) !important;\n}\n\n.v-theme--dark .v-menu > .v-overlay__content,\n.theme--dark .v-menu > .v-overlay__content,\n.v-theme--dark .v-dialog > .v-overlay__content,\n.theme--dark .v-dialog > .v-overlay__content {\n    background: var(--sd-dark-surface-elevated) !important;\n}\n\n.v-theme--dark .v-menu__content .v-list-item-subtitle,\n.theme--dark .v-menu__content .v-list-item-subtitle,\n.v-theme--dark .v-overlay .v-list-item-subtitle,\n.theme--dark .v-overlay .v-list-item-subtitle {\n    color: var(--sd-dark-text-muted) !important;\n}\n\n.v-theme--dark .v-autocomplete .v-field__input,\n.theme--dark .v-autocomplete .v-field__input,\n.v-theme--dark .v-autocomplete .v-select__selection,\n.theme--dark .v-autocomplete .v-select__selection,\n.v-theme--dark .v-autocomplete input,\n.theme--dark .v-autocomplete input,\n.v-theme--dark .v-overlay .v-list-item-title,\n.theme--dark .v-overlay .v-list-item-title {\n    color: var(--sd-dark-text) !important;\n}\n\n.v-theme--dark input:-webkit-autofill,\n.theme--dark input:-webkit-autofill,\n.v-theme--dark input:-webkit-autofill:hover,\n.theme--dark input:-webkit-autofill:hover,\n.v-theme--dark input:-webkit-autofill:focus,\n.theme--dark input:-webkit-autofill:focus,\n.v-theme--dark textarea:-webkit-autofill,\n.theme--dark textarea:-webkit-autofill,\n.v-theme--dark textarea:-webkit-autofill:hover,\n.theme--dark textarea:-webkit-autofill:hover,\n.v-theme--dark textarea:-webkit-autofill:focus,\n.theme--dark textarea:-webkit-autofill:focus,\n.v-theme--dark select:-webkit-autofill,\n.theme--dark select:-webkit-autofill,\n.v-theme--dark select:-webkit-autofill:hover,\n.theme--dark select:-webkit-autofill:hover,\n.v-theme--dark select:-webkit-autofill:focus,\n.theme--dark select:-webkit-autofill:focus {\n    -webkit-text-fill-color: var(--sd-dark-text-inverse) !important;\n}\n\n.v-theme--dark .leaflet-touch .leaflet-control-layers,\n.theme--dark .leaflet-touch .leaflet-control-layers,\n.v-theme--dark .leaflet-touch .leaflet-bar,\n.theme--dark .leaflet-touch .leaflet-bar {\n    border-color: var(--sd-dark-leaflet-border) !important;\n}\n\n.v-theme--dark .leaflet-container:not(.leaflet-control-minimap),\n.theme--dark .leaflet-container:not(.leaflet-control-minimap) {\n    background: var(--sd-dark-leaflet-bg) !important;\n}\n\n.v-theme--dark .handle-bl,\n.theme--dark .handle-bl {\n    background-color: var(--sd-dark-surface-muted);\n    background-image: url('/static/img/expand-alt-white.svg');\n}\n\n\n/* Home dashboard page scope: keep page-specific styling isolated here. */\n.dashboard-page {\n    --dashboard-page-padding: 10px;\n    --dashboard-page-max-width: 1400px;\n    --dashboard-section-gap: 16px;\n    --dashboard-section-padding-y: 0;\n    --dashboard-section-padding-x: 0;\n    --dashboard-title-size: 2.125rem;\n    --dashboard-title-weight: 400;\n    --dashboard-title-color: inherit;\n    width: 100%;\n    max-width: var(--dashboard-page-max-width);\n    box-sizing: border-box;\n    margin-left: auto;\n    margin-right: auto;\n    padding: var(--dashboard-page-padding);\n    text-align: center;\n}\n\n.dashboard-page .dashboard-sections-wrapper {\n    display: inline-block;\n    width: fit-content;\n    max-width: 100%;\n    margin-left: auto;\n    margin-right: auto;\n    text-align: left;\n}\n\n.dashboard-page .dashboard-sections-wrapper > .dashboard-section {\n    width: auto;\n    max-width: 100%;\n}\n\n.dashboard-page .dashboard-section {\n    margin: 0 0 var(--dashboard-section-gap) 0 !important;\n    padding-top: var(--dashboard-section-padding-y) !important;\n    padding-bottom: var(--dashboard-section-padding-y) !important;\n    padding-left: var(--dashboard-section-padding-x) !important;\n    padding-right: var(--dashboard-section-padding-x) !important;\n}\n\n.dashboard-page .dashboard-section > .v-row {\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n}\n\n.dashboard-page .dashboard-section__title {\n    font-size: var(--dashboard-title-size);\n    font-weight: var(--dashboard-title-weight);\n    color: var(--dashboard-title-color);\n    margin-left: 0 !important;\n    padding-left: 0 !important;\n}\n\n.v-theme--dark .dashboard-page,\n.theme--dark .dashboard-page {\n    --dashboard-title-color: var(--sd-dark-text-inverse);\n}\n\n.v-theme--dark .dashboard-page .dashboard-section__title,\n.theme--dark .dashboard-page .dashboard-section__title {\n    color: var(--sd-dark-text-inverse) !important;\n}\n\n/* Keep all dashboard sections on identical spacing rules. */\n.dashboard-page .dashboard-section--recent-views,\n.dashboard-page .dashboard-section--recently-uploaded-views,\n.dashboard-page .dashboard-section--favourite-views,\n.dashboard-page .dashboard-section--quick-actions {\n    margin: 0 0 var(--dashboard-section-gap) 0 !important;\n    padding-top: var(--dashboard-section-padding-y) !important;\n    padding-bottom: var(--dashboard-section-padding-y) !important;\n    padding-left: var(--dashboard-section-padding-x) !important;\n    padding-right: var(--dashboard-section-padding-x) !important;\n}\n\n/* Cesium top toolbar + KML dropdown theme styling (global). */\n.cesium-top-tools {\n    background: var(--sd-light-app-bar-bg);\n    border: 1px solid var(--sd-light-border-subtle);\n    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.18);\n    backdrop-filter: blur(4px);\n}\n\n.cesium-kml-dropdown-panel {\n    background: var(--sd-light-surface);\n    color: var(--sd-light-text);\n    border: 1px solid var(--sd-light-border-subtle);\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);\n}\n\n.v-theme--dark .cesium-top-tools,\n.theme--dark .cesium-top-tools {\n    background: var(--sd-dark-app-bar-bg);\n    border-color: var(--sd-dark-border-subtle);\n    box-shadow: 0 10px 26px rgba(0, 0, 0, 0.5);\n}\n\n.v-theme--dark .cesium-kml-dropdown-panel,\n.theme--dark .cesium-kml-dropdown-panel {\n    background: var(--sd-dark-surface-muted);\n    color: var(--sd-dark-text);\n    border-color: var(--sd-dark-border-subtle);\n}\n\n/* Inspection viewer shell refresh: shared global styling for Phase 1A.\n   Use the active app theme instead of pinning the shell to light mode. */\n.inspection-view {\n    padding: 0;\n    background: var(--sd-bg);\n    color: var(--sd-text);\n    height: 100%;\n    min-height: 0;\n    overflow: hidden;\n}\n\n.inspection-view__primary {\n    height: 100%;\n    min-height: 0;\n    padding-right: 0;\n    overflow: hidden;\n}\n\n.inspection-view #inspectionMain,\n.inspection-view #inspectionSpots {\n    height: 100%;\n    min-height: 0;\n}\n\n.inspection-view #inspectionSpots {\n    padding-left: 0;\n    border-radius: 0;\n    overflow: hidden;\n    border: none;\n    box-shadow: none;\n}\n\n.inspection-view .inspection-shell {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n    min-height: 0;\n    overflow: hidden;\n}\n\n.inspection-view .inspection-shell__header {\n    display: flex;\n    flex: 0 0 auto;\n    justify-content: space-between;\n    align-items: center;\n    gap: 6px;\n    overflow-x: auto;\n    overflow-y: hidden;\n    padding: 4px 12px;\n    background: var(--sd-surface);\n    border: none;\n    border-bottom: 1px solid var(--sd-border);\n    border-radius: 0;\n    box-shadow: none;\n    scrollbar-width: none;\n}\n\n.inspection-view .inspection-shell__header::-webkit-scrollbar {\n    display: none;\n}\n\n.inspection-view .inspection-shell__title-group {\n    flex: 0 0 auto;\n    min-width: 0;\n}\n\n.inspection-view .inspection-shell__eyebrow,\n.inspection-view .inspection-gallery__eyebrow,\n.inspection-view .inspection-context-card__eyebrow {\n    display: inline-block;\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.14em;\n    text-transform: uppercase;\n}\n\n.inspection-view .inspection-shell__eyebrow {\n    color: var(--sd-primary);\n    margin-bottom: 1px;\n}\n\n.inspection-view .inspection-shell__title-row {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    flex-wrap: wrap;\n}\n\n.inspection-view .inspection-shell__title {\n    margin: 0;\n    font-family: 'Omnes Medium', 'Inter', sans-serif;\n    font-size: 17px;\n    line-height: 1.05;\n    color: var(--sd-text);\n}\n\n.inspection-view .inspection-shell__title-badge {\n    padding: 2px 7px;\n    border-radius: 6px;\n    background: var(--sd-info);\n    color: var(--sd-light-text-inverse);\n    font-size: 12px;\n    font-weight: 600;\n    text-transform: capitalize;\n}\n\n.inspection-view .inspection-shell__title-badge--profile {\n    background: var(--sd-surface-soft);\n    border: 1px solid var(--sd-border);\n    color: var(--sd-text-secondary);\n}\n\n.inspection-view .inspection-shell__variant-switch {\n    display: inline-flex;\n    padding: 2px;\n    border: 1px solid var(--sd-border);\n    border-radius: 7px;\n    background: var(--sd-surface-soft);\n}\n\n.inspection-view .inspection-shell__variant-button {\n    padding: 3px 9px;\n    border: 0;\n    border-radius: 5px;\n    background: transparent;\n    color: var(--sd-text-secondary);\n    font-size: 12px;\n    font-weight: 600;\n}\n\n.inspection-view .inspection-shell__variant-button--active {\n    background: var(--sd-primary);\n    color: var(--sd-light-text-inverse);\n}\n\n.inspection-view .inspection-shell__meta {\n    display: flex;\n    align-items: stretch;\n    gap: 6px;\n    flex: 0 0 auto;\n    flex-wrap: nowrap;\n    justify-content: flex-end;\n}\n\n.inspection-view .inspection-shell__meta-pill {\n    flex: 0 0 auto;\n    min-width: 80px;\n    padding: 4px 9px;\n    border-radius: 8px;\n    background: var(--sd-surface-soft);\n    border: 1px solid var(--sd-border);\n    color: var(--sd-text);\n}\n\n.inspection-view--split .inspection-shell__header {\n    min-height: 62px;\n    padding: 8px 12px;\n}\n\n.inspection-view--split .inspection-shell__meta-pill {\n    display: none;\n}\n\n.inspection-view--split .inspection-shell__title {\n    font-size: 16px;\n}\n\n.inspection-view--split .inspection-shell__title-group {\n    min-width: 0;\n}\n\n.inspection-view .inspection-shell__meta-label {\n    display: block;\n    margin-bottom: 1px;\n    font-size: 9px;\n    font-weight: 600;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: var(--sd-text-secondary);\n}\n\n.v-theme--dark .inspection-view .inspection-shell__header,\n.theme--dark .inspection-view .inspection-shell__header,\nhtml.theme--dark .inspection-view .inspection-shell__header,\nbody.theme--dark .inspection-view .inspection-shell__header {\n    background: var(--sd-dark-surface-panel) !important;\n    border-bottom-color: var(--sd-dark-border) !important;\n}\n\n.v-theme--dark .inspection-view .inspection-shell__eyebrow,\n.theme--dark .inspection-view .inspection-shell__eyebrow,\nhtml.theme--dark .inspection-view .inspection-shell__eyebrow,\nbody.theme--dark .inspection-view .inspection-shell__eyebrow {\n    color: var(--sd-dark-text-secondary) !important;\n}\n\n.v-theme--dark .inspection-view .inspection-shell__title,\n.theme--dark .inspection-view .inspection-shell__title,\nhtml.theme--dark .inspection-view .inspection-shell__title,\nbody.theme--dark .inspection-view .inspection-shell__title {\n    color: var(--sd-dark-text-inverse) !important;\n}\n\n.v-theme--dark .inspection-view .inspection-shell__title-badge,\n.theme--dark .inspection-view .inspection-shell__title-badge,\nhtml.theme--dark .inspection-view .inspection-shell__title-badge,\nbody.theme--dark .inspection-view .inspection-shell__title-badge {\n    background: var(--sd-dark-surface-control) !important;\n    color: var(--sd-dark-text-inverse) !important;\n}\n\n.v-theme--dark .inspection-view .inspection-shell__variant-switch,\n.theme--dark .inspection-view .inspection-shell__variant-switch,\nhtml.theme--dark .inspection-view .inspection-shell__variant-switch,\nbody.theme--dark .inspection-view .inspection-shell__variant-switch {\n    background: var(--sd-dark-surface-control) !important;\n    border-color: var(--sd-dark-border) !important;\n}\n\n.v-theme--dark .inspection-view .inspection-shell__variant-button,\n.theme--dark .inspection-view .inspection-shell__variant-button,\nhtml.theme--dark .inspection-view .inspection-shell__variant-button,\nbody.theme--dark .inspection-view .inspection-shell__variant-button {\n    color: var(--sd-dark-text-secondary) !important;\n}\n\n.v-theme--dark .inspection-view .inspection-shell__variant-button--active,\n.theme--dark .inspection-view .inspection-shell__variant-button--active,\nhtml.theme--dark .inspection-view .inspection-shell__variant-button--active,\nbody.theme--dark .inspection-view .inspection-shell__variant-button--active {\n    background: var(--sd-primary) !important;\n    color: var(--sd-dark-text-inverse) !important;\n}\n\n.v-theme--dark .inspection-view .inspection-shell__meta-pill,\n.theme--dark .inspection-view .inspection-shell__meta-pill,\nhtml.theme--dark .inspection-view .inspection-shell__meta-pill,\nbody.theme--dark .inspection-view .inspection-shell__meta-pill {\n    background: var(--sd-dark-surface-control) !important;\n    border-color: var(--sd-dark-border) !important;\n    color: var(--sd-dark-text-inverse) !important;\n}\n\n.v-theme--dark .inspection-view .inspection-shell__meta-label,\n.theme--dark .inspection-view .inspection-shell__meta-label,\nhtml.theme--dark .inspection-view .inspection-shell__meta-label,\nbody.theme--dark .inspection-view .inspection-shell__meta-label {\n    color: var(--sd-dark-text-secondary) !important;\n}\n\n.v-theme--dark .inspection-view .inspection-shell__review-toggle,\n.theme--dark .inspection-view .inspection-shell__review-toggle,\nhtml.theme--dark .inspection-view .inspection-shell__review-toggle,\nbody.theme--dark .inspection-view .inspection-shell__review-toggle {\n    background: var(--sd-dark-surface-control) !important;\n    border-color: var(--sd-dark-border) !important;\n    color: var(--sd-dark-text-inverse) !important;\n}\n\n.v-theme--dark .inspection-view .inspection-shell__review-toggle:hover,\n.theme--dark .inspection-view .inspection-shell__review-toggle:hover,\nhtml.theme--dark .inspection-view .inspection-shell__review-toggle:hover,\nbody.theme--dark .inspection-view .inspection-shell__review-toggle:hover {\n    background: var(--sd-dark-surface-control-hover) !important;\n}\n\n.v-theme--dark .inspection-view .inspection-shell__review-toggle-icon,\n.theme--dark .inspection-view .inspection-shell__review-toggle-icon,\nhtml.theme--dark .inspection-view .inspection-shell__review-toggle-icon,\nbody.theme--dark .inspection-view .inspection-shell__review-toggle-icon {\n    color: var(--sd-dark-text-inverse) !important;\n}\n\n.inspection-view .inspection-shell__body {\n    flex: 1;\n    min-height: 0;\n    display: grid;\n    grid-template-columns: minmax(0, 1fr);\n    gap: 0;\n    overflow: hidden;\n}\n\n.inspection-view .inspection-shell__body--context {\n    grid-template-columns: minmax(0, 1fr) minmax(240px, 280px);\n}\n\n.inspection-view .inspection-canvas-stage {\n    position: relative;\n    min-height: 0;\n    overflow: hidden;\n    border-radius: 0;\n    border: none;\n    background: var(--sd-map-canvas-bg);\n    box-shadow: none;\n}\n\n.inspection-view .inspection-context-rail {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    min-height: 0;\n    max-height: 100%;\n    overflow-y: auto;\n    overscroll-behavior: contain;\n    padding: 12px 12px 24px;\n    scrollbar-gutter: stable;\n    background: var(--sd-surface-soft);\n    border-left: 1px solid var(--sd-border);\n}\n\n.inspection-view .inspection-context-rail__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 2px 2px 6px;\n}\n\n.inspection-view .inspection-context-rail__header h3 {\n    margin: 2px 0 0;\n    color: var(--sd-text);\n    font-size: 18px;\n    font-weight: 600;\n}\n\n.inspection-view .inspection-context-rail__close {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 32px;\n    height: 32px;\n    border: 1px solid var(--sd-border);\n    border-radius: 6px;\n    background: var(--sd-surface);\n    color: var(--sd-text-secondary);\n    cursor: pointer;\n}\n\n.inspection-view .inspection-context-card {\n    width: 100%;\n    padding: 14px;\n    border-radius: 14px;\n    background: var(--sd-surface);\n    border: 1px solid var(--sd-border);\n    box-shadow: none;\n    color: var(--sd-text);\n}\n\n.inspection-view .inspection-context-card__header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 12px;\n    margin-bottom: 12px;\n}\n\n.inspection-view .inspection-gallery__eyebrow,\n.inspection-view .inspection-context-card__eyebrow {\n    color: var(--sd-primary);\n}\n\n.inspection-view .inspection-context-card__hint {\n    font-size: 12px;\n    color: var(--sd-text-secondary);\n}\n\n.inspection-view .inspection-stats-grid {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 8px;\n}\n\n.inspection-view .inspection-stat {\n    padding: 8px 10px;\n    border-radius: 10px;\n    background: var(--sd-bg);\n    border: 1px solid var(--sd-border);\n}\n\n.inspection-view .inspection-stat__label {\n    display: block;\n    margin-bottom: 5px;\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: var(--sd-text-secondary);\n}\n\n.inspection-view .inspection-stat strong {\n    color: var(--sd-text);\n}\n\n.inspection-view .inspection-shot-map {\n    padding: 0;\n    overflow: hidden;\n}\n\n.inspection-view .inspection-shot-map__header {\n    padding: 14px 14px 0;\n    margin-bottom: 12px;\n}\n\n.inspection-view .inspection-shot-map__canvas {\n    width: 100%;\n    height: 240px;\n    border-top: 1px solid var(--sd-border);\n}\n\n.inspection-view .inspection-shot-map__empty {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    min-height: 220px;\n    padding: 18px;\n    border-top: 1px solid var(--sd-border);\n    color: var(--sd-text-secondary);\n    font-size: 13px;\n    text-align: center;\n}\n\n.inspection-view .inspection-shot-map .leaflet-container {\n    background: var(--sd-bg) !important;\n}\n\n.inspection-view .inspection-shot-map .leaflet-marker-icon,\n.inspection-view .inspection-shot-map .leaflet-marker-shadow {\n    transition: transform 0.15s ease;\n}\n\n.inspection-view .inspection-powerline-card__subtitle {\n    margin: 6px 0 0;\n    font-size: 13px;\n    line-height: 1.45;\n    color: var(--sd-text-secondary);\n}\n\n.inspection-view .inspection-powerline-card__status {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 92px;\n    padding: 6px 10px;\n    border-radius: 999px;\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    border: 1px solid transparent;\n}\n\n.inspection-view .inspection-powerline-card__status--not-started {\n    background: var(--sd-surface-soft);\n    color: var(--sd-text-secondary);\n    border-color: var(--sd-border);\n}\n\n.inspection-view .inspection-powerline-card__status--empty {\n    background: var(--sd-surface-soft);\n    color: var(--sd-text-secondary);\n    border-color: var(--sd-border);\n}\n\n.inspection-view .inspection-powerline-card__status--requested {\n    background: var(--sd-primary-surface-alpha);\n    color: var(--sd-primary);\n    border-color: var(--sd-primary-border-alpha);\n}\n\n.inspection-view .inspection-powerline-card__status--processing {\n    background: var(--sd-primary-surface-alpha);\n    color: var(--sd-primary);\n    border-color: var(--sd-primary-border-alpha);\n}\n\n.inspection-view .inspection-powerline-card__status--completed,\n.inspection-view .inspection-powerline-card__status--complete {\n    background: var(--sd-success-surface-alpha);\n    color: var(--sd-success);\n    border-color: var(--sd-success-border-alpha);\n}\n\n.inspection-view .inspection-powerline-card__status--error,\n.inspection-view .inspection-powerline-card__status--unavailable {\n    background: var(--sd-error-surface-alpha);\n    color: var(--sd-error);\n    border-color: var(--sd-error-border-alpha);\n}\n\n.inspection-view .inspection-powerline-card__content {\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n}\n\n.inspection-view .inspection-powerline-card__status--compact {\n    align-self: flex-start;\n}\n\n.inspection-view .inspection-powerline-card__empty {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    min-height: 64px;\n    color: var(--sd-text-secondary);\n    font-size: 13px;\n}\n\n.inspection-view .inspection-powerline-card__summary {\n    margin: 0;\n    font-size: 13px;\n    line-height: 1.55;\n    color: var(--sd-text);\n}\n\n.inspection-view .inspection-powerline-card__progress {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.inspection-view .inspection-powerline-card__progress-meta {\n    display: flex;\n    justify-content: space-between;\n    gap: 12px;\n    font-size: 12px;\n    color: var(--sd-text-secondary);\n}\n\n.inspection-view .inspection-powerline-card__progress-meta span:first-child {\n    color: var(--sd-text);\n    font-weight: 600;\n}\n\n.inspection-view .inspection-powerline-card__progress-track {\n    position: relative;\n    height: 8px;\n    overflow: hidden;\n    border-radius: 999px;\n    background: var(--sd-surface-soft);\n    border: 1px solid var(--sd-border);\n}\n\n.inspection-view .inspection-powerline-card__progress-bar {\n    display: block;\n    height: 100%;\n    border-radius: inherit;\n    background: linear-gradient(90deg, var(--sd-primary) 0%, var(--sd-primary-gradient-end) 100%);\n    transition: width 0.2s ease;\n}\n\n.inspection-view .inspection-powerline-card__stats {\n    margin-top: -2px;\n}\n\n.inspection-view .inspection-powerline-card__detector {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 14px;\n    border-radius: 12px;\n    border: 1px solid var(--sd-border);\n    background: var(--sd-surface-soft);\n}\n\n.inspection-view .inspection-powerline-card__detector-copy {\n    display: flex;\n    flex: 1 1 200px;\n    flex-direction: column;\n    gap: 8px;\n    min-width: 0;\n}\n\n.inspection-view .inspection-powerline-card__detector-heading {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 10px;\n}\n\n.inspection-view .inspection-powerline-card__detector-title {\n    color: var(--sd-text);\n    font-size: 14px;\n    font-weight: 700;\n    letter-spacing: 0.01em;\n}\n\n.inspection-view .inspection-powerline-card__detector-text {\n    margin: 0;\n    color: var(--sd-text-secondary);\n    font-size: 13px;\n    line-height: 1.5;\n}\n\n.inspection-view .inspection-powerline-card__actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n}\n\n.inspection-view .inspection-powerline-card__action {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    min-height: 40px;\n    padding: 10px 14px;\n    border-radius: 10px;\n    border: 1px solid var(--sd-border);\n    background: var(--sd-surface);\n    color: var(--sd-text);\n    font-size: 13px;\n    font-weight: 700;\n    line-height: 1;\n    transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease;\n}\n\n.inspection-view .inspection-powerline-card__action:hover {\n    border-color: var(--sd-primary-border-hover);\n    color: var(--sd-primary);\n    background: var(--sd-surface-soft);\n}\n\n.inspection-view .inspection-powerline-card__action:disabled {\n    cursor: wait;\n    border-color: var(--sd-border);\n    background: var(--sd-surface-soft);\n    color: var(--sd-text-muted);\n}\n\n.inspection-view .inspection-powerline-card__action--primary {\n    border-color: var(--sd-primary-border-muted);\n    background: var(--sd-primary-surface-soft-alpha);\n    color: var(--sd-primary);\n}\n\n.inspection-view .inspection-powerline-card__action-icon {\n    color: inherit !important;\n}\n\n.inspection-view .inspection-gallery-root {\n    --inspection-gallery-left-offset: 64px;\n    position: absolute;\n    left: var(--inspection-gallery-left-offset);\n    right: 0;\n    bottom: 0;\n    z-index: 510;\n    pointer-events: none;\n    --inspection-gallery-right-offset: max(\n        190px,\n        calc(var(--leaflet-minimap-left-margin, 170px) + 210px)\n    );\n}\n\n.inspection-view .inspection-gallery-root > * {\n    pointer-events: auto;\n}\n\n.inspection-view .inspection-source-photos {\n    position: absolute;\n    left: 0;\n    right: var(--inspection-gallery-right-offset);\n    bottom: 42px;\n    display: flex;\n    min-height: 112px;\n    overflow: hidden;\n    border: 1px solid var(--sd-border);\n    border-radius: 10px;\n    background: var(--sd-surface);\n    color: var(--sd-text);\n    box-shadow: 0 8px 20px rgba(9, 15, 27, 0.22);\n    transition: bottom 0.15s ease;\n}\n\n.inspection-view .inspection-source-photos--gallery-open {\n    bottom: 164px;\n}\n\n.inspection-view .inspection-source-photos__header {\n    display: flex;\n    flex: 0 0 132px;\n    flex-direction: column;\n    justify-content: space-between;\n    padding: 12px;\n    border-right: 1px solid var(--sd-border);\n}\n\n.inspection-view .inspection-source-photos__title-group {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.inspection-view .inspection-source-photos__eyebrow {\n    color: var(--sd-primary);\n    font-size: 10px;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n}\n\n.inspection-view .inspection-source-photos__title {\n    color: var(--sd-text);\n    font-size: 14px;\n}\n\n.inspection-view .inspection-source-photos__count {\n    color: var(--sd-text-muted);\n    font-size: 11px;\n}\n\n.inspection-view .inspection-source-photos__list {\n    display: flex;\n    flex: 1 1 auto;\n    gap: 8px;\n    min-width: 0;\n    overflow-x: auto;\n    padding: 8px;\n}\n\n.inspection-view .inspection-source-photos__empty {\n    align-self: center;\n    flex: 1 1 auto;\n    margin: 8px;\n    padding: 10px 12px;\n    border: 1px dashed var(--sd-border);\n    border-radius: 8px;\n    color: var(--sd-text-secondary);\n    font-size: 12px;\n    text-align: center;\n}\n\n.inspection-view .inspection-source-photos__candidate {\n    position: relative;\n    display: flex;\n    flex: 0 0 112px;\n    flex-direction: column;\n    gap: 5px;\n    min-width: 0;\n    padding: 4px;\n    overflow: hidden;\n    border: 1px solid var(--sd-border);\n    border-radius: 10px;\n    background: transparent;\n    color: var(--sd-text-secondary);\n    cursor: pointer;\n    text-align: left;\n}\n\n.inspection-view .inspection-source-photos__candidate:hover {\n    background: var(--sd-surface-soft);\n}\n\n.inspection-view .inspection-source-photos__candidate:disabled {\n    cursor: wait;\n    opacity: 0.62;\n}\n\n.inspection-view .inspection-source-photos__candidate:disabled:hover {\n    background: transparent;\n}\n\n.inspection-view .inspection-source-photos__candidate--selected {\n    border-color: var(--sd-primary);\n    box-shadow: inset 0 0 0 1px var(--sd-primary);\n}\n\n.inspection-view .inspection-source-photos__thumbnail {\n    width: 100%;\n    border-radius: 7px;\n}\n\n.inspection-view .inspection-source-photos__rank,\n.inspection-view .inspection-source-photos__state {\n    position: absolute;\n    top: 5px;\n    z-index: 1;\n    border-radius: 4px;\n    background: rgba(15, 23, 42, 0.78);\n    color: #ffffff;\n    font-size: 10px;\n    font-weight: 700;\n    line-height: 18px;\n}\n\n.inspection-view .inspection-source-photos__rank {\n    left: 5px;\n    width: 18px;\n    text-align: center;\n}\n\n.inspection-view .inspection-source-photos__state {\n    right: 5px;\n    padding: 0 5px;\n}\n\n.inspection-view .inspection-source-photos__filename {\n    overflow: hidden;\n    color: var(--sd-text-secondary);\n    font-size: 10px;\n    line-height: 14px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.inspection-view .inspection-source-photos__legend {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px 12px;\n    padding: 0 12px 10px;\n    color: var(--sd-text-secondary);\n    font-size: 11px;\n}\n\n.inspection-view .inspection-source-photos__legend > span {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n}\n\n.inspection-view .inspection-source-photos__legend-icon {\n    line-height: 1;\n}\n\n.inspection-view .inspection-source-photos__legend-icon--selection {\n    color: #37a5ff;\n}\n\n.inspection-view .inspection-source-photos__legend-icon--finding {\n    color: var(--sd-danger);\n}\n\n.inspection-view .inspection-gallery__toggle {\n    position: absolute;\n    left: 0;\n    right: var(--inspection-gallery-right-offset);\n    bottom: 0;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 10px 16px;\n    border: none;\n    border-radius: 0;\n    background: var(--sd-dark-surface-control);\n    border-top: 1px solid var(--sd-dark-panel-border-soft);\n    color: var(--sd-dark-panel-text-secondary);\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background 0.15s ease;\n    pointer-events: auto;\n}\n\n.inspection-view .inspection-gallery__toggle:hover {\n    background: var(--sd-dark-surface-control-hover);\n}\n\n.inspection-view .inspection-gallery__toggle-icon {\n    color: var(--sd-dark-panel-accent) !important;\n}\n\n.inspection-view .inspection-gallery__toggle-label {\n    font-weight: 700;\n    color: var(--sd-dark-panel-text);\n    letter-spacing: 0.01em;\n}\n\n.inspection-view .inspection-gallery__toggle-count {\n    font-size: 12px;\n    font-weight: 500;\n    color: var(--sd-dark-panel-text-muted);\n}\n\n.inspection-view .inspection-gallery__toggle-chevron {\n    margin-left: auto;\n    color: var(--sd-dark-panel-text-muted) !important;\n}\n\n.inspection-view .inspection-gallery {\n    position: absolute;\n    left: 0;\n    right: var(--inspection-gallery-right-offset);\n    bottom: 0;\n    width: auto;\n    max-width: none;\n    border-radius: 12px !important;\n    border: 1px solid var(--sd-dark-panel-border-soft);\n    background: var(--sd-dark-surface-control) !important;\n    box-shadow: 0 8px 20px rgba(9, 15, 27, 0.22);\n    color: var(--sd-dark-panel-text);\n}\n\n.inspection-view .inspection-gallery__dialog {\n    display: flex;\n    flex-direction: column;\n    width: min(1760px, 94vw);\n    max-width: calc(100vw - 24px);\n    max-height: calc(100vh - 24px);\n    overflow: hidden;\n}\n\n.inspection-view .inspection-gallery__dialog-header {\n    flex: 0 0 auto;\n}\n\n.inspection-view .inspection-gallery__dialog-body {\n    flex: 1 1 auto;\n    overflow: auto;\n}\n\n.inspection-view .inspection-gallery__toolbar {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    min-height: 48px;\n    padding: 8px 14px 4px;\n}\n\n.inspection-view .inspection-gallery__icon-button {\n    color: var(--sd-dark-panel-text);\n}\n\n.inspection-view .inspection-gallery__title-group {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n}\n\n.inspection-view .inspection-gallery__title {\n    font-size: 18px;\n    font-weight: 700;\n    color: var(--sd-dark-panel-text);\n}\n\n.inspection-view .inspection-gallery__count {\n    margin-left: 8px;\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--sd-dark-text-secondary);\n}\n\n.inspection-view .inspection-gallery__strip {\n    padding: 0 10px 10px;\n}\n\n.inspection-view .inspection-gallery__thumbnail {\n    height: 88px;\n    cursor: pointer;\n    border-radius: 10px;\n    border: 1px solid var(--sd-dark-panel-border-faint);\n}\n\n.inspection-view .inspection-gallery__thumbnail--selected {\n    border-color: var(--sd-dark-panel-selected-border);\n    box-shadow: inset 0 0 0 1px var(--sd-dark-panel-selected-ring);\n}\n\n.inspection-view .inspection-gallery__dialog {\n    border-radius: 24px !important;\n    overflow: hidden;\n}\n\n.inspection-view .inspection-gallery__dialog-header {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 18px 22px;\n}\n\n.inspection-view .inspection-gallery__dialog-body {\n    background: var(--sd-bg);\n}\n\n.inspection-view .inspection-gallery__dialog-count {\n    font-size: 13px;\n    font-weight: 600;\n    color: var(--sd-text-secondary);\n}\n\n.inspection-view .inspection-gallery__empty-card {\n    background: transparent;\n}\n\n.inspection-view .inspection-gallery .v-slide-group__prev,\n.inspection-view .inspection-gallery .v-slide-group__next {\n    color: var(--sd-dark-panel-text);\n}\n\n.inspection-view .inspection-gallery .v-slide-group__prev--disabled,\n.inspection-view .inspection-gallery .v-slide-group__next--disabled {\n    opacity: 0.35;\n}\n\n.inspection-view .inspection-gallery .v-badge__badge {\n    background: var(--sd-primary-active) !important;\n    color: var(--sd-light-text-inverse) !important;\n}\n\n.inspection-view .inspection-gallery .v-card-text {\n    color: inherit;\n}\n\nbody.theme--light .inspection-view .inspection-gallery-root,\nhtml.theme--light .inspection-view .inspection-gallery-root,\n.theme--light .inspection-view .inspection-gallery-root,\n.v-theme--light .inspection-view .inspection-gallery-root {\n    --inspection-gallery-left-offset: 64px;\n}\n\nbody.theme--light .inspection-view .inspection-gallery__toggle,\nhtml.theme--light .inspection-view .inspection-gallery__toggle,\n.theme--light .inspection-view .inspection-gallery__toggle,\n.v-theme--light .inspection-view .inspection-gallery__toggle {\n    background: var(--sd-light-surface-panel);\n    border-top-color: var(--sd-light-border-subtle);\n    color: var(--sd-light-text-secondary);\n}\n\nbody.theme--light .inspection-view .inspection-gallery__toggle:hover,\nhtml.theme--light .inspection-view .inspection-gallery__toggle:hover,\n.theme--light .inspection-view .inspection-gallery__toggle:hover,\n.v-theme--light .inspection-view .inspection-gallery__toggle:hover {\n    background: var(--sd-light-surface-muted);\n}\n\nbody.theme--light .inspection-view .inspection-gallery__toggle-icon,\nhtml.theme--light .inspection-view .inspection-gallery__toggle-icon,\n.theme--light .inspection-view .inspection-gallery__toggle-icon,\n.v-theme--light .inspection-view .inspection-gallery__toggle-icon {\n    color: var(--sd-light-primary-active) !important;\n}\n\nbody.theme--light .inspection-view .inspection-gallery__toggle-label,\nhtml.theme--light .inspection-view .inspection-gallery__toggle-label,\n.theme--light .inspection-view .inspection-gallery__toggle-label,\n.v-theme--light .inspection-view .inspection-gallery__toggle-label {\n    color: var(--sd-light-text-strong);\n}\n\nbody.theme--light .inspection-view .inspection-gallery__toggle-count,\nhtml.theme--light .inspection-view .inspection-gallery__toggle-count,\n.theme--light .inspection-view .inspection-gallery__toggle-count,\n.v-theme--light .inspection-view .inspection-gallery__toggle-count,\nbody.theme--light .inspection-view .inspection-gallery__toggle-chevron,\nhtml.theme--light .inspection-view .inspection-gallery__toggle-chevron,\n.theme--light .inspection-view .inspection-gallery__toggle-chevron,\n.v-theme--light .inspection-view .inspection-gallery__toggle-chevron {\n    color: var(--sd-light-text-secondary) !important;\n}\n\nbody.theme--light .inspection-view .inspection-gallery,\nhtml.theme--light .inspection-view .inspection-gallery,\n.theme--light .inspection-view .inspection-gallery,\n.v-theme--light .inspection-view .inspection-gallery {\n    border-color: var(--sd-light-border-subtle);\n    background: var(--sd-light-surface-panel) !important;\n    box-shadow: 0 8px 20px rgba(15, 23, 42, 0.12);\n    color: var(--sd-light-text);\n}\n\nbody.theme--light .inspection-view .inspection-gallery__toolbar,\nhtml.theme--light .inspection-view .inspection-gallery__toolbar,\n.theme--light .inspection-view .inspection-gallery__toolbar,\n.v-theme--light .inspection-view .inspection-gallery__toolbar {\n    background: var(--sd-light-surface-panel);\n}\n\nbody.theme--light .inspection-view .inspection-gallery__icon-button,\nhtml.theme--light .inspection-view .inspection-gallery__icon-button,\n.theme--light .inspection-view .inspection-gallery__icon-button,\n.v-theme--light .inspection-view .inspection-gallery__icon-button,\nbody.theme--light .inspection-view .inspection-gallery__title,\nhtml.theme--light .inspection-view .inspection-gallery__title,\n.theme--light .inspection-view .inspection-gallery__title,\n.v-theme--light .inspection-view .inspection-gallery__title {\n    color: var(--sd-light-text);\n}\n\nbody.theme--light .inspection-view .inspection-gallery__count,\nhtml.theme--light .inspection-view .inspection-gallery__count,\n.theme--light .inspection-view .inspection-gallery__count,\n.v-theme--light .inspection-view .inspection-gallery__count,\nbody.theme--light .inspection-view .inspection-gallery__dialog-count,\nhtml.theme--light .inspection-view .inspection-gallery__dialog-count,\n.theme--light .inspection-view .inspection-gallery__dialog-count,\n.v-theme--light .inspection-view .inspection-gallery__dialog-count {\n    color: var(--sd-light-text-secondary);\n}\n\nbody.theme--light .inspection-view .inspection-gallery__thumbnail,\nhtml.theme--light .inspection-view .inspection-gallery__thumbnail,\n.theme--light .inspection-view .inspection-gallery__thumbnail,\n.v-theme--light .inspection-view .inspection-gallery__thumbnail {\n    border-color: var(--sd-light-border-subtle);\n}\n\nbody.theme--light .inspection-view .inspection-gallery__thumbnail--selected,\nhtml.theme--light .inspection-view .inspection-gallery__thumbnail--selected,\n.theme--light .inspection-view .inspection-gallery__thumbnail--selected,\n.v-theme--light .inspection-view .inspection-gallery__thumbnail--selected {\n    border-color: var(--sd-light-primary-active);\n    box-shadow: inset 0 0 0 1px var(--sd-light-primary-active);\n}\n\nbody.theme--light .inspection-view .inspection-gallery .v-slide-group__prev,\nbody.theme--light .inspection-view .inspection-gallery .v-slide-group__next,\nhtml.theme--light .inspection-view .inspection-gallery .v-slide-group__prev,\nhtml.theme--light .inspection-view .inspection-gallery .v-slide-group__next,\n.theme--light .inspection-view .inspection-gallery .v-slide-group__prev,\n.theme--light .inspection-view .inspection-gallery .v-slide-group__next,\n.v-theme--light .inspection-view .inspection-gallery .v-slide-group__prev,\n.v-theme--light .inspection-view .inspection-gallery .v-slide-group__next {\n    color: var(--sd-light-text-strong);\n}\n\nbody.theme--light .inspection-view .inspection-gallery .v-badge__badge,\nhtml.theme--light .inspection-view .inspection-gallery .v-badge__badge,\n.theme--light .inspection-view .inspection-gallery .v-badge__badge,\n.v-theme--light .inspection-view .inspection-gallery .v-badge__badge {\n    background: var(--sd-light-primary-surface) !important;\n    color: var(--sd-light-text-inverse) !important;\n}\n\nbody.theme--light .inspection-view .inspection-gallery__dialog-body,\nhtml.theme--light .inspection-view .inspection-gallery__dialog-body,\n.theme--light .inspection-view .inspection-gallery__dialog-body,\n.v-theme--light .inspection-view .inspection-gallery__dialog-body {\n    background: var(--sd-light-surface);\n}\n\n.inspection-view .leaflet-container:not(.leaflet-control-minimap) {\n    background: var(--sd-bg) !important;\n}\n\n.inspection-view .leaflet-top.leaflet-left,\n.inspection-view .leaflet-top.leaflet-right {\n    top: 16px;\n}\n\n.inspection-view .leaflet-top.leaflet-left {\n    left: 18px;\n}\n\n.inspection-view .leaflet-top.leaflet-right {\n    right: 18px;\n}\n\n.inspection-view .leaflet-bottom.leaflet-left {\n    left: 12px;\n    bottom: 12px;\n}\n\n.inspection-view .leaflet-bottom.leaflet-right {\n    right: 12px;\n    bottom: 12px;\n}\n\n.inspection-view .leaflet-bar,\n.inspection-view .easy-button-container.leaflet-bar,\n.inspection-view .leaflet-draw-toolbar {\n    border: 1px solid var(--sd-border);\n    border-radius: 10px;\n    overflow: hidden;\n    margin-top: auto;\n    box-shadow: 0 4px 12px rgba(15, 23, 42, 0.10);\n}\n\n.inspection-view .leaflet-top.leaflet-left .leaflet-bar + .leaflet-bar {\n    margin-top: 6px;\n}\n\n.inspection-view .leaflet-bar > a,\n.inspection-view .easy-button-button,\n.inspection-view .leaflet-draw-toolbar > a {\n    display: flex !important;\n    align-items: center;\n    justify-content: center;\n    padding: 0 !important;\n    text-align: center;\n    width: 36px !important;\n    height: 36px !important;\n    line-height: 36px !important;\n    border-bottom: 1px solid var(--sd-border) !important;\n    background-color: var(--sd-surface);\n    color: var(--sd-text) !important;\n}\n\n.inspection-view .leaflet-bar > a > *,\n.inspection-view .easy-button-button > * {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: auto;\n    line-height: 1 !important;\n}\n\n.inspection-view .leaflet-bar a::before,\n.inspection-view .leaflet-bar a::after,\n.inspection-view .easy-button-button::before,\n.inspection-view .easy-button-button::after {\n    margin: auto;\n}\n\n.inspection-view .leaflet-bar i,\n.inspection-view .easy-button-button i,\n.inspection-view .leaflet-draw-toolbar i {\n    line-height: 1 !important;\n}\n\n.inspection-view .leaflet-draw-toolbar > a {\n    background-image: linear-gradient(transparent, transparent),\n        url('/static/img/leaflet-draw-spritesheet.svg') !important;\n    background-repeat: no-repeat !important;\n    background-size: 300px 30px !important;\n}\n\n.leaflet-touch .inspection-view .leaflet-draw-toolbar .leaflet-draw-draw-polyline {\n    background-position: -2px -2px !important;\n}\n\n.leaflet-touch .inspection-view .leaflet-draw-toolbar .leaflet-draw-draw-polygon {\n    background-position: -31px -2px !important;\n}\n\n.leaflet-touch .inspection-view .leaflet-draw-toolbar .leaflet-draw-draw-rectangle {\n    background-position: -62px -2px !important;\n}\n\n.leaflet-touch .inspection-view .leaflet-draw-toolbar .leaflet-draw-draw-circle {\n    background-position: -92px -2px !important;\n}\n\n.leaflet-touch .inspection-view .leaflet-draw-toolbar .leaflet-draw-draw-marker {\n    background-position: -122px -2px !important;\n}\n\n.leaflet-touch .inspection-view .leaflet-draw-toolbar .leaflet-draw-draw-circlemarker {\n    background-position: -273px -2px !important;\n}\n\n.leaflet-touch .inspection-view .leaflet-draw-toolbar .leaflet-draw-edit-edit {\n    background-position: -152px -2px !important;\n}\n\n.leaflet-touch .inspection-view .leaflet-draw-toolbar .leaflet-draw-edit-remove {\n    background-position: -182px -2px !important;\n}\n\n.inspection-view .leaflet-bar > a:last-child,\n.inspection-view .easy-button-button:last-child {\n    border-bottom: 0 !important;\n}\n\n.inspection-view .leaflet-bar > a:hover,\n.inspection-view .easy-button-button:hover,\n.inspection-view .leaflet-draw-toolbar > a:hover {\n    background-color: var(--sd-surface-soft);\n}\n\n.inspection-view .easy-button-button.leaflet-bar-part.leaflet-interactive.unnamed-state-active {\n    padding: 0;\n}\n\n.inspection-view .downloadImageButton,\n.inspection-view .hideAutoAnnotationsButton,\n.inspection-view .hideSpotsMap {\n    background-size: 18px;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.inspection-view .downloadImageButton {\n    background-image: url('/static/img/download.svg');\n}\n\n.inspection-view .hideAutoAnnotationsButton {\n    background-image: url('/static/img/robot.svg');\n}\n\n.inspection-view .hideSpotsMap {\n    background-image: url('/static/img/smartview_markers/inspection_marker_white.png') !important;\n}\n\n.inspection-view .findSimilarButton {\n    text-align: center;\n}\n\n.inspection-view .findSimilarButton i {\n    line-height: 26px;\n}\n\n.inspection-view .findSimilarButton.active {\n    background-color: var(--sd-surface-soft) !important;\n    color: var(--sd-primary) !important;\n}\n\n.inspection-view .hideAutoAnnotationsButton.hidden:after,\n.inspection-view .hideSpotsMap.hidden:after {\n    content: '';\n    position: absolute;\n    width: 3px;\n    height: 100%;\n    top: 0;\n    display: block;\n    background: var(--sd-text) !important;\n    left: 50%;\n    transform: translate(-50%, 0) rotate(45deg);\n}\n\n.inspection-view .leaflet-draw-actions {\n    left: 8px !important;\n}\n\n@media only screen and (max-height: 780px) {\n    .inspection-view .inspection-gallery__toggle {\n        gap: 6px;\n        min-height: 28px;\n        padding: 5px 12px;\n        font-size: 12px;\n    }\n\n    .inspection-view .inspection-gallery__toggle-count {\n        font-size: 11px;\n    }\n\n    .inspection-view .leaflet-top.leaflet-left,\n    .inspection-view .leaflet-top.leaflet-right {\n        top: 0px;\n    }\n\n    .inspection-view .leaflet-top.leaflet-left {\n        left: 10px;\n    }\n\n    .inspection-view .leaflet-top.leaflet-right {\n        right: 10px;\n    }\n\n    .inspection-view .leaflet-bar > a,\n    .inspection-view .easy-button-button,\n    .inspection-view .leaflet-draw-toolbar > a {\n        width: 27px !important;\n        height: 22px !important;\n        line-height: 22px !important;\n    }\n\n    .inspection-view .leaflet-top.leaflet-left .leaflet-bar + .leaflet-bar {\n        margin-top: 0;\n    }\n\n    .inspection-view .downloadImageButton,\n    .inspection-view .hideAutoAnnotationsButton,\n    .inspection-view .hideSpotsMap {\n        background-size: 13px;\n    }\n\n    .inspection-view .findSimilarButton i {\n        line-height: 18px;\n    }\n}\n\n.v-theme--dark .inspection-view .leaflet-top.leaflet-left .leaflet-bar,\n.theme--dark .inspection-view .leaflet-top.leaflet-left .leaflet-bar,\n.v-theme--dark .inspection-view .leaflet-top.leaflet-left .easy-button-container.leaflet-bar,\n.theme--dark .inspection-view .leaflet-top.leaflet-left .easy-button-container.leaflet-bar,\n.v-theme--dark .inspection-view .leaflet-top.leaflet-left .leaflet-draw-toolbar,\n.theme--dark .inspection-view .leaflet-top.leaflet-left .leaflet-draw-toolbar {\n    background: var(--sd-surface) !important;\n    border-color: var(--sd-border) !important;\n}\n\n.v-theme--dark .inspection-view .leaflet-top.leaflet-left .leaflet-bar > a,\n.theme--dark .inspection-view .leaflet-top.leaflet-left .leaflet-bar > a,\n.v-theme--dark .inspection-view .leaflet-top.leaflet-left .easy-button-button,\n.theme--dark .inspection-view .leaflet-top.leaflet-left .easy-button-button,\n.v-theme--dark .inspection-view .leaflet-top.leaflet-left .leaflet-draw-toolbar > a,\n.theme--dark .inspection-view .leaflet-top.leaflet-left .leaflet-draw-toolbar > a {\n    background-color: var(--sd-surface) !important;\n    border-bottom-color: var(--sd-border) !important;\n    color: var(--sd-dark-text-inverse) !important;\n}\n\n.v-theme--dark .inspection-view .leaflet-top.leaflet-left .leaflet-draw-toolbar > a,\n.theme--dark .inspection-view .leaflet-top.leaflet-left .leaflet-draw-toolbar > a {\n    background-image: linear-gradient(transparent, transparent),\n        url('/static/img/leaflet-draw-spritesheet-white.svg') !important;\n}\n\n.v-theme--dark .inspection-view .leaflet-top.leaflet-left .easy-button-button *,\n.theme--dark .inspection-view .leaflet-top.leaflet-left .easy-button-button * {\n    color: var(--sd-dark-text-inverse) !important;\n}\n\n.v-theme--dark .inspection-view .leaflet-top.leaflet-left .inspectionImageDownloadButton,\n.theme--dark .inspection-view .leaflet-top.leaflet-left .inspectionImageDownloadButton {\n    background-image: url('/static/img/download-white.svg') !important;\n    background-color: var(--sd-dark-surface-control) !important;\n    color: var(--sd-dark-text-inverse) !important;\n}\n\n.v-theme--dark .inspection-view .leaflet-top.leaflet-left .hideAutoAnnotationsButton,\n.theme--dark .inspection-view .leaflet-top.leaflet-left .hideAutoAnnotationsButton {\n    background-color: var(--sd-dark-surface-control) !important;\n    background-image: url('/static/img/robot-white.svg') !important;\n    color: var(--sd-dark-text-inverse) !important;\n}\n\n.v-theme--dark .inspection-view .leaflet-top.leaflet-left .quality-button,\n.theme--dark .inspection-view .leaflet-top.leaflet-left .quality-button {\n    background-color: var(--sd-dark-surface-control) !important;\n    color: var(--sd-dark-text-inverse) !important;\n}\n\n.v-theme--dark .inspection-view .leaflet-top.leaflet-left .hideSpotsMap,\n.theme--dark .inspection-view .leaflet-top.leaflet-left .hideSpotsMap {\n    background-color: var(--sd-dark-surface-control) !important;\n    color: var(--sd-dark-text-inverse) !important;\n    background-image: url('/static/img/smartview_markers/inspection_marker_white.png') !important;\n}\n\n.v-theme--dark .inspection-view .leaflet-top.leaflet-left .findSimilarButton.active,\n.theme--dark .inspection-view .leaflet-top.leaflet-left .findSimilarButton.active {\n    background-color: var(--sd-surface-soft) !important;\n    color: var(--sd-dark-text-inverse) !important;\n}\n\n.v-theme--dark .inspection-view .leaflet-top.leaflet-left .hideAutoAnnotationsButton.hidden:after,\n.theme--dark .inspection-view .leaflet-top.leaflet-left .hideAutoAnnotationsButton.hidden:after,\n.v-theme--dark .inspection-view .leaflet-top.leaflet-left .hideSpotsMap.hidden:after,\n.theme--dark .inspection-view .leaflet-top.leaflet-left .hideSpotsMap.hidden:after {\n    background: var(--sd-dark-text-inverse) !important;\n}\n\n.v-theme--dark .inspection-view .leaflet-draw-actions a,\n.theme--dark .inspection-view .leaflet-draw-actions a,\n.v-theme--dark .inspection-view .leaflet-draw-tooltip,\n.theme--dark .inspection-view .leaflet-draw-tooltip {\n    background-color: var(--sd-dark-draw-tooltip-bg) !important;\n    border-color: var(--sd-border) !important;\n    color: var(--sd-dark-text-inverse) !important;\n}\n\n.v-theme--dark .inspection-view .leaflet-draw-tooltip:before,\n.theme--dark .inspection-view .leaflet-draw-tooltip:before {\n    border-right-color: var(--sd-surface) !important;\n}\n\n.v-theme--dark .inspection-view .leaflet-draw-tooltip-subtext,\n.theme--dark .inspection-view .leaflet-draw-tooltip-subtext {\n    color: var(--sd-dark-text-soft) !important;\n}\n\n.v-theme--dark .inspection-view .leaflet-top.leaflet-left .leaflet-bar > a:hover,\n.theme--dark .inspection-view .leaflet-top.leaflet-left .leaflet-bar > a:hover,\n.v-theme--dark .inspection-view .leaflet-top.leaflet-left .easy-button-button:hover,\n.theme--dark .inspection-view .leaflet-top.leaflet-left .easy-button-button:hover,\n.v-theme--dark .inspection-view .leaflet-top.leaflet-left .leaflet-draw-toolbar > a:hover,\n.theme--dark .inspection-view .leaflet-top.leaflet-left .leaflet-draw-toolbar > a:hover,\n.v-theme--dark .inspection-view .leaflet-draw-actions a:hover,\n.theme--dark .inspection-view .leaflet-draw-actions a:hover {\n    background-color: var(--sd-surface-soft) !important;\n    color: var(--sd-dark-text-inverse) !important;\n}\n\n.inspection-view .easy-button-button .color-button {\n    display: block;\n    width: 100%;\n    height: 100%;\n    border-radius: inherit;\n}\n\n.inspection-view .leaflet-control-minimap {\n    border: 1px solid var(--sd-dark-border-medium);\n    border-radius: 12px;\n    overflow: hidden;\n    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.22);\n}\n\n.inspection-view .leaflet-control-minimap-toggle-display {\n    background-color: var(--sd-dark-draw-tooltip-bg);\n}\n\n.inspection-view #altitudecontainer,\n.inspection-view #colorbar-container,\n.inspection-view .leaflet-card,\n.inspection-view .v-btn-graph {\n    box-shadow: 0 14px 30px rgba(15, 23, 42, 0.18);\n}\n\n/* --- Review Mode Toggle Button --- */\n\n.inspection-view .inspection-shell__review-toggle {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    padding: 4px 10px;\n    border: 1px solid var(--sd-primary-border-soft);\n    border-radius: 10px;\n    background: linear-gradient(180deg, var(--sd-light-surface-selected) 0%, var(--sd-light-primary-surface-strong) 100%);\n    color: var(--sd-light-primary-active);\n    font-size: 11px;\n    font-weight: 600;\n    letter-spacing: 0.01em;\n    cursor: pointer;\n    white-space: nowrap;\n    transition: background 0.15s ease, box-shadow 0.15s ease;\n}\n\n.inspection-view .inspection-shell__review-toggle:hover {\n    background: linear-gradient(180deg, var(--sd-light-primary-surface-hover) 0%, var(--sd-light-primary-surface-hover-strong) 100%);\n    box-shadow: 0 4px 12px rgba(42, 70, 171, 0.12);\n}\n\n.inspection-view .inspection-shell__review-toggle-icon {\n    color: var(--sd-primary);\n    font-size: 13px !important;\n}\n\n/* --- Review Mode Grid Switch --- */\n\n.inspection-view .inspection-shell__body--review {\n    grid-template-columns: minmax(0, 1fr) minmax(340px, 400px);\n}\n\n/* --- Docked Findings Panel --- */\n\n.inspection-view .inspection-findings-panel {\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n    border-radius: 14px;\n    background:\n        linear-gradient(\n            180deg,\n            var(--sd-dark-panel-gradient-start) 0%,\n            var(--sd-dark-panel-gradient-end) 100%\n        );\n    border: 1px solid var(--sd-dark-panel-border);\n    box-shadow: 0 16px 36px rgba(9, 15, 27, 0.32);\n    color: var(--sd-dark-panel-text);\n    overflow: hidden;\n}\n\n.inspection-view .inspection-findings-panel__header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 12px;\n    padding: 16px 18px 12px;\n    border-bottom: 1px solid var(--sd-dark-panel-border-subtle);\n}\n\n.inspection-view .inspection-findings-panel__title {\n    margin: 4px 0 0;\n    font-family: 'Omnes Medium', 'Inter', sans-serif;\n    font-size: 18px;\n    font-weight: 700;\n    line-height: 1.2;\n    color: var(--sd-dark-panel-text);\n}\n\n.inspection-view .inspection-findings-panel__subtitle {\n    margin: 6px 0 0;\n    font-size: 12px;\n    line-height: 1.5;\n    color: var(--sd-dark-panel-text-subtle);\n}\n\n.inspection-view .inspection-findings-panel__close {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 30px;\n    height: 30px;\n    border: 1px solid var(--sd-dark-panel-accent-border);\n    border-radius: 8px;\n    background: var(--sd-dark-panel-surface-raised);\n    cursor: pointer;\n    transition: background 0.15s ease;\n}\n\n.inspection-view .inspection-findings-panel__close:hover {\n    background: var(--sd-dark-panel-surface-hover);\n}\n\n.inspection-view .inspection-findings-panel__list {\n    flex: 1;\n    min-height: 0;\n    overflow-y: auto;\n    padding: 14px 18px;\n}\n\n.inspection-view .inspection-findings-panel__content {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.inspection-view .inspection-findings-panel__detail,\n.inspection-view .inspection-findings-panel__queue {\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n    padding: 14px;\n    border-radius: 14px;\n    background: var(--sd-dark-panel-surface);\n    border: 1px solid var(--sd-dark-panel-border-subtle);\n}\n\n.inspection-view .inspection-findings-panel__detail-header,\n.inspection-view .inspection-findings-panel__queue-header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 12px;\n}\n\n.inspection-view .inspection-findings-panel__detail-copy {\n    min-width: 0;\n}\n\n.inspection-view .inspection-findings-panel__detail-title-row {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.inspection-view .inspection-findings-panel__detail-title {\n    margin: 0;\n    font-size: 16px;\n    line-height: 1.3;\n    color: var(--sd-dark-panel-text);\n}\n\n.inspection-view .inspection-findings-panel__severity-dot {\n    flex: 0 0 auto;\n    width: 10px;\n    height: 10px;\n    border-radius: 999px;\n    box-shadow: 0 0 0 3px var(--sd-dark-panel-surface);\n}\n\n.inspection-view .inspection-findings-panel__detail-tags {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin-top: 10px;\n}\n\n.inspection-view .inspection-findings-panel__detail-tag {\n    display: inline-flex;\n    align-items: center;\n    padding: 4px 8px;\n    border-radius: 999px;\n    background: var(--sd-dark-panel-surface-raised);\n    border: 1px solid var(--sd-dark-panel-accent-border);\n    font-size: 11px;\n    font-weight: 600;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: var(--sd-dark-panel-text-secondary);\n}\n\n.inspection-view .inspection-findings-panel__detail-tag--ai {\n    color: var(--sd-dark-panel-accent);\n    border-color: var(--sd-dark-panel-accent-border-medium);\n}\n\n.inspection-view .inspection-findings-panel__detail-tag--manual {\n    color: var(--sd-dark-text-secondary);\n}\n\n.inspection-view .inspection-findings-panel__detail-context {\n    margin: 10px 0 0;\n    font-size: 12px;\n    line-height: 1.5;\n    color: var(--sd-dark-panel-text-subtle);\n}\n\n.inspection-view .inspection-findings-panel__focus-button {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 8px 12px;\n    border: 1px solid var(--sd-dark-panel-accent-border-soft);\n    border-radius: 10px;\n    background: var(--sd-dark-panel-selected-surface);\n    color: var(--sd-dark-panel-text);\n    font-size: 12px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.inspection-view .inspection-findings-panel__focus-button:hover {\n    background: var(--sd-dark-panel-selected-surface-hover);\n    border-color: var(--sd-dark-panel-accent-border-hover);\n}\n\n.inspection-view .inspection-findings-panel__focus-button-icon {\n    color: var(--sd-dark-panel-accent) !important;\n}\n\n.inspection-view .inspection-findings-panel__preview {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n    min-height: 170px;\n    border-radius: 12px;\n    background: var(--sd-dark-panel-preview-bg);\n    border: 1px solid var(--sd-dark-panel-border-subtle);\n}\n\n.inspection-view .inspection-findings-panel__preview-image {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.inspection-view .inspection-findings-panel__preview--empty {\n    flex-direction: column;\n    gap: 10px;\n    color: var(--sd-dark-panel-text-muted);\n    font-size: 13px;\n}\n\n.inspection-view .inspection-findings-panel__metrics {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 10px;\n}\n\n.inspection-view .inspection-findings-panel__metric {\n    padding: 10px 12px;\n    border-radius: 10px;\n    background: var(--sd-dark-panel-surface);\n    border: 1px solid var(--sd-dark-panel-border-faint);\n}\n\n.inspection-view .inspection-findings-panel__metric-label {\n    display: block;\n    margin-bottom: 6px;\n    font-size: 10px;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: var(--sd-dark-panel-text-muted);\n}\n\n.inspection-view .inspection-findings-panel__queue-title {\n    font-size: 12px;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: var(--sd-dark-text-secondary);\n}\n\n.inspection-view .inspection-findings-panel__queue-count {\n    font-size: 12px;\n    font-weight: 600;\n    color: var(--sd-dark-panel-accent);\n}\n\n.inspection-view .inspection-findings-panel__items {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.inspection-view .inspection-findings-panel__queue-empty {\n    padding: 14px;\n    border: 1px dashed var(--sd-dark-panel-border-dashed);\n    border-radius: 12px;\n    color: var(--sd-dark-panel-text-muted);\n    font-size: 13px;\n    line-height: 1.5;\n    text-align: center;\n}\n\n.inspection-view .inspection-findings-panel__item {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    width: 100%;\n    padding: 10px 12px;\n    border: 1px solid var(--sd-dark-panel-border-faint);\n    border-radius: 12px;\n    background: var(--sd-dark-panel-surface-subtle);\n    color: inherit;\n    text-align: left;\n    cursor: pointer;\n    transition: background 0.15s ease, border-color 0.15s ease,\n        transform 0.15s ease;\n}\n\n.inspection-view .inspection-findings-panel__item:hover {\n    background: var(--sd-dark-panel-surface-muted);\n    border-color: var(--sd-dark-panel-accent-border-soft);\n}\n\n.inspection-view .inspection-findings-panel__item--selected {\n    background: var(--sd-dark-panel-selected-surface);\n    border-color: var(--sd-dark-panel-accent-border-strong);\n    transform: translateX(2px);\n}\n\n.inspection-view .inspection-findings-panel__item-copy {\n    flex: 1;\n    min-width: 0;\n}\n\n.inspection-view .inspection-findings-panel__item-label {\n    display: block;\n    color: var(--sd-dark-panel-text);\n    font-size: 13px;\n    line-height: 1.4;\n}\n\n.inspection-view .inspection-findings-panel__item-meta {\n    display: block;\n    margin-top: 2px;\n    font-size: 12px;\n    color: var(--sd-dark-panel-text-subtle);\n}\n\n.inspection-view .inspection-findings-panel__item-context {\n    display: block;\n    margin-top: 4px;\n    font-size: 11px;\n    line-height: 1.45;\n    color: var(--sd-dark-text-secondary);\n}\n\n.inspection-view .inspection-findings-panel__empty {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    padding: 48px 24px;\n    text-align: center;\n}\n\n.inspection-view .inspection-findings-panel__empty-title {\n    margin: 0;\n    font-size: 15px;\n    font-weight: 600;\n    color: var(--sd-dark-panel-text-secondary);\n}\n\n.inspection-view .inspection-findings-panel__empty-hint {\n    margin: 0;\n    font-size: 13px;\n    line-height: 1.5;\n    color: var(--sd-dark-panel-text-muted);\n    max-width: 240px;\n}\n\n.inspection-view .inspection-findings-panel__footer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 10px 18px;\n    border-top: 1px solid var(--sd-dark-panel-border-faint);\n}\n\n.inspection-view .inspection-findings-panel__footer-label {\n    font-size: 11px;\n    font-weight: 600;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: var(--sd-dark-text-secondary);\n}\n\n@media only screen and (max-width: 1600px) {\n    .inspection-view .inspection-shell__body--context {\n        grid-template-columns: minmax(0, 1fr) 240px;\n    }\n\n    .inspection-view .inspection-shell__body--review {\n        grid-template-columns: minmax(0, 1fr) minmax(300px, 360px);\n    }\n}\n\n@media only screen and (max-width: 1320px) {\n    .inspection-view .inspection-shell__body--context {\n        grid-template-columns: 1fr;\n    }\n\n    .inspection-view .inspection-context-rail {\n        display: none;\n    }\n\n    .inspection-view .inspection-shell__body--review {\n        grid-template-columns: 1fr;\n    }\n\n    .inspection-view .inspection-findings-panel {\n        max-height: 320px;\n    }\n\n    .inspection-view .inspection-findings-panel__metrics {\n        grid-template-columns: 1fr;\n    }\n}\n\n@media only screen and (max-width: 1000px) {\n    .inspection-view .inspection-shell__header {\n        padding: 10px 14px;\n    }\n\n    .inspection-view .inspection-shell__title {\n        font-size: 18px;\n    }\n\n    .inspection-view .inspection-gallery__toolbar {\n        flex-wrap: wrap;\n    }\n}\n\n/* One dataset-scoped Context rail serves all visible viewer panes. */\n.inspection-shared-rail-host {\n    display: contents;\n}\n\n.inspection-shared-rail-host--active {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 12;\n    display: flex;\n    min-height: 0;\n    padding: 0;\n    border-left: 1px solid var(--sd-border);\n    box-shadow: -12px 0 28px rgba(9, 15, 27, 0.18);\n    width: var(--smartview-active-rail-width);\n}\n\n.inspection-shared-rail-host--context {\n    --smartview-active-rail-width: var(--smartview-context-rail-width);\n}\n\n.inspection-shared-rail-host--review {\n    --smartview-active-rail-width: var(--smartview-review-rail-width);\n}\n\n.inspection-shared-rail-host--active .inspection-context-rail,\n.inspection-shared-rail-host--active .inspection-findings-panel {\n    display: flex;\n    width: 100%;\n    height: 100%;\n    max-height: none;\n    border: 0;\n    border-radius: 0;\n    box-shadow: none;\n}\n\n/* ==========================================================================\n   PLATFORM SHELL — Figma Design System Parity\n   Source: Figma \"Smartdata Design System\" node 895:14743, 895:14192\n   Overrides existing app-bar rules at lines 403, 565, 840 via higher\n   specificity (element + two classes beats element + one class).\n   ========================================================================== */\n\n/* --- Blue top nav bar (72px, solid brand primary) --- */\n\nheader.v-app-bar.nd-shell-bar {\n    --sd-border: var(--sd-light-border);\n    --sd-text: var(--sd-shell-text);\n    --sd-text-secondary: var(--sd-shell-text-secondary);\n    background-color: var(--sd-primary) !important;\n    backdrop-filter: none !important;\n    border: none !important;\n    box-shadow: none !important;\n}\n\nheader.v-app-bar.nd-shell-bar .v-toolbar__content {\n    height: 72px !important;\n    align-items: center;\n}\n\n/* Dark mode: bar stays blue */\n.v-theme--dark header.v-app-bar.nd-shell-bar,\n.theme--dark header.v-app-bar.nd-shell-bar,\nhtml.theme--dark header.v-app-bar.nd-shell-bar,\nbody.theme--dark header.v-app-bar.nd-shell-bar {\n    background-color: var(--sd-primary) !important;\n    box-shadow: none !important;\n}\n\n/* --- White contextual sub-bar (extension slot, 56px) --- */\n\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension {\n    background: var(--sd-light-surface);\n    box-shadow: 0 2px 4px rgba(63, 75, 97, 0.12);\n    padding: 0 16px !important;\n}\n\n.v-theme--dark header.v-app-bar.nd-shell-bar .v-toolbar__extension,\n.theme--dark header.v-app-bar.nd-shell-bar .v-toolbar__extension,\nhtml.theme--dark header.v-app-bar.nd-shell-bar .v-toolbar__extension,\nbody.theme--dark header.v-app-bar.nd-shell-bar .v-toolbar__extension {\n    background: var(--sd-surface) !important;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.28);\n}\n\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-subbar {\n    display: flex;\n    align-items: stretch;\n    width: 100%;\n    min-height: 56px;\n}\n\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-subbar__segment {\n    position: relative;\n    display: flex;\n    align-items: stretch;\n    flex: 0 1 auto;\n    min-width: 0;\n    height: 56px;\n}\n\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-selector {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-start;\n    gap: 4px;\n    width: 100%;\n    min-width: 0;\n    height: 56px;\n    padding: 8px 32px 8px 12px;\n    background: transparent;\n    border: none;\n    border-radius: 0;\n    appearance: none;\n    -webkit-appearance: none;\n    color: var(--sd-text, var(--sd-shell-text));\n    cursor: pointer;\n    text-align: left;\n    opacity: 1 !important;\n}\n\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-selector__label {\n    color: var(--sd-text-secondary, var(--sd-shell-text-secondary));\n    font-size: 11px;\n    font-weight: 600;\n    letter-spacing: 0.06em;\n    line-height: 1;\n    opacity: 1 !important;\n    text-transform: uppercase;\n}\n\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-selector__value {\n    display: block;\n    width: 100%;\n    min-width: 0;\n    overflow: hidden;\n    color: var(--sd-text, var(--sd-shell-text));\n    -webkit-text-fill-color: var(--sd-text, var(--sd-shell-text));\n    font-family: 'Omnes Medium', 'Omnes', Roboto, sans-serif;\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 1.2;\n    opacity: 1 !important;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-selector__icon {\n    position: absolute;\n    right: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: var(--sd-text-secondary, var(--sd-shell-text-secondary));\n    opacity: 1 !important;\n}\n\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-selector__spinner {\n    position: absolute;\n    right: 28px;\n    top: 50%;\n    transform: translateY(-50%);\n}\n\n.v-theme--dark header.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-selector,\n.theme--dark header.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-selector,\nhtml.theme--dark header.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-selector,\nbody.theme--dark header.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-selector {\n    color: var(--sd-dark-text) !important;\n}\n\n.v-theme--dark header.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-selector__label,\n.theme--dark header.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-selector__label,\nhtml.theme--dark header.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-selector__label,\nbody.theme--dark header.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-selector__label {\n    color: var(--sd-dark-text) !important;\n    -webkit-text-fill-color: var(--sd-dark-text) !important;\n}\n\n.v-theme--dark header.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-selector__value,\n.theme--dark header.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-selector__value,\nhtml.theme--dark header.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-selector__value,\nbody.theme--dark header.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-selector__value {\n    color: var(--sd-dark-text) !important;\n    -webkit-text-fill-color: var(--sd-dark-text) !important;\n}\n\n.v-theme--dark header.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-selector__icon,\n.theme--dark header.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-selector__icon,\nhtml.theme--dark header.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-selector__icon,\nbody.theme--dark header.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-selector__icon {\n    color: var(--sd-dark-text-secondary) !important;\n    opacity: 1 !important;\n}\n\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-subbar__input {\n    display: flex;\n    align-items: stretch;\n    width: 100%;\n    min-width: 0;\n    height: 56px;\n}\n\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-subbar__input--active .v-input,\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-subbar__input--active .nd-shell-subbar__selector-control {\n    width: 100%;\n    max-width: 100% !important;\n}\n\n/* Sub-bar text colors: inherit from theme, not from blue bar */\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .v-field__input,\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .v-field__input input,\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .v-field__input input::placeholder,\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .v-select__selection,\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .v-select__selection-text,\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .v-field__field input,\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .v-field label,\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .v-field-label,\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .v-autocomplete input {\n    color: var(--sd-text, var(--sd-light-text)) !important;\n    -webkit-text-fill-color: var(--sd-text, var(--sd-light-text)) !important;\n    opacity: 1 !important;\n}\n\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .v-input {\n    margin: 0 !important;\n}\n\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .v-field,\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .v-field--variant-filled,\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .v-field--variant-outlined,\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .v-input__control,\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .v-text-field .v-field {\n    background: transparent !important;\n    border: none !important;\n    border-radius: 0 !important;\n    box-shadow: none !important;\n}\n\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .v-field__overlay,\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .v-field__underlay,\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .v-field::before,\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .v-field::after,\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .v-field__outline {\n    display: none !important;\n    opacity: 0 !important;\n}\n\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .v-field__field,\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .v-field__input {\n    min-height: 56px !important;\n}\n\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .v-field__input,\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .v-select__selection-text,\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .v-select__selection {\n    font-family: 'Omnes Medium', 'Omnes', Roboto, sans-serif !important;\n    font-size: 18px !important;\n    font-weight: 600 !important;\n    line-height: 1.2 !important;\n    color: var(--sd-text, var(--sd-shell-text)) !important;\n    -webkit-text-fill-color: var(--sd-text, var(--sd-shell-text)) !important;\n}\n\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .v-label {\n    color: var(--sd-text-secondary, var(--sd-light-text-secondary)) !important;\n    font-size: 11px !important;\n    letter-spacing: 0.06em !important;\n    opacity: 1 !important;\n    text-transform: uppercase;\n}\n\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .v-field-label,\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .v-label {\n    color: var(--sd-text-secondary, var(--sd-light-text-secondary)) !important;\n    opacity: 1 !important;\n}\n\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .v-input--disabled,\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .v-input--disabled .v-field__input,\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .v-input--disabled .v-select__selection,\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .v-input--disabled .v-select__selection-text,\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .v-input--disabled .v-label,\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .v-input--disabled .v-field-label {\n    color: var(--sd-text-secondary, var(--sd-light-text-secondary)) !important;\n    -webkit-text-fill-color: var(--sd-text-secondary, var(--sd-light-text-secondary)) !important;\n    opacity: 1 !important;\n}\n\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .v-field__append-inner .v-icon,\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .v-field__clearable .v-icon,\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .v-field__prepend-inner .v-icon,\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .v-select__menu-icon {\n    color: var(--sd-text-secondary, var(--sd-light-text-secondary)) !important;\n    opacity: 0.9 !important;\n}\n\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .top-page-site-select,\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .top-page-view-select,\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .nd-shell-subbar__selector-control {\n    align-self: stretch;\n}\n\nheader.v-app-bar.nd-shell-bar .v-toolbar__extension .v-divider--vertical {\n    border-color: var(--sd-border, var(--sd-light-border)) !important;\n}\n\n.nd-shell-dropdown-menu,\n.v-overlay__content.nd-shell-dropdown-menu,\n.v-menu__content.nd-shell-dropdown-menu {\n    background: var(--sd-light-surface) !important;\n    border: 1px solid var(--sd-border, var(--sd-light-border));\n    border-radius: 14px !important;\n    box-shadow: 0 18px 40px rgba(17, 27, 50, 0.18) !important;\n    color: var(--sd-text, var(--sd-shell-text)) !important;\n    overflow: hidden;\n}\n\n.v-theme--dark .nd-shell-dropdown-menu,\n.theme--dark .nd-shell-dropdown-menu,\nhtml.theme--dark .nd-shell-dropdown-menu,\nbody.theme--dark .nd-shell-dropdown-menu,\n.v-theme--dark .v-overlay__content.nd-shell-dropdown-menu,\n.theme--dark .v-overlay__content.nd-shell-dropdown-menu,\nhtml.theme--dark .v-overlay__content.nd-shell-dropdown-menu,\nbody.theme--dark .v-overlay__content.nd-shell-dropdown-menu,\n.v-theme--dark .v-menu__content.nd-shell-dropdown-menu,\n.theme--dark .v-menu__content.nd-shell-dropdown-menu,\nhtml.theme--dark .v-menu__content.nd-shell-dropdown-menu,\nbody.theme--dark .v-menu__content.nd-shell-dropdown-menu {\n    background: var(--sd-surface) !important;\n    border-color: var(--sd-border, var(--sd-light-border));\n    box-shadow: 0 18px 40px rgba(0, 0, 0, 0.32) !important;\n}\n\n.nd-shell-dropdown-menu .v-list,\n.v-overlay__content.nd-shell-dropdown-menu .v-list,\n.v-menu__content.nd-shell-dropdown-menu .v-list {\n    background: var(--sd-light-surface) !important;\n    color: var(--sd-text, var(--sd-shell-text)) !important;\n    padding: 8px 0;\n}\n\n.v-theme--dark .nd-shell-dropdown-menu .v-list,\n.theme--dark .nd-shell-dropdown-menu .v-list,\nhtml.theme--dark .nd-shell-dropdown-menu .v-list,\nbody.theme--dark .nd-shell-dropdown-menu .v-list,\n.v-theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list,\n.theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list,\nhtml.theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list,\nbody.theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list,\n.v-theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list,\n.theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list,\nhtml.theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list,\nbody.theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list {\n    background: var(--sd-surface) !important;\n}\n\n.nd-shell-dropdown-menu .v-list-item,\n.nd-shell-dropdown-menu .v-list-item-title,\n.nd-shell-dropdown-menu .v-list-item-subtitle,\n.nd-shell-dropdown-menu .v-list-item__prepend .v-icon,\n.nd-shell-dropdown-menu .v-list-item__append .v-icon,\n.v-overlay__content.nd-shell-dropdown-menu .v-list-item,\n.v-overlay__content.nd-shell-dropdown-menu .v-list-item-title,\n.v-overlay__content.nd-shell-dropdown-menu .v-list-item-subtitle,\n.v-overlay__content.nd-shell-dropdown-menu .v-list-item__prepend .v-icon,\n.v-overlay__content.nd-shell-dropdown-menu .v-list-item__append .v-icon,\n.v-menu__content.nd-shell-dropdown-menu .v-list-item,\n.v-menu__content.nd-shell-dropdown-menu .v-list-item-title,\n.v-menu__content.nd-shell-dropdown-menu .v-list-item-subtitle,\n.v-menu__content.nd-shell-dropdown-menu .v-list-item__prepend .v-icon,\n.v-menu__content.nd-shell-dropdown-menu .v-list-item__append .v-icon {\n    color: var(--sd-text, var(--sd-shell-text)) !important;\n    opacity: 1 !important;\n}\n\n.nd-shell-dropdown-menu .v-list-item,\n.v-overlay__content.nd-shell-dropdown-menu .v-list-item,\n.v-menu__content.nd-shell-dropdown-menu .v-list-item {\n    min-height: 48px;\n}\n\n.v-theme--dark .nd-shell-dropdown-menu .v-list-item,\n.theme--dark .nd-shell-dropdown-menu .v-list-item,\nhtml.theme--dark .nd-shell-dropdown-menu .v-list-item,\nbody.theme--dark .nd-shell-dropdown-menu .v-list-item,\n.v-theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list-item,\n.theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list-item,\nhtml.theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list-item,\nbody.theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list-item,\n.v-theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list-item,\n.theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list-item,\nhtml.theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list-item,\nbody.theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list-item {\n    color: var(--sd-text) !important;\n}\n\n.nd-shell-dropdown-menu .v-list-item-subtitle,\n.v-overlay__content.nd-shell-dropdown-menu .v-list-item-subtitle,\n.v-menu__content.nd-shell-dropdown-menu .v-list-item-subtitle {\n    color: var(--sd-text-secondary, var(--sd-shell-text-secondary)) !important;\n}\n\n.nd-shell-dropdown-menu .v-list-item--disabled,\n.v-overlay__content.nd-shell-dropdown-menu .v-list-item--disabled,\n.v-menu__content.nd-shell-dropdown-menu .v-list-item--disabled {\n    opacity: 0.42 !important;\n}\n\n.nd-shell-dropdown-menu .v-list-item--active,\n.nd-shell-dropdown-menu .v-list-item:hover,\n.v-overlay__content.nd-shell-dropdown-menu .v-list-item--active,\n.v-overlay__content.nd-shell-dropdown-menu .v-list-item:hover,\n.v-menu__content.nd-shell-dropdown-menu .v-list-item--active,\n.v-menu__content.nd-shell-dropdown-menu .v-list-item:hover {\n    background: var(--sd-light-primary-surface) !important;\n}\n\n.v-theme--dark .nd-shell-dropdown-menu .v-list-item--active,\n.v-theme--dark .nd-shell-dropdown-menu .v-list-item:hover,\n.theme--dark .nd-shell-dropdown-menu .v-list-item--active,\n.theme--dark .nd-shell-dropdown-menu .v-list-item:hover,\nhtml.theme--dark .nd-shell-dropdown-menu .v-list-item--active,\nhtml.theme--dark .nd-shell-dropdown-menu .v-list-item:hover,\nbody.theme--dark .nd-shell-dropdown-menu .v-list-item--active,\nbody.theme--dark .nd-shell-dropdown-menu .v-list-item:hover,\n.v-theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list-item--active,\n.v-theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list-item:hover,\n.theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list-item--active,\n.theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list-item:hover,\nhtml.theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list-item--active,\nhtml.theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list-item:hover,\nbody.theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list-item--active,\nbody.theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list-item:hover,\n.v-theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list-item--active,\n.v-theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list-item:hover,\n.theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list-item--active,\n.theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list-item:hover,\nhtml.theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list-item--active,\nhtml.theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list-item:hover,\nbody.theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list-item--active,\nbody.theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list-item:hover {\n    background: var(--sd-surface-soft) !important;\n    color: var(--sd-text) !important;\n}\n\n.v-theme--dark .nd-shell-dropdown-menu .v-list-item--active .v-list-item-title,\n.v-theme--dark .nd-shell-dropdown-menu .v-list-item:hover .v-list-item-title,\n.theme--dark .nd-shell-dropdown-menu .v-list-item--active .v-list-item-title,\n.theme--dark .nd-shell-dropdown-menu .v-list-item:hover .v-list-item-title,\nhtml.theme--dark .nd-shell-dropdown-menu .v-list-item--active .v-list-item-title,\nhtml.theme--dark .nd-shell-dropdown-menu .v-list-item:hover .v-list-item-title,\nbody.theme--dark .nd-shell-dropdown-menu .v-list-item--active .v-list-item-title,\nbody.theme--dark .nd-shell-dropdown-menu .v-list-item:hover .v-list-item-title,\n.v-theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list-item--active .v-list-item-title,\n.v-theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list-item:hover .v-list-item-title,\n.theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list-item--active .v-list-item-title,\n.theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list-item:hover .v-list-item-title,\nhtml.theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list-item--active .v-list-item-title,\nhtml.theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list-item:hover .v-list-item-title,\nbody.theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list-item--active .v-list-item-title,\nbody.theme--dark .v-overlay__content.nd-shell-dropdown-menu .v-list-item:hover .v-list-item-title,\n.v-theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list-item--active .v-list-item-title,\n.v-theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list-item:hover .v-list-item-title,\n.theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list-item--active .v-list-item-title,\n.theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list-item:hover .v-list-item-title,\nhtml.theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list-item--active .v-list-item-title,\nhtml.theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list-item:hover .v-list-item-title,\nbody.theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list-item--active .v-list-item-title,\nbody.theme--dark .v-menu__content.nd-shell-dropdown-menu .v-list-item:hover .v-list-item-title {\n    color: var(--sd-text) !important;\n}\n\n.nd-shell-dropdown-menu .v-btn {\n    box-shadow: none !important;\n    transform: none !important;\n}\n\n.nd-shell-view-menu {\n    min-width: 300px;\n    contain: none !important;\n    isolation: isolate;\n}\n\n.nd-shell-view-list {\n    min-width: 300px;\n    position: relative;\n    z-index: 0;\n}\n\n.nd-shell-view-option {\n    position: relative;\n    isolation: isolate;\n    padding-left: 14px !important;\n    padding-right: 14px !important;\n}\n\n.nd-shell-view-option .v-list-item__overlay,\n.nd-shell-view-option .v-list-item__underlay {\n    display: none !important;\n    background: transparent !important;\n    opacity: 0 !important;\n}\n\n.nd-shell-view-option--selected {\n    background: var(--sd-light-primary-surface) !important;\n}\n\n.v-theme--dark .nd-shell-view-option--selected,\n.theme--dark .nd-shell-view-option--selected,\nhtml.theme--dark .nd-shell-view-option--selected,\nbody.theme--dark .nd-shell-view-option--selected {\n    background: var(--sd-surface-soft) !important;\n}\n\n.v-theme--dark .nd-shell-view-option--selected .nd-shell-view-option__title,\n.theme--dark .nd-shell-view-option--selected .nd-shell-view-option__title,\nhtml.theme--dark .nd-shell-view-option--selected .nd-shell-view-option__title,\nbody.theme--dark .nd-shell-view-option--selected .nd-shell-view-option__title,\n.v-theme--dark .nd-shell-view-option--selected .nd-shell-view-option__icon,\n.theme--dark .nd-shell-view-option--selected .nd-shell-view-option__icon,\nhtml.theme--dark .nd-shell-view-option--selected .nd-shell-view-option__icon,\nbody.theme--dark .nd-shell-view-option--selected .nd-shell-view-option__icon,\n.v-theme--dark .nd-shell-view-option--selected .v-list-item-title,\n.theme--dark .nd-shell-view-option--selected .v-list-item-title,\nhtml.theme--dark .nd-shell-view-option--selected .v-list-item-title,\nbody.theme--dark .nd-shell-view-option--selected .v-list-item-title,\n.v-theme--dark .v-overlay__content.nd-shell-dropdown-menu .nd-shell-view-option--selected .v-list-item-title,\n.theme--dark .v-overlay__content.nd-shell-dropdown-menu .nd-shell-view-option--selected .v-list-item-title,\nhtml.theme--dark .v-overlay__content.nd-shell-dropdown-menu .nd-shell-view-option--selected .v-list-item-title,\nbody.theme--dark .v-overlay__content.nd-shell-dropdown-menu .nd-shell-view-option--selected .v-list-item-title {\n    color: var(--sd-light-text-strong) !important;\n    -webkit-text-fill-color: var(--sd-light-text-strong) !important;\n}\n\n.nd-shell-view-option--empty {\n    cursor: default;\n}\n\n.nd-shell-view-option__row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    width: 100%;\n    min-width: 0;\n    position: relative;\n    z-index: 1;\n}\n\n.nd-shell-view-option__main {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    min-width: 0;\n    flex: 1 1 auto;\n    position: relative;\n    z-index: 1;\n}\n\n.nd-shell-view-option__icon {\n    flex: 0 0 auto;\n    color: var(--sd-shell-icon-muted) !important;\n    backface-visibility: hidden;\n    opacity: 1 !important;\n}\n\n.nd-shell-view-option__title {\n    color: var(--sd-text, var(--sd-shell-text));\n    -webkit-text-fill-color: var(--sd-text, var(--sd-shell-text)) !important;\n    backface-visibility: hidden;\n    display: block;\n    font-family: 'Omnes Medium', 'Omnes', Roboto, sans-serif;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 1.2;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    text-shadow: 0 0 0 currentColor;\n    opacity: 1 !important;\n}\n\n.nd-shell-view-option__actions {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    flex: 0 0 auto;\n}\n\n.nd-shell-view-option__action {\n    min-width: 40px !important;\n}\n\n/* --- Desktop navigation links --- */\n\n.nd-nav-links {\n    display: flex;\n    align-items: center;\n    gap: 28px;\n    margin-left: 24px;\n}\n\n.nd-nav-link {\n    font-family: 'Omnes Medium', 'Omnes', Roboto, sans-serif;\n    font-size: 18px;\n    color: var(--sd-shell-nav-text);\n    text-decoration: none;\n    white-space: nowrap;\n    transition: color 0.15s ease;\n    line-height: 72px;\n}\n\n.nd-nav-link:hover {\n    color: var(--sd-shell-nav-text-active);\n}\n\n.nd-nav-link--active {\n    color: var(--sd-shell-nav-text-active);\n    font-family: 'Omnes Medium', 'Omnes', Roboto, sans-serif;\n}\n\n/* --- Shell right-side controls --- */\n\n.nd-shell-avatar {\n    border: 2px solid var(--sd-shell-avatar-border);\n}\n\n.nd-shell-more-btn.v-btn {\n    color: var(--sd-shell-control-text) !important;\n}\n\n.nd-shell-more-btn.v-btn:hover {\n    color: var(--sd-shell-nav-text-active) !important;\n}\n\n.nd-shell-help-btn.v-btn {\n    color: var(--sd-shell-control-text) !important;\n}\n\n.nd-shell-help-btn.v-btn:hover {\n    color: var(--sd-shell-nav-text-active) !important;\n}\n\n/* --- Responsive rules --- */\n\n/* Mobile: hide nav links, keep hamburger */\n@media (max-width: 959.98px) {\n    .nd-nav-links {\n        display: none !important;\n    }\n\n    .nd-shell-more-menu {\n        display: none !important;\n    }\n}\n\n/* Desktop: hide hamburger, show nav links */\n@media (min-width: 960px) {\n    header.v-app-bar.nd-shell-bar .v-app-bar-nav-icon {\n        display: none !important;\n    }\n}\n\n/* --- White logo on blue bar --- */\n\n.nd-shell-logo {\n    max-height: 30px;\n    vertical-align: middle;\n    display: block;\n}\n\n/* ND-1324: common controls use the existing selector row. */\n.nd-annotation-toolbar {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    flex: 1 1 690px;\n    min-width: 210px;\n    max-width: 100%;\n}\n.nd-annotation-toolbar:empty { display: none; }\n.nd-shell-subbar:has(.nd-annotation-toolbar:not(:empty)) > .v-spacer { flex: 0 0 auto !important; }\n.annotation-toolbar-host {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 6px;\n    min-width: 0;\n    color: var(--sd-text);\n    height: 56px;\n}\n.annotation-toolbar-host__owner { display: flex; align-items: center; gap: 4px; white-space: nowrap; font-size: 12px; }\n.annotation-toolbar-host__tools { min-width: 0; }\n.annotation-toolbar-host .cesium-viewer-menu-toolbar { position: static; gap: 0; }\n.annotation-toolbar-host .viewer-primary-tools,\n.annotation-toolbar-host__compact .viewer-primary-tools {\n    display: flex;\n    align-items: center;\n    gap: 2px;\n    padding: 0;\n    min-height: 40px;\n    border: 0;\n    box-shadow: none;\n    background: var(--sd-surface);\n    backdrop-filter: none;\n}\n.annotation-toolbar-host .viewer-tool-button,\n.annotation-toolbar-host__compact .viewer-tool-button { min-width: 0; padding: 0 8px; height: 38px; color: var(--sd-text); background: transparent; text-transform: none; letter-spacing: 0; border: 0; }\n.annotation-toolbar-host .viewer-tool-button--active,\n.annotation-toolbar-host__compact .viewer-tool-button--active { color: var(--sd-light-text-inverse); background: var(--sd-primary); }\n.annotation-toolbar-host .viewer-mode-indicator,\n.annotation-toolbar-status { position: absolute; width: 1px; height: 1px; overflow: hidden; clip-path: inset(50%); white-space: nowrap; }\n.annotation-toolbar-host__compact { padding: 8px; max-width: min(440px, calc(100vw - 24px)); background: var(--sd-surface); color: var(--sd-text); }\n.annotation-toolbar-host__compact .viewer-primary-tools { flex-wrap: wrap; }\n/* Menus and dialogs can render outside the toolbar through a Vue teleport. */\n:is(.annotation-toolbar-host, .annotation-toolbar-host__compact,\n    .viewer-tool-menu, .viewer-more-menu, .top-menu-submenu,\n    .annotation-pane-menu, .viewer-settings-menu, .annotation-form-root,\n    .inspection-annotation-dialog, .entity-control-buttons) {\n    font-family: 'Omnes Regular', Omnes, sans-serif;\n}\n:is(.annotation-toolbar-host, .annotation-toolbar-host__compact,\n    .viewer-tool-menu, .viewer-more-menu, .top-menu-submenu,\n    .annotation-pane-menu, .viewer-settings-menu, .annotation-form-root,\n    .inspection-annotation-dialog, .entity-control-buttons)\n:is(.v-btn__content, .v-list-item-title, .v-list-item-subtitle,\n    .v-list-subheader, .v-label, .v-field__input, input, textarea) {\n    font-family: inherit !important;\n}\n.annotation-toolbar-host__compact .cesium-viewer-menu-toolbar { position: static; }\n.annotation-toolbar-host__compact .viewer-mode-indicator { display: none; }\n\n/* The source-photo panel reserves space instead of covering the canvas. */\n.inspection-view .inspection-canvas-stage { display: flex; flex-direction: column; }\n.inspection-map-stage { position: relative; display: flex; flex-direction: column; flex: 1 1 auto; min-height: 90px; overflow: hidden; }\n.inspection-map-canvas { position: relative; display: flex; flex-direction: column; flex: 1 1 auto; min-height: 90px; min-width: 0; }\n.inspection-map-canvas__map { flex: 1 1 auto; min-height: 0; height: 100%; width: 100%; }\n.inspection-map-canvas .inspection-annotation-launcher { display: none; }\n.inspection-view .inspection-gallery-root {\n    position: relative;\n    order: 2;\n    flex: 0 0 auto;\n    left: auto;\n    right: auto;\n    bottom: auto;\n    padding: 0 6px;\n    pointer-events: auto;\n    z-index: auto;\n}\n.inspection-view .inspection-source-photos {\n    position: relative;\n    left: auto;\n    right: auto;\n    bottom: auto;\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n    margin: 0 0 4px;\n    overflow: visible;\n    box-shadow: none;\n}\n.inspection-view .inspection-source-photos__header {\n    flex: 0 0 auto;\n    flex-direction: row;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 6px 10px;\n    padding: 6px 8px;\n    border-right: 0;\n}\n.inspection-view .inspection-source-photos__title-group { flex-direction: row; align-items: baseline; flex-wrap: wrap; }\n.inspection-source-photos__toggle { margin-left: auto; padding: 4px 6px; border: 1px solid var(--sd-border); border-radius: 5px; color: var(--sd-text); background: var(--sd-surface-soft); font-size: 12px; }\n.inspection-view .inspection-source-photos__legend { flex: 0 0 auto; padding: 4px 8px; }\n.inspection-view .inspection-source-photos__status { max-height: 64px; overflow-y: auto; padding: 4px 8px; font-size: 12px; overflow-wrap: anywhere; border-top: 1px solid var(--sd-border); }\n.inspection-view .inspection-source-photos__list {\n    display: grid;\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n    gap: 6px;\n    padding: 6px;\n    overflow: visible;\n}\n.inspection-view .inspection-source-photos__candidate { width: 100%; flex: none; }\n.inspection-view .inspection-source-photos__filename { white-space: normal; overflow-wrap: anywhere; text-overflow: clip; font-size: 11px; }\n.inspection-view .inspection-gallery__toggle,\n.inspection-view .inspection-gallery { position: relative; left: auto; right: auto; bottom: auto; width: 100%; }\n.inspection-view .inspection-gallery__toggle { padding: 8px; }\n.inspection-workspace-status,\n.cesium-workspace-status {\n    order: 1;\n    flex: 0 0 auto;\n    display: flex;\n    gap: 8px;\n    max-height: 76px;\n    overflow-y: auto;\n    padding: 6px 10px;\n    background: var(--sd-surface);\n    color: var(--sd-text);\n    border-top: 1px solid var(--sd-border);\n    font-size: 12px;\n    overflow-wrap: anywhere;\n}\n.inspection-workspace-status span,\n.cesium-workspace-status span { flex: 1; }\n.inspection-workspace-status button,\n.cesium-workspace-status button { align-self: flex-start; }\n.inspection-source-photos__toggle:focus-visible,\n.inspection-source-photos__candidate:focus-visible {\n    outline: 2px solid var(--sd-primary);\n    outline-offset: 2px;\n}\n@media (max-width: 1100px) {\n    .inspection-view .inspection-source-photos__list { grid-template-columns: repeat(3, minmax(0, 1fr)); }\n    .annotation-toolbar-host__owner > span { position: absolute; width: 1px; height: 1px; overflow: hidden; clip-path: inset(50%); }\n    .nd-annotation-toolbar { min-width: 168px; }\n}\n@media (max-width: 760px) {\n    .inspection-view .inspection-source-photos__list { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n    .inspection-view .inspection-source-photos__thumbnail { max-height: 48px; }\n    .inspection-view .inspection-source-photos__header { gap: 4px; }\n}\n\n/* Keep Settings rows readable and within the browser viewport. */\n.viewer-settings-list {\n    width: 300px;\n    max-width: calc(100vw - 24px);\n    max-height: min(480px, calc(100vh - 140px));\n    overflow-y: auto;\n    color: var(--sd-text);\n    background: var(--sd-surface);\n}\n.viewer-settings-list .v-list-item { min-height: 44px; padding: 0 4px; }\n\n/* ND-1331: one photo gallery serves both viewer panes. */\n.smartview-root { position: relative; }\n.smartview-root--photo-workspace .column-item { position: relative; }\n.photo-workspace-pane-label { position: absolute; top: 8px; left: 10px; z-index: 500; background: #161e29df; color: #fff; border-radius: 12px; padding: 4px 10px; font-size: 12px; pointer-events: none; }\n.inspection-view--photo-workspace .inspection-shell__body { padding: 0; }\n#nd-photo-workspace-toolbar { display: flex; align-items: center; flex: 0 0 auto; }\n#nd-photo-workspace-toolbar:empty { display: none; }\n\n.smartview-root--photo-workspace .column-item:has(.inspection-view--photo-workspace) .photo-workspace-pane-label { left: 64px; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
